var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3298 -2734 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3,.cls-5{fill:#fff}.cls-5{fill-rule:evenodd}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2217",
    "data-name": "Rectangle 2217",
    transform: "translate(1301 814)",
    stroke: "#d9d9d9",
    fill: "#fff",
    d: "M0 0h65v65H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5056",
    "data-name": "Group 5056",
    transform: "translate(1997 -3654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2098",
    "data-name": "Rectangle 2098",
    transform: "translate(1301 920)",
    fill: "#8bc4e1",
    d: "M0 0h65v65H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33335",
    "data-name": "Path 33335",
    className: "cls-3",
    d: "M24.933 16H17v7.933h7.933zM23.8 22.8h-5.667v-5.667H23.8z",
    transform: "translate(1310.067 927.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33336",
    "data-name": "Path 33336",
    className: "cls-3",
    d: "M44.633 16h-9.066a.567.567 0 0 0 0 1.133h9.067a.567.567 0 0 0 0-1.133z",
    transform: "translate(1302.267 927.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33337",
    "data-name": "Path 33337",
    className: "cls-3",
    d: "M44.633 22h-9.066a.567.567 0 0 0 0 1.133h9.067a.567.567 0 0 0 0-1.133z",
    transform: "translate(1302.267 924.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33338",
    "data-name": "Path 33338",
    className: "cls-3",
    d: "M44.633 28h-9.066a.567.567 0 0 0 0 1.133h9.067a.567.567 0 0 0 0-1.133z",
    transform: "translate(1302.267 921.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33339",
    "data-name": "Path 33339",
    className: "cls-3",
    d: "M37.267 34h-18.7a.567.567 0 0 0 0 1.133h18.7a.567.567 0 1 0 0-1.133z",
    transform: "translate(1309.633 919.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33340",
    "data-name": "Path 33340",
    className: "cls-3",
    d: "M27.067 40h-8.5a.567.567 0 0 0 0 1.133h8.5a.567.567 0 1 0 0-1.133z",
    transform: "translate(1309.633 916.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33341",
    "data-name": "Path 33341",
    className: "cls-3",
    d: "M27.067 46h-8.5a.567.567 0 0 0 0 1.133h8.5a.567.567 0 1 0 0-1.133z",
    transform: "translate(1309.633 914.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33342",
    "data-name": "Path 33342",
    className: "cls-3",
    d: "M27.067 52h-8.5a.567.567 0 0 0 0 1.133h8.5a.567.567 0 1 0 0-1.133z",
    transform: "translate(1309.633 911.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33343",
    "data-name": "Path 33343",
    className: "cls-3",
    d: "M39 47.933h7.933V40H39zm1.133-6.8H45.8V46.8h-5.667z",
    transform: "translate(1300.533 916.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33344",
    "data-name": "Path 33344",
    className: "cls-3",
    d: "M33.867 7.367c0-.01-.005-.018-.006-.027V0H6.667v17H1v13.6A3.4 3.4 0 0 0 4.4 34h26.067a3.4 3.4 0 0 0 3.394-3.394V7.394c.001-.01.006-.018.006-.027zm-1.139-6.234V6.8H7.8V1.133zM2.133 30.6V18.133h4.534V30.6a2.267 2.267 0 0 1-4.533 0zm28.333 2.267H6.932c.009-.01.015-.022.024-.032a3.378 3.378 0 0 0 .315-.422l.044-.073a3.333 3.333 0 0 0 .24-.481l.025-.07a3.366 3.366 0 0 0 .155-.538c0-.017 0-.035.008-.051a3.383 3.383 0 0 0 .057-.6V7.933h24.928v22.673a2.264 2.264 0 0 1-2.261 2.261z",
    transform: "translate(1317 934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33345",
    "data-name": "Path 33345",
    className: "cls-3",
    d: "M36.6 4H23v3.4h13.6zm-1.133 2.267H24.133V5.133h11.334z",
    transform: "translate(1307.467 932.267)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_197",
    "data-name": "Mask Group 197",
    transform: "translate(0 106)",
    opacity: 0.563,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883",
    transform: "rotate(28 -981.387 2866.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840",
    transform: "translate(35.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753",
    transform: "translate(0 1.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4714",
    "data-name": "Group 4714",
    transform: "translate(.721 24.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34715",
    "data-name": "Path 34715",
    className: "cls-5",
    d: "M212.308 545.114l-12.272 1.073.872-.956.017.05.05-.017c0-.034-.017-.05-.034-.084l1.14-1.241.034-.017v-.017l.05-.05.017.05.117-.05-.017-.05-.084.033 1.123-1.224 4.828-2.833 4.342 5.03a.7.7 0 0 0-.183.303zm.034.151l.453-.034-.067.754.754.486.838-.419.067-.905-.05-.034-.57-.369.3-.352a1.146 1.146 0 0 1 .637.587 1.278 1.278 0 0 1-.6 1.693 1.261 1.261 0 0 1-1.71-.537 1.3 1.3 0 0 1-.052-.87zm1.744-.972a1.4 1.4 0 0 0-.252-.067l1.174-4.091 1.643 1.207zm2.666-2.951l1.291-1.475 1.056 2.23a1.16 1.16 0 0 0-.369.268 1.122 1.122 0 0 0-.184.3zm1.811 1.425l.218.168-.084.034.034.05.084-.034.184.6.687.134.469-.536-.2-.671-.436-.084.134-.352a.934.934 0 0 1 .553 1.593.98.98 0 0 1-1.375.1.919.919 0 0 1-.269-1.002zm.7-.654a.976.976 0 0 1 .218-.034l-.1.268zm-.436.771l-.235-.168a.974.974 0 0 1 .184-.3.856.856 0 0 1 .352-.252l.117.252zm.671-.872a1.461 1.461 0 0 0-.268.034l-1.09-2.3 3.755-4.275.017.017zm2.582-6.522l.084-.235.453.034.319-.453-.235-.5-.57-.05-.251.352-.235-.117a.776.776 0 0 1 .788-.486.746.746 0 0 1 .7.822.77.77 0 0 1-.838.687.517.517 0 0 1-.213-.053zm-.5-.922a.151.151 0 0 0-.017.084l-3.856-.017c0-.017 0-.034-.017-.034a1.348 1.348 0 0 0-1.69-.871 1.247 1.247 0 0 0-.419.218l-.905-1.391a1.432 1.432 0 0 0 .419-.218 1.725 1.725 0 0 0 .57-.637zm-5.968-2.984l-.4-.2-.067-1.09-1.023-.469-.956.654.067 1.056-.386.285a1.592 1.592 0 0 1 .486-2.146 1.527 1.527 0 0 1 2.28 1.911zm-7.712 4.007l4.928-3.591.05.05-3.454 3.772-1.475.151a19.402 19.402 0 0 1-.049-.382zm-.168-.067l-.671.486-.62-1.358-1.66-.151-.956 1.375.654 1.442-.386.553a2.324 2.324 0 0 1-.486-3.185 2.291 2.291 0 0 1 3.2-.553 2.345 2.345 0 0 1 .924 1.391zm-4.476 7.025l-3.705 2.18.486-.7c.017.017.05.033.067.05l.034-.05c-.017-.017-.05-.034-.067-.067l4.057-5.885a2.429 2.429 0 0 0 2.6.05l.268.319zm4.845-2.833l-4.661 2.733 3.6-3.94zm.05-.034l-1.056-1.224 1.358-1.475 2.414 1.106zm5.667 4.627l.2.05-.251.285.017-.218zm1.14-4.208l-1.157 4.04.235-3.923a.8.8 0 0 0 .62-.352zm.017-.067l-.3-.218c0-.017.017-.017.017-.034a.788.788 0 0 0-.05-.771l.738-.419zm3.035-.235l-1.308 1.509-1.677-1.224.436-1.542 1.542-.889zm3.94-4.392zm-.067-.017a.907.907 0 0 1-.251-.369l.235-.134.151.318-.017.05zm-.268-.738a.127.127 0 0 1 .017-.067l.134.067zm.235.168l-.235.134c0-.05-.017-.084-.017-.134zm-.3-.017a.57.57 0 0 0 .017.168l-4.46 2.548-.57-1.207a1.016 1.016 0 0 0 .218-.05 1.376 1.376 0 0 0 .972-1.475zm-6.035-.7l.2.319-.2.771-.386.034a1.2 1.2 0 0 1 .381-1.127zm-4.409 3.923l4.057-2.381a1.281 1.281 0 0 0 .721.6l-1.375 2.6a2.087 2.087 0 0 0-.2-.151.842.842 0 0 0-1.073.3zm3.5 1.827a.733.733 0 0 1-.57.335l.017-.235.352-.235zm0-.822a.767.767 0 0 1 .05.738c0 .017-.017.017-.017.034l-.184-.134-.05-.52zm-.117-.134l-.117.218-.469-.235-.386.251-.235-.1a.771.771 0 0 1 .989-.285.639.639 0 0 1 .217.148zm.084.084l-.1.05.067-.117a.087.087 0 0 0 .032.064zm.838-.469l-.8.453c-.017-.017-.034-.05-.067-.067l1.392-2.615c.034 0 .067.017.1.017zm.972-2.18l.6 1.274-1.492.855.62-2.163a1.306 1.306 0 0 0 .271.031zm-.05-.084c-.067 0-.151-.017-.218-.017l.084-.268zm-.268-.034l-.084-.017.168-.319zm-.822-.62l.369-.218.5.453-.184.335a1.221 1.221 0 0 1-.686-.573zm.3-.251l-.335.184c-.017-.05-.05-.1-.067-.151zm2.112-.553a1.275 1.275 0 0 1-.905 1.392c-.084.017-.151.034-.235.05l-.184-.4.738-.218.2-.822zm-4.342 4.946l-.05.017a.717.717 0 0 1-.05-.587l.235.1.034.4-.117.034.017.05.117-.034.386.2-.017.251a1.389 1.389 0 0 1-.251-.067.7.7 0 0 1-.319-.3l.034-.017zm-3.957-3.739l5.717-.6c.017.067.05.134.067.184l-4.107 2.414-2.464-1.14zm-1.425.151l1.324-.134-.754.822-.62-.285a1.653 1.653 0 0 0 .052-.407zm-.671-.084l.5-.352a1.818 1.818 0 0 1 .017.3zm.52.1a2.06 2.06 0 0 1-.034.319l-.553-.251zm-.285 1.291a2.214 2.214 0 0 0 .352-.755l.553.252-1.341 1.459-.251-.3a2.807 2.807 0 0 0 .692-.659zm-.453-1.123l.671.3a2.642 2.642 0 0 1-.335.738 2.416 2.416 0 0 1-.671.637l-.453-.536zm-.872 1.224l.017-.034.436.5a2.319 2.319 0 0 1-2.414-.067l.386-.553zm8.349-4.963l.922 1.442a1.305 1.305 0 0 0-.419 1.207l-5.516.587 3.4-3.722a1.647 1.647 0 0 0 1.615.483zm-.05-.1a1.569 1.569 0 0 1-1.492-.469l.335-.369.872.4zm1.107-.855a1.666 1.666 0 0 1-.537.6 1.593 1.593 0 0 1-.419.2l-.285-.436.838-.57zm-2.464.168l-.168.184c-.017-.017-.017-.034-.034-.034zm4.51 2.833h-.436l-.57-.52-.754.235-.218-.335a1.508 1.508 0 0 1 .4-.2 1.243 1.243 0 0 1 1.576.822zm.5 5.046l-.989-2.1 4.443-2.548a.894.894 0 0 0 .268.386zm-5.415 5.4l-.319.033a1.836 1.836 0 0 1 .134-.251zm-.151-.268a1.222 1.222 0 0 1 .453-.369 1.191 1.191 0 0 1 .62-.134l-.017.369-.8.4h-.017zm-3.035-3.688l-.1.034-1.241-1.425 2.75-1.61 2.23 1.023a.8.8 0 0 0 .05.62h-.01l.017.05h.017a.811.811 0 0 0 .352.318.827.827 0 0 0 .268.084l-.235 3.99a1.4 1.4 0 0 0-1.123.536l-3.051-3.537.067-.034zm-9.573 5.03l-.52-1.257.084-.033-.017-.034.05-.034.017.05.117-.034-.017-.05-.084.034.822-.486-.034.034.084.1.05-.034c-.034-.034-.05-.067-.084-.084l2.7-1.593-1.073 1.174-.084.033.017.034zm-2.582 1.291l1.643.218 1.006-1.324 12.222-1.073a1.317 1.317 0 0 0 .1.905 1.341 1.341 0 0 0 1.811.57 1.358 1.358 0 0 0 .637-1.794l.067-.034-.034-.05-.067.033a1.312 1.312 0 0 0-.637-.57l2.565-2.934 1.811 1.324a.9.9 0 0 0-.067.369l-.084.034.034.05.05-.034a1.015 1.015 0 0 0 .319.687 1.038 1.038 0 0 0 1.459-.117 1.052 1.052 0 0 0-.05-1.475.919.919 0 0 0-.52-.235l2.4-6.471a1.1 1.1 0 0 0 .251.067.838.838 0 0 0 .905-.721.83.83 0 0 0-1.593-.369l-5.9-2.884a1.647 1.647 0 0 0-.1-1.643 1.679 1.679 0 0 0-2.347-.4 1.7 1.7 0 0 0-.52 2.3l-4.879 3.554a2.459 2.459 0 0 0-4.392-.838 2.486 2.486 0 0 0 .536 3.4l-4.677 6.773-1.609-.2-1.006 1.332z",
    transform: "translate(-196.7 -529.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34716",
    "data-name": "Path 34716",
    className: "cls-3",
    d: "M291.117 593.2l.017.067-.117.034-.017-.05z",
    transform: "translate(-275.19 -582.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34717",
    "data-name": "Path 34717",
    className: "cls-3",
    d: "M293.217 592.5l.017.05-.117.05-.017-.067z",
    transform: "translate(-276.938 -581.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34718",
    "data-name": "Path 34718",
    className: "cls-3",
    d: "M294.217 592.1l.017.05-.117.05-.017-.067z",
    transform: "translate(-277.771 -581.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34719",
    "data-name": "Path 34719",
    className: "cls-3",
    d: "M292.117 592.8l.034.067-.117.034-.034-.05z",
    transform: "translate(-276.023 -582.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34720",
    "data-name": "Path 34720",
    className: "cls-3",
    d: "M282.917 596.2l.017.067-.117.034-.017-.05z",
    transform: "translate(-268.365 -584.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34721",
    "data-name": "Path 34721",
    className: "cls-3",
    d: "M277.717 598.1l.017.067-.1.034-.034-.05z",
    transform: "translate(-264.037 -586.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34722",
    "data-name": "Path 34722",
    className: "cls-3",
    d: "M274.617 599.3l.017.05-.117.05-.017-.067z",
    transform: "translate(-261.457 -587.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34723",
    "data-name": "Path 34723",
    className: "cls-3",
    d: "M276.717 598.5l.017.067-.117.033-.017-.05z",
    transform: "translate(-263.205 -586.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34724",
    "data-name": "Path 34724",
    className: "cls-3",
    d: "M273.617 599.7l.017.05-.117.05-.017-.067z",
    transform: "translate(-260.624 -587.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34725",
    "data-name": "Path 34725",
    className: "cls-3",
    d: "M275.7 598.9l.034.05-.117.05-.017-.067z",
    transform: "translate(-262.372 -587.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34726",
    "data-name": "Path 34726",
    className: "cls-3",
    d: "M287.017 594.7l.017.067-.117.034-.017-.05z",
    transform: "translate(-271.778 -583.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34727",
    "data-name": "Path 34727",
    className: "cls-3",
    d: "M283.917 595.9l.017.05-.117.05-.017-.067z",
    transform: "translate(-269.198 -584.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34728",
    "data-name": "Path 34728",
    className: "cls-3",
    d: "M284.917 595.5l.017.05-.1.05-.034-.067z",
    transform: "translate(-270.03 -584.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34729",
    "data-name": "Path 34729",
    className: "cls-3",
    d: "M286 595.1l.034.067-.117.034-.017-.05z",
    transform: "translate(-270.945 -584.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34730",
    "data-name": "Path 34730",
    className: "cls-3",
    d: "M289.1 594l.034.05-.117.05-.017-.067z",
    transform: "translate(-273.526 -583.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34731",
    "data-name": "Path 34731",
    className: "cls-3",
    d: "M288.017 594.3l.017.067-.117.034-.017-.05z",
    transform: "translate(-272.61 -583.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34732",
    "data-name": "Path 34732",
    className: "cls-3",
    d: "M280.817 597l.017.05-.117.05-.017-.05z",
    transform: "translate(-266.617 -585.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34733",
    "data-name": "Path 34733",
    className: "cls-3",
    d: "M281.817 596.6l.017.067-.1.033-.034-.05z",
    transform: "translate(-267.45 -585.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34734",
    "data-name": "Path 34734",
    className: "cls-3",
    d: "M290.117 593.6l.017.05-.117.05-.017-.067z",
    transform: "translate(-274.358 -582.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34735",
    "data-name": "Path 34735",
    className: "cls-3",
    d: "M278.717 597.8l.034.05-.117.05-.034-.067z",
    transform: "translate(-264.869 -586.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34736",
    "data-name": "Path 34736",
    className: "cls-3",
    d: "M279.817 597.4l.017.05-.117.05-.017-.067z",
    transform: "translate(-265.785 -585.977)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715",
    transform: "translate(.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34737",
    "data-name": "Path 34737",
    className: "cls-5",
    d: "M203.867 398.31l11.183-5.21-.5 1.207-.034-.034-.05.034c.017.017.034.05.05.067l-.654 1.559-.017.017v.017l-.034.067-.034-.034-.1.084.034.05.067-.067-.637 1.542-3.537 4.309-5.784-3.252a1.277 1.277 0 0 0 .047-.356zm-.084-.134l-.419.2-.2-.721-.889-.2-.637.671.235.872.067.017.654.151-.168.436a1.2 1.2 0 0 1-.788-.335 1.285 1.285 0 0 1-.017-1.794 1.253 1.253 0 0 1 1.777-.084 1.18 1.18 0 0 1 .385.786zm-1.308 1.492a1.27 1.27 0 0 0 .251-.017l.285 4.242-1.962-.57zm-1.509 3.688l-.721 1.827-1.745-1.743a1.028 1.028 0 0 0 .251-.386.853.853 0 0 0 .067-.335zm-2.2-.7l-.251-.067.067-.067-.05-.05-.067.067-.386-.5-.687.1-.268.671.419.553.436-.067v.369a.9.9 0 0 1-.553-.05.96.96 0 0 1-.5-1.274.948.948 0 0 1 1.844.319zm-.436.855a1.126 1.126 0 0 1-.2.1v-.285zm.151-.872l.285.084a.75.75 0 0 1-.067.335 1 1 0 0 1-.235.352l-.2-.2zm-.335 1.039a1.025 1.025 0 0 0 .235-.117l1.794 1.794-2.079 5.315h-.034zm-.218 7.008v.251l-.436.117-.151.52.386.386.536-.151.117-.4.268.034a.779.779 0 0 1-1.526.184.765.765 0 0 1 .57-.922 1.031 1.031 0 0 1 .24-.023zm.771.7a.151.151 0 0 0-.017-.084l3.638-1.308.017.034a1.352 1.352 0 0 0 1.894.235 1.492 1.492 0 0 0 .319-.335l1.308 1.006a2.243 2.243 0 0 0-.335.352 1.672 1.672 0 0 0-.319.788zm6.622.771l.453.05.419 1.006 1.123.1.687-.939-.419-.972.268-.4a1.6 1.6 0 0 1 .268 2.2 1.578 1.578 0 0 1-2.2.4 1.683 1.683 0 0 1-.594-1.444zm5.9-6.421l-3.42 5.063a.087.087 0 0 0-.067-.034l1.978-4.728 1.341-.654a1.719 1.719 0 0 0 .174.354zm.184.017l.469-.687 1.039 1.056 1.609-.419.436-1.609-1.107-1.123.168-.654a2.326 2.326 0 0 1 1.542 2.833 2.285 2.285 0 0 1-4.158.6zm1.827-8.131l2.749-3.3-.218.838c-.034 0-.05-.017-.084-.034l-.017.05c.034.017.067.017.084.034l-1.827 6.907a2.463 2.463 0 0 0-2.464.838l-.352-.2zm-3.588 4.309l3.454-4.158-2.062 4.946zm-.034.05l1.408.788-.771 1.861-2.649-.218zm-6.907-2.414a.887.887 0 0 1-.218.017l.134-.352.067.218zm.369 4.359l-.285-4.208 1.106 3.772a.765.765 0 0 0-.453.536zm0 .05l.352.1a.059.059 0 0 1-.017.034.8.8 0 0 0 .319.721l-.553.654zm-2.772 1.274l.738-1.861 2 .587.1 1.593-1.157 1.358zm-2.213 5.482v-.017h.017zm.067 0a.73.73 0 0 1 .369.268l-.184.218-.251-.252v-.05zm.5.587c0 .017.017.034.017.067l-.151-.017zm-.268-.067l.168-.2c.017.034.05.084.067.117l-.235.084zm.268-.1c-.017-.05-.05-.1-.067-.151l3.336-3.923.956.939a1.25 1.25 0 0 0-.2.117 1.377 1.377 0 0 0-.419 1.727zm5.935-1.408l-.3-.218-.084-.8.352-.168a1.251 1.251 0 0 1 .031 1.185zm2.817-5.18l-3.018 3.638a1.321 1.321 0 0 0-.872-.335l.419-2.917a.963.963 0 0 0 .235.067.819.819 0 0 0 .905-.654zm-3.923-.52a.712.712 0 0 1 .419-.5l.067.235-.268.335zm.285.754a.776.776 0 0 1-.3-.671v-.034l.218.067.218.469zm.151.1l.034-.235.5.05.285-.369.251.017a.76.76 0 0 1-.838.6.719.719 0 0 1-.234-.061zm-.1-.067l.067-.084-.017.134zm-.637.754l.6-.7c.034.017.05.034.084.05l-.419 2.934a.212.212 0 0 0-.1.017zm-.168 2.381l-.989-1.006 1.123-1.308.151 2.247a.514.514 0 0 0-.287.067zm.067.05l.2-.05.017.285zm.268-.05a.152.152 0 0 0 .084-.017l-.05.352zm.972.3l-.268.335-.62-.251.05-.386a1.108 1.108 0 0 1 .837.304zm-.2.335l.235-.3a.778.778 0 0 0 .117.117zm-1.794 1.241a1.291 1.291 0 0 1 .386-1.626c.067-.05.134-.084.2-.134l.319.319-.62.469.084.838zm2.414-6.136l.034-.034a.723.723 0 0 1 .235.536l-.251-.017-.168-.369.084-.084-.034-.05-.084.084-.436-.05-.067-.235a.726.726 0 0 1 .268-.017.861.861 0 0 1 .4.168l-.034.034zm5 2.163l-5.18 2.515a1.085 1.085 0 0 0-.134-.151l3.051-3.672 2.7.218zm1.274-.62l-1.207.587.436-1.039.687.05a3.422 3.422 0 0 0 .078.403zm.654-.151l-.352.5a1.449 1.449 0 0 1-.117-.285zm-.52.067a1.778 1.778 0 0 1-.067-.319l.6.05zm-.151-1.308a2.382 2.382 0 0 0-.084.838l-.6-.05.771-1.844.352.2a2.3 2.3 0 0 0-.445.858zm.8.905l-.738-.067a2.618 2.618 0 0 1 .067-.8 2.384 2.384 0 0 1 .419-.821l.6.335zm.386-1.442l-.017.034-.587-.335a2.263 2.263 0 0 1 2.3-.754l-.168.654zm-6.17 7.528l-1.358-1.039a1.28 1.28 0 0 0-.017-1.274l5-2.431-1.945 4.661a1.592 1.592 0 0 0-1.681.085zm.084.067a1.5 1.5 0 0 1 1.542-.067l-.2.469-.956-.084zm-.754 1.174a1.573 1.573 0 0 1 .3-.738 1.276 1.276 0 0 1 .335-.335l.4.319-.587.821zm2.263-.989l.1-.235c.017.017.034.017.034.034zm-5.2-1.123l.419-.151.7.3.637-.469.319.252a1.362 1.362 0 0 1-.3.319 1.294 1.294 0 0 1-1.777-.251zm-2.179-4.577l1.643 1.626-3.32 3.923a.894.894 0 0 0-.386-.268zm3.269-6.924l.3-.134a.759.759 0 0 1-.05.268zm.218.2a1.3 1.3 0 0 1-.3.5 1.081 1.081 0 0 1-.537.335l-.1-.352.62-.654h.017zm4.124 2.414l.084-.067 1.643.922-2.045 2.464-2.448-.2a.815.815 0 0 0-.251-.57l.017-.017-.034-.05-.017.017a.835.835 0 0 0-.721-.168l-1.123-3.839a1.515 1.515 0 0 0 .57-.369 1.408 1.408 0 0 0 .319-.52l4.057 2.28-.05.05zm7.293-8l.922 1.006v.017l-.067.05.034.034-.034.05-.034-.034-.1.084.034.05.067-.05-.6.738.017-.05-.1-.067-.034.05a.35.35 0 0 1 .1.067l-2.012 2.414.6-1.459.067-.05-.034-.034zm2-2.1l-1.626.369-.486 1.593-11.132 5.18a1.3 1.3 0 0 0-2.28-.738 1.366 1.366 0 0 0 0 1.911l-.05.067.05.034.05-.067a1.264 1.264 0 0 0 .788.319l-1.425 3.638-2.146-.637a.9.9 0 0 0-.067-.369l.067-.067-.05-.034-.05.05a.99.99 0 0 0-.536-.536 1.055 1.055 0 0 0-.771 1.962.956.956 0 0 0 .57.05l-.067 6.907a1.265 1.265 0 0 0-.251.017.805.805 0 1 0 1.023.788l6.522.687a1.656 1.656 0 0 0 .654 1.526 1.722 1.722 0 0 0 2.045-2.766l3.387-5.013a2.452 2.452 0 0 0 4.409-.721 2.478 2.478 0 0 0-1.643-3.018l2.1-7.98 1.576-.352.5-1.593z",
    transform: "translate(-196.831 -389.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34738",
    "data-name": "Path 34738",
    className: "cls-3",
    d: "M300 406.717l-.05.017a.807.807 0 0 1-.05-.117l.05-.017z",
    transform: "translate(-282.62 -402.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34739",
    "data-name": "Path 34739",
    className: "cls-3",
    d: "M300.467 408.134l-.067-.1.05-.034a.35.35 0 0 0 .067.1z",
    transform: "translate(-283.036 -403.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34740",
    "data-name": "Path 34740",
    className: "cls-3",
    d: "M301.267 409.351l-.067-.117.05-.034.067.1z",
    transform: "translate(-283.702 -404.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34741",
    "data-name": "Path 34741",
    className: "cls-3",
    d: "M330.567 397.3a.285.285 0 0 1 .017.117h-.067l-.017-.117z",
    transform: "translate(-308.09 -395.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34742",
    "data-name": "Path 34742",
    className: "cls-3",
    d: "M320.8 385.35l.017-.05c.034.017.084.034.117.05l-.017.05z",
    transform: "translate(-300.016 -385.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34743",
    "data-name": "Path 34743",
    className: "cls-3",
    d: "M322.1 385.95l.034-.05a.35.35 0 0 1 .1.067l-.034.05a.35.35 0 0 0-.1-.067z",
    transform: "translate(-301.099 -385.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34744",
    "data-name": "Path 34744",
    className: "cls-3",
    d: "M301.95 390.134l-.05-.034a.443.443 0 0 1 .084-.1l.05.034z",
    transform: "translate(-284.285 -389.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34745",
    "data-name": "Path 34745",
    className: "cls-3",
    d: "M330.767 398.7a.286.286 0 0 0 .017.117h-.067a.285.285 0 0 0-.017-.117z",
    transform: "translate(-308.257 -396.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34746",
    "data-name": "Path 34746",
    className: "cls-3",
    d: "M327.65 390.5c.017.033.05.067.067.1l-.05.034c-.017-.034-.05-.067-.067-.1z",
    transform: "translate(-305.676 -389.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34747",
    "data-name": "Path 34747",
    className: "cls-3",
    d: "M328.45 391.8a.353.353 0 0 0 .067.1l-.05.034-.067-.1z",
    transform: "translate(-306.342 -390.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34748",
    "data-name": "Path 34748",
    className: "cls-3",
    d: "M323.3 386.65l.034-.05c.034.017.067.05.1.067l-.034.05z",
    transform: "translate(-302.097 -386.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34749",
    "data-name": "Path 34749",
    className: "cls-3",
    d: "M330.25 395.8l.034.117-.05.017c-.017-.034-.017-.084-.034-.117z",
    transform: "translate(-307.84 -393.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34750",
    "data-name": "Path 34750",
    className: "cls-3",
    d: "M326.65 389.4c.034.034.05.067.084.1l-.05.034a.2.2 0 0 0-.084-.084z",
    transform: "translate(-304.844 -388.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34751",
    "data-name": "Path 34751",
    className: "cls-3",
    d: "M324.5 387.45l.034-.05a.449.449 0 0 1 .1.084l-.034.05c-.033-.034-.066-.05-.1-.084z",
    transform: "translate(-303.096 -386.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34752",
    "data-name": "Path 34752",
    className: "cls-3",
    d: "M325.65 388.4c.034.034.067.05.084.084l-.05.05-.084-.084z",
    transform: "translate(-304.012 -387.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34753",
    "data-name": "Path 34753",
    className: "cls-3",
    d: "M305.434 413.567l-.034.05c-.034-.017-.067-.05-.1-.067l.034-.05a.35.35 0 0 1 .1.067z",
    transform: "translate(-287.115 -408.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34754",
    "data-name": "Path 34754",
    className: "cls-3",
    d: "M317.6 384.367l.017-.067.117.017-.017.067c-.05 0-.083-.017-.117-.017z",
    transform: "translate(-297.353 -384.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34755",
    "data-name": "Path 34755",
    className: "cls-3",
    d: "M316.1 384.167v-.067c.034 0 .084.017.117.017v.067c-.033 0-.067-.017-.117-.017z",
    transform: "translate(-296.104 -384.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34756",
    "data-name": "Path 34756",
    className: "cls-3",
    d: "M314.7 384.167v-.067h.117v.067z",
    transform: "translate(-294.939 -384.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34757",
    "data-name": "Path 34757",
    className: "cls-3",
    d: "M313.2 384.184v-.067c.034 0 .084-.017.117-.017v.067z",
    transform: "translate(-293.691 -384.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34758",
    "data-name": "Path 34758",
    className: "cls-3",
    d: "M311.717 384.384l-.017-.067.117-.017v.067a.249.249 0 0 0-.1.017z",
    transform: "translate(-292.442 -384.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34759",
    "data-name": "Path 34759",
    className: "cls-3",
    d: "M330.867 400.2v.134h-.067v-.117z",
    transform: "translate(-308.34 -397.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34760",
    "data-name": "Path 34760",
    className: "cls-3",
    d: "M298.6 401.217v-.117h.067v.117z",
    transform: "translate(-281.538 -398.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34761",
    "data-name": "Path 34761",
    className: "cls-3",
    d: "M303.184 411.634c-.034-.034-.067-.05-.084-.084l.05-.05.084.084z",
    transform: "translate(-285.284 -406.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34762",
    "data-name": "Path 34762",
    className: "cls-3",
    d: "M310.317 384.6l-.017-.067c.034-.017.084-.017.117-.034l.017.067a.31.31 0 0 1-.117.034z",
    transform: "translate(-291.277 -384.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34763",
    "data-name": "Path 34763",
    className: "cls-3",
    d: "M302.85 389.117l-.05-.034c.034-.034.05-.067.084-.084l.05.034z",
    transform: "translate(-285.034 -388.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34764",
    "data-name": "Path 34764",
    className: "cls-3",
    d: "M306.333 386.317l-.034-.05c.034-.017.067-.05.1-.067l.034.05a.35.35 0 0 1-.1.067z",
    transform: "translate(-287.947 -385.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34765",
    "data-name": "Path 34765",
    className: "cls-3",
    d: "M329.75 394.534l-.05-.117.05-.017c.017.034.034.084.05.117z",
    transform: "translate(-307.424 -392.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34766",
    "data-name": "Path 34766",
    className: "cls-3",
    d: "M304.034 388.034l-.034-.05c.034-.033.067-.05.1-.084l.034.05a.172.172 0 0 0-.1.084z",
    transform: "translate(-286.033 -387.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34767",
    "data-name": "Path 34767",
    className: "cls-3",
    d: "M305.133 387.117l-.034-.05a.351.351 0 0 1 .1-.067l.034.05a1.036 1.036 0 0 1-.1.067z",
    transform: "translate(-286.949 -386.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34768",
    "data-name": "Path 34768",
    className: "cls-3",
    d: "M308.917 385.1l-.017-.067.117-.034.017.05a.825.825 0 0 1-.117.051z",
    transform: "translate(-290.111 -384.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34769",
    "data-name": "Path 34769",
    className: "cls-3",
    d: "M329.15 393.151l-.05-.117.05-.034c.017.034.034.084.05.117z",
    transform: "translate(-306.925 -391.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34770",
    "data-name": "Path 34770",
    className: "cls-3",
    d: "M307.533 385.7l-.034-.05a.824.824 0 0 1 .117-.05l.017.05z",
    transform: "translate(-288.946 -385.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34771",
    "data-name": "Path 34771",
    className: "cls-3",
    d: "M330.784 401.7a.417.417 0 0 1-.017.134l-.067-.017a.285.285 0 0 1 .017-.117z",
    transform: "translate(-308.257 -398.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34772",
    "data-name": "Path 34772",
    className: "cls-3",
    d: "M310.734 415.934l-.017.067a.309.309 0 0 1-.117-.034l.017-.067z",
    transform: "translate(-291.527 -410.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34773",
    "data-name": "Path 34773",
    className: "cls-3",
    d: "M298.934 404.034c-.017-.034-.017-.084-.034-.117l.067-.017c.017.034.017.084.034.117z",
    transform: "translate(-281.788 -400.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34774",
    "data-name": "Path 34774",
    className: "cls-3",
    d: "M298.717 402.617c0-.034-.017-.084-.017-.117h.067l.017.117z",
    transform: "translate(-281.622 -399.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34775",
    "data-name": "Path 34775",
    className: "cls-3",
    d: "M312.134 416.317l-.017.067-.117-.017.017-.067c.033 0 .067.017.117.017z",
    transform: "translate(-292.692 -410.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34776",
    "data-name": "Path 34776",
    className: "cls-3",
    d: "M315.117 416.5v.067H315v-.067c.034.017.067 0 .117 0z",
    transform: "translate(-295.189 -411.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34777",
    "data-name": "Path 34777",
    className: "cls-3",
    d: "M316.517 416.4v.067l-.117.017v-.067c.034 0 .084-.017.117-.017z",
    transform: "translate(-296.354 -410.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34778",
    "data-name": "Path 34778",
    className: "cls-3",
    d: "M313.617 416.5v.067h-.117v-.067z",
    transform: "translate(-293.94 -411.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34779",
    "data-name": "Path 34779",
    className: "cls-3",
    d: "M319.2 384.75l-.017.067c-.017 0-.05-.017-.067-.017-.034-.017-.084-.017-.117-.034l.017-.067c.034.017.084.017.117.034a.127.127 0 0 1 .067.017z",
    transform: "translate(-298.518 -384.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34780",
    "data-name": "Path 34780",
    className: "cls-3",
    d: "M298.7 398.217c0-.034.017-.084.017-.117h.067c0 .034-.017.084-.017.117z",
    transform: "translate(-281.622 -395.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34781",
    "data-name": "Path 34781",
    className: "cls-3",
    d: "M298.6 399.717v-.117h.067v.117z",
    transform: "translate(-281.538 -397.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34782",
    "data-name": "Path 34782",
    className: "cls-3",
    d: "M298.9 396.717a.311.311 0 0 1 .034-.117l.067.017c-.017.034-.017.084-.034.117z",
    transform: "translate(-281.788 -394.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34783",
    "data-name": "Path 34783",
    className: "cls-3",
    d: "M299.85 393.934l-.05-.017c.017-.034.034-.084.05-.117l.05.017c-.016.033-.033.083-.05.117z",
    transform: "translate(-282.537 -392.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34784",
    "data-name": "Path 34784",
    className: "cls-3",
    d: "M300.45 392.551l-.05-.034a.959.959 0 0 1 .067-.117l.05.034a.42.42 0 0 0-.067.117z",
    transform: "translate(-283.037 -391.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34785",
    "data-name": "Path 34785",
    className: "cls-3",
    d: "M299.284 395.2l-.017.034-.067-.017.017-.05c0-.017.017-.05.017-.067l.067.017a.727.727 0 0 1-.017.083z",
    transform: "translate(-282.038 -393.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34786",
    "data-name": "Path 34786",
    className: "cls-3",
    d: "M301.15 391.334l-.05-.034.067-.1.05.034c-.017.033-.05.066-.067.1z",
    transform: "translate(-283.619 -390.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34787",
    "data-name": "Path 34787",
    className: "cls-3",
    d: "M330.2 404.517c-.017.034-.017.084-.034.117l-.067-.017c.017-.034.017-.084.034-.117z",
    transform: "translate(-307.757 -401.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34788",
    "data-name": "Path 34788",
    className: "cls-3",
    d: "M329.15 407.3l.05.034-.05.117-.05-.034a.823.823 0 0 1 .05-.117z",
    transform: "translate(-306.925 -403.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34789",
    "data-name": "Path 34789",
    className: "cls-3",
    d: "M327.567 409.8l.05.034c-.017.034-.05.067-.067.1l-.05-.034c.017-.033.05-.067.067-.1z",
    transform: "translate(-305.593 -405.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34790",
    "data-name": "Path 34790",
    className: "cls-3",
    d: "M328.367 408.6l.05.034a.35.35 0 0 1-.067.1l-.05-.034a.351.351 0 0 0 .067-.1z",
    transform: "translate(-306.259 -404.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34791",
    "data-name": "Path 34791",
    className: "cls-3",
    d: "M326.584 410.9l.05.034c-.034.034-.05.067-.084.1l-.05-.034a.442.442 0 0 0 .084-.1z",
    transform: "translate(-304.761 -406.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34792",
    "data-name": "Path 34792",
    className: "cls-3",
    d: "M304.234 412.584l-.034.05c-.034-.034-.067-.05-.1-.084l.034-.05z",
    transform: "translate(-286.116 -407.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34793",
    "data-name": "Path 34793",
    className: "cls-3",
    d: "M330.584 403.117c0 .034-.017.084-.017.117l-.067-.017c0-.034.017-.084.017-.117z",
    transform: "translate(-308.09 -399.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34794",
    "data-name": "Path 34794",
    className: "cls-3",
    d: "M325.584 412l.034.05c-.034.034-.067.05-.084.084l-.034-.05z",
    transform: "translate(-303.928 -407.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34795",
    "data-name": "Path 34795",
    className: "cls-3",
    d: "M329.65 405.9l.05.017c-.017.034-.034.084-.05.117l-.05-.017z",
    transform: "translate(-307.341 -402.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34796",
    "data-name": "Path 34796",
    className: "cls-3",
    d: "M319.317 415.7l.017.05c-.034.017-.084.017-.117.034l-.017-.067a.138.138 0 0 0 .117-.017z",
    transform: "translate(-298.685 -410.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34797",
    "data-name": "Path 34797",
    className: "cls-3",
    d: "M324.5 413l.034.05c-.034.017-.067.05-.1.067l-.034-.05c.034-.017.067-.05.1-.067z",
    transform: "translate(-303.013 -408.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34798",
    "data-name": "Path 34798",
    className: "cls-3",
    d: "M323.3 413.8l.034.05c-.034.017-.067.05-.1.067l-.034-.05a.349.349 0 0 0 .1-.067z",
    transform: "translate(-302.014 -408.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34799",
    "data-name": "Path 34799",
    className: "cls-3",
    d: "M307.934 414.95l-.017.067-.117-.05.034-.067z",
    transform: "translate(-289.196 -409.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34800",
    "data-name": "Path 34800",
    className: "cls-3",
    d: "M320.8 415.2l.034.05c-.034.017-.084.034-.117.05l-.017-.05a.272.272 0 0 1 .1-.05z",
    transform: "translate(-299.933 -409.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34801",
    "data-name": "Path 34801",
    className: "cls-3",
    d: "M317.917 416.1l.017.05c-.034.017-.084.017-.117.034l-.017-.067a.248.248 0 0 0 .117-.017z",
    transform: "translate(-297.519 -410.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34802",
    "data-name": "Path 34802",
    className: "cls-3",
    d: "M322.017 414.6l.034.05a.8.8 0 0 1-.117.05l-.034-.05z",
    transform: "translate(-300.932 -409.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34803",
    "data-name": "Path 34803",
    className: "cls-3",
    d: "M307.734 412.317l-.034-.034.084-.084.05.05z",
    transform: "translate(-289.113 -407.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34804",
    "data-name": "Path 34804",
    className: "cls-3",
    d: "M247.134 463.334l-.034-.05.1-.084.034.05z",
    transform: "translate(-238.672 -449.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34805",
    "data-name": "Path 34805",
    className: "cls-3",
    d: "M245.434 464.734l-.034-.05.1-.084.034.05z",
    transform: "translate(-237.257 -451.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34806",
    "data-name": "Path 34806",
    className: "cls-3",
    d: "M244.634 465.434l-.034-.05.084-.084.05.05z",
    transform: "translate(-236.591 -451.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34807",
    "data-name": "Path 34807",
    className: "cls-3",
    d: "M246.25 464.034l-.05-.05.1-.084.05.05z",
    transform: "translate(-237.923 -450.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34808",
    "data-name": "Path 34808",
    className: "cls-3",
    d: "M308.534 411.617l-.034-.034.1-.084.034.05z",
    transform: "translate(-289.779 -406.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34809",
    "data-name": "Path 34809",
    className: "cls-3",
    d: "M309.35 410.917l-.05-.05.1-.067.034.05z",
    transform: "translate(-290.444 -406.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34810",
    "data-name": "Path 34810",
    className: "cls-3",
    d: "M304.334 415.134l-.034-.05.1-.084.034.05z",
    transform: "translate(-286.283 -409.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34811",
    "data-name": "Path 34811",
    className: "cls-3",
    d: "M300.95 418.017l-.05-.05.1-.067.033.034z",
    transform: "translate(-283.453 -412.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34812",
    "data-name": "Path 34812",
    className: "cls-3",
    d: "M300.134 418.717l-.034-.05.084-.067.05.05z",
    transform: "translate(-282.787 -412.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34813",
    "data-name": "Path 34813",
    className: "cls-3",
    d: "M299.25 419.417l-.05-.034.1-.084.033.05z",
    transform: "translate(-282.038 -413.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34814",
    "data-name": "Path 34814",
    className: "cls-3",
    d: "M306.084 413.6l.05.05-.1.084-.034-.05z",
    transform: "translate(-287.698 -408.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34815",
    "data-name": "Path 34815",
    className: "cls-3",
    d: "M301.833 417.317l-.034-.05.084-.067.05.034z",
    transform: "translate(-284.202 -411.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34816",
    "data-name": "Path 34816",
    className: "cls-3",
    d: "M306.9 412.9l.034.05-.1.084-.034-.05z",
    transform: "translate(-288.364 -408.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34817",
    "data-name": "Path 34817",
    className: "cls-3",
    d: "M305.15 414.434l-.05-.05.1-.084.034.05z",
    transform: "translate(-286.949 -409.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34818",
    "data-name": "Path 34818",
    className: "cls-3",
    d: "M303.534 415.834l-.034-.05.084-.084.034.05z",
    transform: "translate(-285.617 -410.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34819",
    "data-name": "Path 34819",
    className: "cls-3",
    d: "M302.65 416.534l-.05-.05.1-.084.033.05z",
    transform: "translate(-284.868 -410.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34820",
    "data-name": "Path 34820",
    className: "cls-3",
    d: "M253.85 457.634l-.05-.05.1-.084.034.05z",
    transform: "translate(-244.249 -445.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34821",
    "data-name": "Path 34821",
    className: "cls-3",
    d: "M281.634 434.317l-.034-.05.084-.067.05.034z",
    transform: "translate(-267.388 -425.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34822",
    "data-name": "Path 34822",
    className: "cls-3",
    d: "M280.75 435.017l-.05-.05.1-.067.034.05z",
    transform: "translate(-266.639 -426.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34823",
    "data-name": "Path 34823",
    className: "cls-3",
    d: "M279.934 435.717l-.034-.05.1-.067.034.05z",
    transform: "translate(-265.973 -426.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    className: "cls-3",
    transform: "rotate(-38.37 19.57 -15.396)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2161",
    "data-name": "Rectangle 2161",
    className: "cls-3",
    transform: "rotate(-40.62 18.283 -15.699)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34824",
    "data-name": "Path 34824",
    className: "cls-3",
    d: "M282.434 433.617l-.034-.05.1-.067.034.034z",
    transform: "translate(-268.054 -425.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34825",
    "data-name": "Path 34825",
    className: "cls-3",
    d: "M283.334 432.834l-.034-.05.084-.084.05.05z",
    transform: "translate(-268.803 -424.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2162",
    "data-name": "Rectangle 2162",
    className: "cls-3",
    transform: "rotate(-40.62 19.27 -12.963)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34826",
    "data-name": "Path 34826",
    className: "cls-3",
    d: "M274.034 440.634l-.034-.05.1-.084.034.05z",
    transform: "translate(-261.063 -431.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2163",
    "data-name": "Rectangle 2163",
    className: "cls-3",
    transform: "rotate(-38.37 20.377 -13.31)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34827",
    "data-name": "Path 34827",
    className: "cls-3",
    d: "M285.034 431.434l-.034-.05.084-.084.034.05z",
    transform: "translate(-270.218 -423.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34828",
    "data-name": "Path 34828",
    className: "cls-3",
    d: "M273.234 441.334l-.034-.05.084-.084.05.05z",
    transform: "translate(-260.397 -431.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34829",
    "data-name": "Path 34829",
    className: "cls-3",
    d: "M277.434 437.834l-.034-.05.084-.084.05.05z",
    transform: "translate(-263.892 -428.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34830",
    "data-name": "Path 34830",
    className: "cls-3",
    d: "M275.733 439.234l-.034-.05.1-.084.034.05z",
    transform: "translate(-262.477 -429.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34831",
    "data-name": "Path 34831",
    className: "cls-3",
    d: "M276.55 438.534l-.05-.05.1-.084.034.05z",
    transform: "translate(-263.143 -429.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34832",
    "data-name": "Path 34832",
    className: "cls-3",
    d: "M278.25 437.134l-.05-.05.1-.084.034.05z",
    transform: "translate(-264.558 -428.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2164",
    "data-name": "Rectangle 2164",
    className: "cls-3",
    transform: "rotate(-40.62 17.29 -18.46)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    className: "cls-3",
    transform: "rotate(-39.4 17.776 -18.67)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34833",
    "data-name": "Path 34833",
    className: "cls-3",
    d: "M294.234 423.634l-.034-.05.1-.084.034.05z",
    transform: "translate(-277.876 -416.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34834",
    "data-name": "Path 34834",
    className: "cls-3",
    d: "M292.55 425.034l-.05-.05.1-.084.034.05z",
    transform: "translate(-276.461 -418.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34835",
    "data-name": "Path 34835",
    className: "cls-3",
    d: "M295.05 422.934l-.05-.05.1-.084.034.05z",
    transform: "translate(-278.542 -416.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34836",
    "data-name": "Path 34836",
    className: "cls-3",
    d: "M296.75 421.534l-.05-.05.1-.084.034.05z",
    transform: "translate(-279.957 -415.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34837",
    "data-name": "Path 34837",
    className: "cls-3",
    d: "M295.934 422.234l-.034-.05.084-.084.05.05z",
    transform: "translate(-279.291 -415.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34838",
    "data-name": "Path 34838",
    className: "cls-3",
    d: "M286.65 430.034l-.05-.05.1-.084.034.05z",
    transform: "translate(-271.55 -422.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    className: "cls-3",
    transform: "rotate(-40.62 17.93 -16.71)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34839",
    "data-name": "Path 34839",
    className: "cls-3",
    d: "M285.833 430.734l-.034-.05.1-.084.034.05z",
    transform: "translate(-270.884 -422.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34840",
    "data-name": "Path 34840",
    className: "cls-3",
    d: "M288.334 428.617l-.034-.034.1-.084.034.05z",
    transform: "translate(-272.965 -421.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34841",
    "data-name": "Path 34841",
    className: "cls-3",
    d: "M289.15 427.917l-.05-.034.1-.084.05.05z",
    transform: "translate(-273.631 -420.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34842",
    "data-name": "Path 34842",
    className: "cls-3",
    d: "M290.85 426.517l-.05-.05.1-.067.034.034z",
    transform: "translate(-275.046 -419.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2167",
    "data-name": "Rectangle 2167",
    className: "cls-3",
    transform: "rotate(-41.63 17.408 -16.909)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2168",
    "data-name": "Rectangle 2168",
    className: "cls-3",
    transform: "rotate(-39.612 21.508 -8.359)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34843",
    "data-name": "Path 34843",
    className: "cls-3",
    d: "M269.833 444.217l-.034-.034.1-.084.034.05z",
    transform: "translate(-257.567 -434.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34844",
    "data-name": "Path 34844",
    className: "cls-3",
    d: "M269.034 444.917l-.034-.034.084-.084.05.05z",
    transform: "translate(-256.901 -434.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34845",
    "data-name": "Path 34845",
    className: "cls-3",
    d: "M270.65 443.517l-.05-.05.1-.067.034.05z",
    transform: "translate(-258.232 -433.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34846",
    "data-name": "Path 34846",
    className: "cls-3",
    d: "M271.534 442.817l-.034-.05.084-.067.05.034z",
    transform: "translate(-258.982 -432.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34847",
    "data-name": "Path 34847",
    className: "cls-3",
    d: "M268.15 445.634l-.05-.05.1-.084.034.05z",
    transform: "translate(-256.152 -435.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2169",
    "data-name": "Rectangle 2169",
    className: "cls-3",
    transform: "rotate(-39.4 21.322 -9.198)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34848",
    "data-name": "Path 34848",
    className: "cls-3",
    d: "M258.934 453.434l-.034-.05.084-.084.05.05z",
    transform: "translate(-248.494 -441.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34849",
    "data-name": "Path 34849",
    className: "cls-3",
    d: "M261.434 451.317l-.034-.05.1-.067.034.05z",
    transform: "translate(-250.575 -439.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34850",
    "data-name": "Path 34850",
    className: "cls-3",
    d: "M263.934 449.134l-.034-.05.1-.084.034.05z",
    transform: "translate(-252.656 -438.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34851",
    "data-name": "Path 34851",
    className: "cls-3",
    d: "M263.134 449.917l-.034-.05.084-.067.05.034z",
    transform: "translate(-251.99 -438.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34852",
    "data-name": "Path 34852",
    className: "cls-3",
    d: "M264.833 448.434l-.034-.05.084-.084.05.05z",
    transform: "translate(-253.405 -437.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    className: "cls-3",
    transform: "rotate(-41.63 19.885 -9.798)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34853",
    "data-name": "Path 34853",
    className: "cls-3",
    d: "M267.334 446.334l-.034-.05.1-.084.034.05z",
    transform: "translate(-255.486 -435.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2171",
    "data-name": "Rectangle 2171",
    className: "cls-3",
    transform: "rotate(-39.4 20.645 -10.99)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34854",
    "data-name": "Path 34854",
    className: "cls-3",
    d: "M259.75 452.717l-.05-.034.1-.084.034.05z",
    transform: "translate(-249.16 -441.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34855",
    "data-name": "Path 34855",
    className: "cls-3",
    d: "M250.534 460.517l-.034-.033.084-.084.05.05z",
    transform: "translate(-241.502 -447.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34856",
    "data-name": "Path 34856",
    className: "cls-3",
    d: "M253.034 458.417l-.034-.05.1-.067.034.034z",
    transform: "translate(-243.583 -445.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34857",
    "data-name": "Path 34857",
    className: "cls-3",
    d: "M252.15 459.117l-.05-.05.1-.067.034.05z",
    transform: "translate(-242.834 -446.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34858",
    "data-name": "Path 34858",
    className: "cls-3",
    d: "M251.334 459.817l-.034-.05.1-.067.034.05z",
    transform: "translate(-242.168 -447.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34859",
    "data-name": "Path 34859",
    className: "cls-3",
    d: "M248.833 461.934l-.034-.05.084-.084.05.05z",
    transform: "translate(-240.087 -448.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34860",
    "data-name": "Path 34860",
    className: "cls-3",
    d: "M249.65 461.217l-.05-.034.1-.084.034.05z",
    transform: "translate(-240.753 -448.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34861",
    "data-name": "Path 34861",
    className: "cls-3",
    d: "M255.534 456.234l-.034-.05.1-.084.034.05z",
    transform: "translate(-245.664 -444.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34862",
    "data-name": "Path 34862",
    className: "cls-3",
    d: "M254.734 456.934l-.034-.05.084-.084.05.05z",
    transform: "translate(-244.998 -444.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34863",
    "data-name": "Path 34863",
    className: "cls-3",
    d: "M247.95 462.634l-.05-.05.1-.084.034.05z",
    transform: "translate(-239.338 -449.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34864",
    "data-name": "Path 34864",
    className: "cls-3",
    d: "M257.234 454.834l-.034-.05.1-.084.034.05z",
    transform: "translate(-247.079 -442.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34865",
    "data-name": "Path 34865",
    className: "cls-3",
    d: "M256.434 455.534l-.034-.05.084-.084.034.05z",
    transform: "translate(-246.413 -443.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34866",
    "data-name": "Path 34866",
    className: "cls-3",
    d: "M208.8 457.1l.084-.1.034.05-.084.084z",
    transform: "translate(-206.793 -444.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    className: "cls-3",
    transform: "rotate(-46.102 15.389 3.576)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    className: "cls-3",
    transform: "rotate(-46.122 15.64 4.242)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34867",
    "data-name": "Path 34867",
    className: "cls-3",
    d: "M225.634 439.734l-.034-.05.084-.084.034.05z",
    transform: "translate(-220.777 -430.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34868",
    "data-name": "Path 34868",
    className: "cls-3",
    d: "M221.05 444.517l-.05-.033.084-.084.05.033z",
    transform: "translate(-216.948 -434.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34869",
    "data-name": "Path 34869",
    className: "cls-3",
    d: "M218.75 446.834l-.05-.034.084-.1.05.05z",
    transform: "translate(-215.034 -436.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34870",
    "data-name": "Path 34870",
    className: "cls-3",
    d: "M219.533 446.034L219.5 446l.084-.1.034.05z",
    transform: "translate(-215.7 -435.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    className: "cls-3",
    transform: "rotate(-45 14.9 1.542)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34871",
    "data-name": "Path 34871",
    className: "cls-3",
    d: "M217.234 448.434l-.034-.034.084-.1.034.05z",
    transform: "translate(-213.785 -437.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34872",
    "data-name": "Path 34872",
    className: "cls-3",
    d: "M217.95 447.634l-.05-.034.084-.1.05.05z",
    transform: "translate(-214.368 -436.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    className: "cls-3",
    transform: "rotate(-45 14.433 .435)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34873",
    "data-name": "Path 34873",
    className: "cls-3",
    d: "M222.55 442.934l-.05-.05.084-.084.05.034z",
    transform: "translate(-218.197 -432.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34874",
    "data-name": "Path 34874",
    className: "cls-3",
    d: "M221.834 443.734l-.034-.05.084-.084.034.034z",
    transform: "translate(-217.614 -433.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    className: "cls-3",
    transform: "rotate(-46.122 13.348 -1.162)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34875",
    "data-name": "Path 34875",
    className: "cls-3",
    d: "M223.334 442.134l-.034-.05.084-.084.05.034z",
    transform: "translate(-218.862 -432.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    className: "cls-3",
    transform: "rotate(-46.05 14.65 1.847)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    className: "cls-3",
    transform: "rotate(-46.05 15.214 3.15)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34876",
    "data-name": "Path 34876",
    className: "cls-3",
    d: "M211.85 454.034l-.05-.05.084-.084.05.034z",
    transform: "translate(-209.29 -442.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34877",
    "data-name": "Path 34877",
    className: "cls-3",
    d: "M224.05 441.334l-.05-.05.1-.084.034.05z",
    transform: "translate(-219.445 -431.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34878",
    "data-name": "Path 34878",
    className: "cls-3",
    d: "M210.35 455.617l-.05-.034.084-.084.05.034z",
    transform: "translate(-208.042 -443.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2179",
    "data-name": "Rectangle 2179",
    className: "cls-3",
    transform: "rotate(-46.05 15.03 2.722)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    className: "cls-3",
    transform: "rotate(-46.122 14.728 2.078)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2181",
    "data-name": "Rectangle 2181",
    className: "cls-3",
    transform: "rotate(-46.05 14.842 2.296)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    className: "cls-3",
    transform: "rotate(-46.122 14.913 2.506)",
    d: "M0 0h.117v.067H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4720",
    "data-name": "Group 4720",
    transform: "translate(2.352 25.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34879",
    "data-name": "Path 34879",
    className: "cls-3",
    d: "M260 574.776l12.155-12.876-.1-.1-12.155 12.876z",
    transform: "translate(-250.935 -557.679)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716",
    transform: "translate(.666 3.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34880",
    "data-name": "Path 34880",
    className: "cls-3",
    d: "M212.5 560.417l-.3.536.3.536h.637l.3-.553-.319-.536z",
    transform: "translate(-211.898 -560.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34881",
    "data-name": "Path 34881",
    className: "cls-5",
    d: "M212.177 559.1a.863.863 0 0 0-1.727.017.862.862 0 0 0 .872.855.852.852 0 0 0 .855-.872zm.05 0a.942.942 0 0 1-.905.939.916.916 0 0 1-.922-.905.942.942 0 0 1 .905-.939.905.905 0 0 1 .922.905z",
    transform: "translate(-210.4 -558.197)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4717",
    "data-name": "Group 4717",
    transform: "translate(20.453 2.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34882",
    "data-name": "Path 34882",
    className: "cls-3",
    d: "M330.6 556.7l-.4.486.235.587.62.084.386-.486-.235-.587z",
    transform: "translate(-329.903 -556.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34883",
    "data-name": "Path 34883",
    className: "cls-5",
    d: "M330.2 555.761a.88.88 0 0 0-.721-.989.854.854 0 0 0-.972.721.87.87 0 0 0 .721.989.842.842 0 0 0 .972-.721zm.05.017a.915.915 0 1 1-.771-1.04.9.9 0 0 1 .77 1.04z",
    transform: "translate(-328.426 -554.726)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4718",
    "data-name": "Group 4718",
    transform: "translate(0 9.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34884",
    "data-name": "Path 34884",
    className: "cls-3",
    d: "M209.1 597.6l-.587.2-.117.6.469.419.587-.2.117-.62z",
    transform: "translate(-208.069 -597.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34885",
    "data-name": "Path 34885",
    className: "cls-5",
    d: "M208 597.215a.858.858 0 0 0-.084-1.224.837.837 0 0 0-1.207.084.887.887 0 0 0 .067 1.224.858.858 0 0 0 1.224-.084zm.034.05a.908.908 0 0 1-1.291.084.928.928 0 0 1-.084-1.308.908.908 0 0 1 1.291-.084.927.927 0 0 1 .082 1.308z",
    transform: "translate(-206.427 -595.727)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4719",
    "data-name": "Group 4719",
    transform: "translate(6.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34886",
    "data-name": "Path 34886",
    className: "cls-3",
    d: "M246.569 538.4l-.369.2v.419l.352.235.369-.218.017-.419z",
    transform: "translate(-245.935 -538.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34887",
    "data-name": "Path 34887",
    className: "cls-5",
    d: "M245.74 538.139a.587.587 0 1 0-.8.2.578.578 0 0 0 .8-.2zm.034.034a.621.621 0 1 1-.2-.855.608.608 0 0 1 .199.854z",
    transform: "translate(-244.62 -537.22)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34888",
    "data-name": "Path 34888",
    className: "cls-3",
    d: "M216.517 565.4l-.117.067 6.639 12 .117-.067z",
    transform: "translate(-214.728 -560.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34889",
    "data-name": "Path 34889",
    className: "cls-3",
    d: "M248.2 541.3l1.291 16.3h.05l-1.291-16.3z",
    transform: "translate(-241.197 -540.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34890",
    "data-name": "Path 34890",
    className: "cls-3",
    d: "M216.484 544.371l5.13-3.454-.084-.117-5.13 3.454z",
    transform: "translate(-214.728 -540.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34891",
    "data-name": "Path 34891",
    className: "cls-3",
    d: "M211.784 571.45l.419-5.633-.184-.017-.419 5.633z",
    transform: "translate(-210.733 -561.009)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733",
    transform: "translate(17.288 6.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4721",
    "data-name": "Group 4721",
    transform: "translate(3.637 6.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34892",
    "data-name": "Path 34892",
    className: "cls-3",
    d: "M321.739 467.3l-.905.486-.034 1.04.872.536.905-.486.034-1.023z",
    transform: "translate(-320.199 -466.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34893",
    "data-name": "Path 34893",
    className: "cls-5",
    d: "M319.929 466.673a1.426 1.426 0 1 0-1.978.469 1.45 1.45 0 0 0 1.978-.469zm.084.05a1.488 1.488 0 0 1-2.079.486 1.522 1.522 0 0 1-.486-2.1 1.488 1.488 0 0 1 2.079-.486 1.533 1.533 0 0 1 .486 2.101z",
    transform: "translate(-317.216 -464.392)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4722",
    "data-name": "Group 4722",
    transform: "translate(5.214 1.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34894",
    "data-name": "Path 34894",
    className: "cls-3",
    d: "M327.752 434.2l-.235.117-.017.268.235.134.218-.117.017-.268z",
    transform: "translate(-327.353 -434.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34895",
    "data-name": "Path 34895",
    className: "cls-5",
    d: "M327.307 434.006a.39.39 0 0 0-.1-.5.377.377 0 0 0-.5.117.358.358 0 1 0 .6.386zm.034.017a.388.388 0 1 1-.117-.537.416.416 0 0 1 .116.537z",
    transform: "translate(-326.623 -433.423)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(1.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34896",
    "data-name": "Path 34896",
    className: "cls-3",
    d: "M305.918 425.2l-.218.235.1.3.3.084.218-.235-.084-.319z",
    transform: "translate(-305.534 -425.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34897",
    "data-name": "Path 34897",
    className: "cls-5",
    d: "M305.632 424.8a.444.444 0 0 0-.335-.536.449.449 0 0 0-.218.872.475.475 0 0 0 .553-.336zm.017 0a.474.474 0 1 1-.352-.57.456.456 0 0 1 .351.57z",
    transform: "translate(-304.711 -424.211)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4724",
    "data-name": "Group 4724",
    transform: "translate(8.118 1.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34898",
    "data-name": "Path 34898",
    className: "cls-3",
    d: "M344.768 434.417l-.168-.017-.1.151.067.151.184.017.1-.151z",
    transform: "translate(-344.407 -434.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34899",
    "data-name": "Path 34899",
    className: "cls-5",
    d: "M344.3 434.237a.261.261 0 0 0 .117-.335.247.247 0 0 0-.319-.117.261.261 0 0 0-.117.335.247.247 0 0 0 .319.117zm.017.017a.266.266 0 1 1-.218-.486.271.271 0 0 1 .352.117.292.292 0 0 1-.13.369z",
    transform: "translate(-343.943 -433.741)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34900",
    "data-name": "Path 34900",
    className: "cls-3",
    d: "M311 434.958L307.75 428l-.05.034 3.252 6.958z",
    transform: "translate(-305.658 -427.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34901",
    "data-name": "Path 34901",
    className: "cls-3",
    d: "M302.595 478.5l-4.795 7.242.017.05 4.812-7.243z",
    transform: "translate(-297.418 -469.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34902",
    "data-name": "Path 34902",
    className: "cls-3",
    d: "M326.586 436.617l-.067-.017-.419 5.75h.05z",
    transform: "translate(-320.973 -434.523)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4725",
    "data-name": "Group 4725",
    transform: "translate(9.501 4.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34903",
    "data-name": "Path 34903",
    className: "cls-3",
    d: "M353.453 452.4l-.235-.1-.218.151.034.251.235.117.218-.168z",
    transform: "translate(-352.865 -452.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34904",
    "data-name": "Path 34904",
    className: "cls-5",
    d: "M352.613 452.248a.363.363 0 1 0-.4-.318.384.384 0 0 0 .4.318zm0 .017a.38.38 0 0 1-.419-.335.407.407 0 0 1 .335-.436.38.38 0 0 1 .419.335.373.373 0 0 1-.335.436z",
    transform: "translate(-352.192 -451.492)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4726",
    "data-name": "Group 4726",
    transform: "translate(13.362 4.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34905",
    "data-name": "Path 34905",
    className: "cls-3",
    d: "M376.419 449.234l-.268-.034-.151.2.1.251.251.034.168-.218z",
    transform: "translate(-375.87 -449.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34906",
    "data-name": "Path 34906",
    className: "cls-5",
    d: "M375.755 449.122a.361.361 0 1 0-.469-.2.34.34 0 0 0 .469.2zm0 .033a.383.383 0 1 1 .2-.5.38.38 0 0 1-.2.501z",
    transform: "translate(-375.222 -448.422)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34907",
    "data-name": "Path 34907",
    className: "cls-3",
    d: "M332.825 454.15l-.034-.05-4.191 3.085.034.05z",
    transform: "translate(-323.054 -449.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34908",
    "data-name": "Path 34908",
    className: "cls-3",
    d: "M328.836 435.5l-3.336 5.667.034.017 3.319-5.683z",
    transform: "translate(-320.474 -433.607)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727",
    transform: "translate(5.885 13.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34909",
    "data-name": "Path 34909",
    className: "cls-3",
    d: "M331.719 508.3l.184-.168-.05-.268-.252-.067-.2.168.067.268z",
    transform: "translate(-331.27 -507.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34910",
    "data-name": "Path 34910",
    className: "cls-5",
    d: "M330.67 507.274a.361.361 0 0 0 .687.218.371.371 0 0 0-.235-.453.339.339 0 0 0-.452.235zm-.034-.017a.382.382 0 0 1 .486-.252.376.376 0 0 1 .251.486.371.371 0 0 1-.469.251.4.4 0 0 1-.267-.485z",
    transform: "translate(-330.624 -506.987)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728",
    transform: "translate(8.357 13.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34911",
    "data-name": "Path 34911",
    className: "cls-3",
    d: "M346.919 507.7l.268-.251-.084-.352-.335-.1-.268.252.084.352z",
    transform: "translate(-346.311 -506.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34912",
    "data-name": "Path 34912",
    className: "cls-5",
    d: "M345.426 506.306a.509.509 0 0 0 .335.637.485.485 0 0 0 .62-.335.509.509 0 0 0-.335-.637.5.5 0 0 0-.62.335zm-.034 0a.536.536 0 1 1 .352.671.548.548 0 0 1-.352-.671z",
    transform: "translate(-345.37 -505.925)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(0 15.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34913",
    "data-name": "Path 34913",
    className: "cls-3",
    d: "M296.434 520.37l.268.017.134-.235-.134-.235-.268-.017-.134.235z",
    transform: "translate(-296.169 -519.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34914",
    "data-name": "Path 34914",
    className: "cls-5",
    d: "M295.736 519.085a.363.363 0 0 0-.134.5.369.369 0 0 0 .5.151.384.384 0 0 0 .151-.52.4.4 0 0 0-.517-.131zm-.017-.017a.4.4 0 0 1 .536.151.425.425 0 0 1-.151.553.389.389 0 0 1-.536-.151.42.42 0 0 1 .151-.553z",
    transform: "translate(-295.521 -519.021)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730",
    "data-name": "Group 4730",
    transform: "translate(6.945 11.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34915",
    "data-name": "Path 34915",
    className: "cls-3",
    d: "M337.834 493.953h.251l.134-.235-.134-.218h-.268l-.117.218z",
    transform: "translate(-337.574 -493.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34916",
    "data-name": "Path 34916",
    className: "cls-5",
    d: "M337.141 492.544a.368.368 0 0 0 .369.637.37.37 0 0 0 .117-.5.341.341 0 0 0-.486-.137zm-.017-.034a.388.388 0 0 1 .536.134.4.4 0 0 1-.134.536.379.379 0 0 1-.52-.134.4.4 0 0 1 .118-.536z",
    transform: "translate(-336.948 -492.452)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    transform: "translate(3.349 14.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34917",
    "data-name": "Path 34917",
    className: "cls-3",
    d: "M316.117 513.535l.184-.034.05-.168-.117-.134-.168.034-.066.167z",
    transform: "translate(-315.916 -513.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34918",
    "data-name": "Path 34918",
    className: "cls-5",
    d: "M315.6 512.772a.249.249 0 1 0 .352.017.279.279 0 0 0-.352-.017zm-.017 0a.25.25 0 0 1 .369.034.261.261 0 0 1-.386.352.281.281 0 0 1 .015-.386z",
    transform: "translate(-315.497 -512.706)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732",
    transform: "translate(6.921 17.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34919",
    "data-name": "Path 34919",
    className: "cls-3",
    d: "M337.584 528.752l.151-.117-.034-.168-.168-.067-.134.117.034.185z",
    transform: "translate(-337.299 -528.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34920",
    "data-name": "Path 34920",
    className: "cls-5",
    d: "M336.834 528.125a.249.249 0 1 0 .318-.151.242.242 0 0 0-.318.151zm-.017 0a.285.285 0 0 1 .335-.168.26.26 0 0 1 .151.335.285.285 0 0 1-.335.168.261.261 0 0 1-.151-.335z",
    transform: "translate(-336.8 -527.949)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34921",
    "data-name": "Path 34921",
    className: "cls-3",
    d: "M326.607 482.2l.067-.017-1.207-5.281-.067.017z",
    transform: "translate(-320.391 -468.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34922",
    "data-name": "Path 34922",
    className: "cls-3",
    d: "M317.117 483.553l1.593-6.136-.017-.017-1.593 6.153z",
    transform: "translate(-313.482 -468.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34923",
    "data-name": "Path 34923",
    className: "cls-3",
    d: "M309.117 427.2l-.017.05 3.152 1.492.017-.05z",
    transform: "translate(-306.824 -426.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34924",
    "data-name": "Path 34924",
    className: "cls-3",
    d: "M332.165 435.2l-2.565.218.017.05 2.548-.218z",
    transform: "translate(-323.887 -433.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34925",
    "data-name": "Path 34925",
    className: "cls-3",
    d: "M345.65 435.9l-.05.017 1.475 2.833.05-.034z",
    transform: "translate(-337.204 -433.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34926",
    "data-name": "Path 34926",
    className: "cls-3",
    d: "M345.5 435.5v.017l5.3 2.6v-.017z",
    transform: "translate(-337.121 -433.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34927",
    "data-name": "Path 34927",
    className: "cls-3",
    d: "M358.639 450.1l-3.739.469v.05l3.739-.453z",
    transform: "translate(-344.945 -445.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34928",
    "data-name": "Path 34928",
    className: "cls-3",
    d: "M319.981 509.8l-2.481.721.017.067 2.483-.738z",
    transform: "translate(-313.815 -495.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34929",
    "data-name": "Path 34929",
    className: "cls-3",
    d: "M324.867 478l-.067.067 2.33 2.716.05-.05z",
    transform: "translate(-319.891 -468.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34930",
    "data-name": "Path 34930",
    className: "cls-3",
    d: "M334.372 495.4l-.872 2.2.067.034.889-2.2z",
    transform: "translate(-327.133 -483.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34931",
    "data-name": "Path 34931",
    className: "cls-3",
    d: "M339.45 495.3l-.05.034 1.492 2.062.05-.034z",
    transform: "translate(-332.044 -483.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34932",
    "data-name": "Path 34932",
    className: "cls-3",
    d: "M335.865 508.3l-2.465.235v.067l2.465-.252z",
    transform: "translate(-327.05 -494.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34933",
    "data-name": "Path 34933",
    className: "cls-3",
    d: "M333.117 509.9h-.017l.855 3.219h.017z",
    transform: "translate(-326.8 -495.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34934",
    "data-name": "Path 34934",
    className: "cls-3",
    d: "M340.159 509.6l-1.459 3.319.034.017 1.442-3.32z",
    transform: "translate(-331.461 -495.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34935",
    "data-name": "Path 34935",
    className: "cls-3",
    d: "M301.935 514l-3.035 1.241.017.034 3.034-1.257z",
    transform: "translate(-298.334 -498.947)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734",
    transform: "translate(7.025 7.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34936",
    "data-name": "Path 34936",
    className: "cls-3",
    d: "M248.5 427.9a.213.213 0 0 1 .1.017l-.017.05a.73.73 0 0 1-.084-.017z",
    transform: "translate(-246.119 -427.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34937",
    "data-name": "Path 34937",
    className: "cls-3",
    d: "M236.734 432.717l-.034-.034a.367.367 0 0 0 .05-.084l.034.034z",
    transform: "translate(-236.298 -431.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34938",
    "data-name": "Path 34938",
    className: "cls-3",
    d: "M236.05 433.617l-.05-.034.05-.084.034.017a.18.18 0 0 1-.034.101z",
    transform: "translate(-235.715 -432.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34939",
    "data-name": "Path 34939",
    className: "cls-3",
    d: "M235.55 434.7l-.05-.017c.017-.034.034-.05.05-.084l.034.017z",
    transform: "translate(-235.299 -433.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34940",
    "data-name": "Path 34940",
    className: "cls-3",
    d: "M235.134 435.7l-.034-.017.034-.084.034.017z",
    transform: "translate(-234.966 -434.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34941",
    "data-name": "Path 34941",
    className: "cls-3",
    d: "M237.4 431.834l-.05.067-.05-.033.067-.067z",
    transform: "translate(-236.797 -431.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34942",
    "data-name": "Path 34942",
    className: "cls-3",
    d: "M249.517 428.1l.084.017-.017.05a.151.151 0 0 0-.084-.017z",
    transform: "translate(-246.952 -428.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34943",
    "data-name": "Path 34943",
    className: "cls-3",
    d: "M234.767 443.384l-.034.017-.034-.084.05-.017z",
    transform: "translate(-234.633 -440.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34944",
    "data-name": "Path 34944",
    className: "cls-3",
    d: "M234.75 436.717l-.05-.017a.238.238 0 0 1 .034-.1l.05.017z",
    transform: "translate(-234.633 -435.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34945",
    "data-name": "Path 34945",
    className: "cls-3",
    d: "M234.567 442.3h-.05l-.017-.084.05-.017z",
    transform: "translate(-234.466 -439.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34946",
    "data-name": "Path 34946",
    className: "cls-3",
    d: "M234.35 440.1h-.05v-.1h.05z",
    transform: "translate(-234.3 -437.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34947",
    "data-name": "Path 34947",
    className: "cls-3",
    d: "M234.367 441.2h-.05a.212.212 0 0 0-.017-.1h.05a.213.213 0 0 1 .017.1z",
    transform: "translate(-234.3 -438.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34948",
    "data-name": "Path 34948",
    className: "cls-3",
    d: "M234.45 439h-.05a.212.212 0 0 1 .017-.1h.05a.212.212 0 0 0-.017.1z",
    transform: "translate(-234.383 -437.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34949",
    "data-name": "Path 34949",
    className: "cls-3",
    d: "M234.55 437.817l-.05-.017c0-.034.017-.067.017-.1l.05.017a.213.213 0 0 0-.017.1z",
    transform: "translate(-234.466 -436.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34950",
    "data-name": "Path 34950",
    className: "cls-3",
    d: "M236.084 446.567l-.034.034c-.017-.034-.034-.05-.05-.084l.033-.017c.017 0 .034.034.051.067z",
    transform: "translate(-235.715 -443.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34951",
    "data-name": "Path 34951",
    className: "cls-3",
    d: "M248.4 452.45c-.034 0-.067.017-.1.017v-.05l.084-.017z",
    transform: "translate(-245.953 -448.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34952",
    "data-name": "Path 34952",
    className: "cls-3",
    d: "M249.417 452.15a.213.213 0 0 1-.1.017l-.017-.05a.731.731 0 0 0 .084-.017z",
    transform: "translate(-246.785 -448.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34953",
    "data-name": "Path 34953",
    className: "cls-3",
    d: "M245 452.467a.213.213 0 0 1-.1-.017v-.05a.726.726 0 0 1 .084.017z",
    transform: "translate(-243.123 -448.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34954",
    "data-name": "Path 34954",
    className: "cls-3",
    d: "M251.6 451.45c-.034.017-.05.034-.084.034l-.017-.05.084-.034z",
    transform: "translate(-248.616 -447.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34955",
    "data-name": "Path 34955",
    className: "cls-3",
    d: "M243.9 452.267c-.034 0-.067-.017-.1-.017l.017-.05.084.017z",
    transform: "translate(-242.207 -448.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34956",
    "data-name": "Path 34956",
    className: "cls-3",
    d: "M253.567 450.3l.034.034a.364.364 0 0 1-.084.05l-.017-.034c.017-.017.05-.033.067-.05z",
    transform: "translate(-250.281 -446.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34957",
    "data-name": "Path 34957",
    className: "cls-3",
    d: "M235.167 444.484l-.034.017c-.017-.034-.017-.067-.034-.084l.05-.017a.182.182 0 0 0 .018.084z",
    transform: "translate(-234.966 -441.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34958",
    "data-name": "Path 34958",
    className: "cls-3",
    d: "M255.267 448.8l.034.034-.067.067-.034-.034z",
    transform: "translate(-251.696 -445.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34959",
    "data-name": "Path 34959",
    className: "cls-3",
    d: "M254.467 449.6l.034.034c-.017.017-.05.034-.067.067l-.034-.034z",
    transform: "translate(-251.03 -445.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34960",
    "data-name": "Path 34960",
    className: "cls-3",
    d: "M242.884 451.984l-.084-.034.017-.05.084.034z",
    transform: "translate(-241.375 -447.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34961",
    "data-name": "Path 34961",
    className: "cls-3",
    d: "M252.584 450.9l.017.033-.084.05-.017-.034z",
    transform: "translate(-249.449 -447.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34962",
    "data-name": "Path 34962",
    className: "cls-3",
    d: "M250.617 428.4a.128.128 0 0 1 .084.034l-.017.05c-.034-.017-.05-.017-.084-.034z",
    transform: "translate(-247.867 -428.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34963",
    "data-name": "Path 34963",
    className: "cls-3",
    d: "M237.3 448.267l-.034.034c-.017-.017-.034-.05-.067-.067l.034-.033z",
    transform: "translate(-236.714 -444.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34964",
    "data-name": "Path 34964",
    className: "cls-3",
    d: "M236.684 447.384l-.034.017-.05-.067.033-.033z",
    transform: "translate(-236.214 -444.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34965",
    "data-name": "Path 34965",
    className: "cls-3",
    d: "M235.567 445.484l-.034.017a.283.283 0 0 1-.034-.084l.034-.017z",
    transform: "translate(-235.299 -442.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34966",
    "data-name": "Path 34966",
    className: "cls-3",
    d: "M238.967 449.8a.131.131 0 0 1-.067-.067l.034-.034c.017.017.05.034.067.05z",
    transform: "translate(-238.129 -446.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34967",
    "data-name": "Path 34967",
    className: "cls-3",
    d: "M240.784 451.084l-.084-.05.017-.034c.034.017.05.034.084.05z",
    transform: "translate(-239.627 -447.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34968",
    "data-name": "Path 34968",
    className: "cls-3",
    d: "M239.784 450.584a.363.363 0 0 0-.084-.05l.034-.034.084.05z",
    transform: "translate(-238.795 -446.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34969",
    "data-name": "Path 34969",
    className: "cls-3",
    d: "M241.784 451.667c-.034-.017-.067-.017-.084-.034l.017-.033.084.033z",
    transform: "translate(-240.459 -447.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34970",
    "data-name": "Path 34970",
    className: "cls-3",
    d: "M238.1 449.067l-.034.034-.067-.067.034-.034z",
    transform: "translate(-237.38 -445.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34971",
    "data-name": "Path 34971",
    className: "cls-3",
    d: "M250.6 451.85c-.034.017-.067.017-.084.034l-.017-.05c.034-.017.05-.017.084-.033z",
    transform: "translate(-247.784 -447.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34972",
    "data-name": "Path 34972",
    className: "cls-3",
    d: "M254.434 430.65l-.034-.017.034-.034.034.017.034.05-.017.034z",
    transform: "translate(-251.03 -430.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34973",
    "data-name": "Path 34973",
    className: "cls-3",
    d: "M253.534 429.9c.034.017.05.034.084.05l-.034.034c-.034-.017-.05-.034-.084-.05z",
    transform: "translate(-250.281 -429.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34974",
    "data-name": "Path 34974",
    className: "cls-3",
    d: "M255.3 431.333l.034-.033.067.067-.034.034a.13.13 0 0 1-.067-.068z",
    transform: "translate(-251.779 -430.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34975",
    "data-name": "Path 34975",
    className: "cls-3",
    d: "M251.617 428.8c.034.017.05.034.084.034l-.017.034c-.034-.017-.05-.034-.084-.034z",
    transform: "translate(-248.7 -428.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34976",
    "data-name": "Path 34976",
    className: "cls-3",
    d: "M257.3 434.117l.034-.017c.017.034.034.05.05.084l-.034.017a.367.367 0 0 0-.05-.084z",
    transform: "translate(-253.444 -433.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34977",
    "data-name": "Path 34977",
    className: "cls-3",
    d: "M256 432.234l.034-.034c.017.017.034.05.05.067l-.034.034z",
    transform: "translate(-252.362 -431.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34978",
    "data-name": "Path 34978",
    className: "cls-3",
    d: "M246.2 427.85v-.05h.1v.05z",
    transform: "translate(-244.205 -427.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34979",
    "data-name": "Path 34979",
    className: "cls-3",
    d: "M239.884 429.6l.017.034c-.034.017-.05.034-.084.05l-.017-.033a.369.369 0 0 0 .084-.051z",
    transform: "translate(-238.878 -429.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34980",
    "data-name": "Path 34980",
    className: "cls-3",
    d: "M257.8 435.017l.05-.017c.017.034.017.05.034.084l-.034.017z",
    transform: "translate(-253.86 -433.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34981",
    "data-name": "Path 34981",
    className: "cls-3",
    d: "M239.1 430.334c-.017.017-.05.034-.067.05l-.033-.034.067-.05z",
    transform: "translate(-238.212 -429.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34982",
    "data-name": "Path 34982",
    className: "cls-3",
    d: "M256.7 433.117l.034-.017.05.067-.034.034z",
    transform: "translate(-252.945 -432.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34983",
    "data-name": "Path 34983",
    className: "cls-3",
    d: "M240.884 429.1l.017.05c-.034.017-.05.034-.084.034l-.017-.034z",
    transform: "translate(-239.71 -428.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34984",
    "data-name": "Path 34984",
    className: "cls-3",
    d: "M241.984 428.6l.017.05-.084.034-.017-.034a.367.367 0 0 1 .084-.05z",
    transform: "translate(-240.626 -428.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34985",
    "data-name": "Path 34985",
    className: "cls-3",
    d: "M244.1 428.05a.728.728 0 0 0-.084.017l-.017-.05c.034 0 .067-.017.1-.017z",
    transform: "translate(-242.374 -427.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34986",
    "data-name": "Path 34986",
    className: "cls-3",
    d: "M243 428.35c-.034.017-.067.017-.084.034l-.017-.05.084-.034z",
    transform: "translate(-241.458 -428.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34987",
    "data-name": "Path 34987",
    className: "cls-3",
    d: "M258.2 436.117l.05-.017c.017.034.017.067.034.084l-.05.017a.128.128 0 0 0-.034-.084z",
    transform: "translate(-254.193 -434.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34988",
    "data-name": "Path 34988",
    className: "cls-3",
    d: "M258.334 443.8l.05.017a.128.128 0 0 1-.034.084l-.05-.017c.017-.017.017-.05.034-.084z",
    transform: "translate(-254.276 -441.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34989",
    "data-name": "Path 34989",
    className: "cls-3",
    d: "M257.45 445.9l.034.017-.05.084-.034-.017z",
    transform: "translate(-253.527 -442.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34990",
    "data-name": "Path 34990",
    className: "cls-3",
    d: "M258.017 444.9l.05.017c-.017.034-.017.067-.034.084l-.034-.017a.126.126 0 0 1 .018-.084z",
    transform: "translate(-254.027 -442.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34991",
    "data-name": "Path 34991",
    className: "cls-3",
    d: "M258.617 442.7h.05l-.017.1-.05-.017a.125.125 0 0 0 .017-.083z",
    transform: "translate(-254.526 -440.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34992",
    "data-name": "Path 34992",
    className: "cls-3",
    d: "M256.85 446.8l.034.017c-.017.033-.034.05-.05.084l-.034-.034a.234.234 0 0 0 .05-.067z",
    transform: "translate(-253.028 -443.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34993",
    "data-name": "Path 34993",
    className: "cls-3",
    d: "M252.617 429.3l.084.05-.017.034c-.034-.017-.05-.034-.084-.05z",
    transform: "translate(-249.532 -429.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34994",
    "data-name": "Path 34994",
    className: "cls-3",
    d: "M258.817 441.6h.05a.212.212 0 0 1-.017.1h-.05z",
    transform: "translate(-254.693 -439.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34995",
    "data-name": "Path 34995",
    className: "cls-3",
    d: "M255.934 447.934l-.034-.034.034-.033.05-.067.033.034a.293.293 0 0 1-.067.084z",
    transform: "translate(-252.279 -444.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34996",
    "data-name": "Path 34996",
    className: "cls-3",
    d: "M259 440.5h.034v.1H259z",
    transform: "translate(-254.859 -438.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34997",
    "data-name": "Path 34997",
    className: "cls-3",
    d: "M247.117 452.6h.084v.05h-.1z",
    transform: "translate(-244.954 -448.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34998",
    "data-name": "Path 34998",
    className: "cls-3",
    d: "M246.1 452.6h.1v.05h-.1z",
    transform: "translate(-244.122 -448.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34999",
    "data-name": "Path 34999",
    className: "cls-3",
    d: "M258.6 437.117l.05-.017a.213.213 0 0 1 .017.1l-.05.017c0-.033-.017-.067-.017-.1z",
    transform: "translate(-254.526 -435.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35000",
    "data-name": "Path 35000",
    className: "cls-3",
    d: "M258.8 438.3h.05l.017.1h-.05c0-.033-.017-.067-.017-.1z",
    transform: "translate(-254.693 -436.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35001",
    "data-name": "Path 35001",
    className: "cls-3",
    d: "M258.9 439.4h.05v.1h-.05z",
    transform: "translate(-254.776 -437.455)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4740",
    "data-name": "Group 4740",
    transform: "translate(2.221 15.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735",
    transform: "translate(.612 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35002",
    "data-name": "Path 35002",
    className: "cls-3",
    d: "M211.655 509.8l-.335-.3-.419.134-.1.436.319.3.436-.134z",
    transform: "translate(-210.548 -509.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35003",
    "data-name": "Path 35003",
    className: "cls-5",
    d: "M209.835 509.369a.628.628 0 1 0-.469-.754.615.615 0 0 0 .469.754zm-.017.05a.674.674 0 0 1-.5-.8.661.661 0 0 1 .8-.5.671.671 0 1 1-.3 1.308z",
    transform: "translate(-209.298 -508.093)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35004",
    "data-name": "Path 35004",
    className: "cls-3",
    d: "M208.807 481.736l-.469-.436-.587.184-.151.62.453.419.6-.184z",
    transform: "translate(-207.273 -480.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35005",
    "data-name": "Path 35005",
    className: "cls-5",
    d: "M206.379 481.218a.868.868 0 0 0 1.039-.654.893.893 0 0 0-.654-1.056.868.868 0 0 0-1.039.654.877.877 0 0 0 .654 1.056zm-.017.067a.929.929 0 1 1 1.107-.687.916.916 0 0 1-1.107.687z",
    transform: "translate(-205.649 -479.449)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737",
    transform: "translate(4.745 14.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35006",
    "data-name": "Path 35006",
    className: "cls-3",
    d: "M236.338 569.387l-.017-.469-.419-.218-.4.252.034.469.419.218z",
    transform: "translate(-235.24 -568.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35007",
    "data-name": "Path 35007",
    className: "cls-5",
    d: "M234.093 568.482a.634.634 0 0 0 .889.184.651.651 0 0 0 .184-.905.634.634 0 0 0-.889-.184.666.666 0 0 0-.184.905zm-.034.034a.691.691 0 1 1 .956.2.7.7 0 0 1-.955-.201z",
    transform: "translate(-233.951 -567.451)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738",
    "data-name": "Group 4738",
    transform: "translate(2.565 9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35008",
    "data-name": "Path 35008",
    className: "cls-3",
    d: "M222.4 537.669l-.084-.3-.3-.067-.218.218.084.285.3.084z",
    transform: "translate(-221.657 -537.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35009",
    "data-name": "Path 35009",
    className: "cls-5",
    d: "M221.092 537.1a.427.427 0 1 0 0-.6.425.425 0 0 0 0 .6zm-.017.017a.45.45 0 1 1 .637 0 .436.436 0 0 1-.636-.004z",
    transform: "translate(-220.95 -536.35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4739",
    "data-name": "Group 4739",
    transform: "translate(6.54 3.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35010",
    "data-name": "Path 35010",
    className: "cls-3",
    d: "M246.187 498.818l-.218-.218-.285.067-.084.3.2.218.3-.067z",
    transform: "translate(-245.442 -498.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35011",
    "data-name": "Path 35011",
    className: "cls-5",
    d: "M244.986 498.476a.424.424 0 0 0 .52-.285.416.416 0 0 0-.285-.52.419.419 0 0 0-.235.8zm0 .017a.435.435 0 0 1-.3-.553.458.458 0 0 1 .553-.318.446.446 0 0 1 .3.57.435.435 0 0 1-.553.3z",
    transform: "translate(-244.66 -497.605)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35012",
    "data-name": "Path 35012",
    className: "cls-3",
    d: "M214.2 512.934l1.542 4.225.084-.033-1.526-4.226z",
    transform: "translate(-212.766 -507.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35013",
    "data-name": "Path 35013",
    className: "cls-3",
    d: "M209.9 485.817l.687 4.242h.1l-.7-4.258z",
    transform: "translate(-209.187 -484.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35014",
    "data-name": "Path 35014",
    className: "cls-3",
    d: "M214.3 502.344l.017.05 5.415-1.861-.017-.034z",
    transform: "translate(-212.85 -496.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35015",
    "data-name": "Path 35015",
    className: "cls-3",
    d: "M212.2 486.734l5.868 2.146.017-.034-5.868-2.146z",
    transform: "translate(-211.102 -485.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35016",
    "data-name": "Path 35016",
    className: "cls-3",
    d: "M223.2 539.017l2.5 5.147.034-.017-2.5-5.147z",
    transform: "translate(-220.258 -529.016)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4747",
    "data-name": "Group 4747",
    transform: "translate(9.219 14.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4741",
    "data-name": "Group 4741",
    transform: "translate(0 19.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35017",
    "data-name": "Path 35017",
    className: "cls-3",
    d: "M251.1 593.878l1.14.2.738-.888-.386-1.09-1.157-.2-.738.889z",
    transform: "translate(-250.145 -591.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35018",
    "data-name": "Path 35018",
    className: "cls-5",
    d: "M248.533 588.395a1.623 1.623 0 0 0-.956 2.062 1.591 1.591 0 1 0 2.984-1.106 1.554 1.554 0 0 0-2.028-.956zm-.034-.1a1.716 1.716 0 1 1-1.006 2.2 1.722 1.722 0 0 1 1.007-2.201z",
    transform: "translate(-247.391 -588.192)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35019",
    "data-name": "Path 35019",
    className: "cls-3",
    d: "M261.2 598.934l17.436 2.833.017-.151-17.436-2.816z",
    transform: "translate(-258.885 -577.243)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4742",
    "data-name": "Group 4742",
    transform: "translate(7.568 7.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35020",
    "data-name": "Path 35020",
    className: "cls-3",
    d: "M295.172 516.6l-.62.05-.251.57.352.5.62-.05.251-.57z",
    transform: "translate(-294.003 -516.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35021",
    "data-name": "Path 35021",
    className: "cls-5",
    d: "M293.934 516.069a.861.861 0 0 0 .2-1.207.841.841 0 0 0-1.19-.2.861.861 0 0 0-.2 1.207.871.871 0 0 0 1.19.2zm.034.05a.915.915 0 0 1-1.274-.235.95.95 0 0 1 .218-1.291.927.927 0 0 1 1.274.218.937.937 0 0 1-.219 1.308z",
    transform: "translate(-292.531 -514.431)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743",
    transform: "translate(2.218 3.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35022",
    "data-name": "Path 35022",
    className: "cls-3",
    d: "M264.324 492.5l-.855.067-.369.8.5.7.855-.084.369-.788z",
    transform: "translate(-262.685 -492.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35023",
    "data-name": "Path 35023",
    className: "cls-5",
    d: "M262.6 491.8a1.207 1.207 0 0 0 .285-1.677 1.223 1.223 0 0 0-1.677-.3 1.207 1.207 0 0 0-.285 1.676 1.193 1.193 0 0 0 1.677.301zm.033.067a1.271 1.271 0 0 1-1.777-.318 1.291 1.291 0 0 1 .319-1.794 1.271 1.271 0 0 1 1.777.319 1.294 1.294 0 0 1-.322 1.792z",
    transform: "translate(-260.622 -489.522)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744",
    transform: "translate(2.025 10.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35024",
    "data-name": "Path 35024",
    className: "cls-3",
    d: "M262.657 534.569l-.5-.369-.57.235-.084.62.5.385.57-.251z",
    transform: "translate(-261.16 -533.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35025",
    "data-name": "Path 35025",
    className: "cls-5",
    d: "M260.281 534.138a.865.865 0 0 0 .956-.754.842.842 0 0 0-.754-.956.854.854 0 0 0-.956.755.875.875 0 0 0 .754.955zm0 .05a.933.933 0 0 1-.8-1.023.912.912 0 0 1 1.023-.8.933.933 0 0 1 .8 1.023.912.912 0 0 1-1.023.8z",
    transform: "translate(-259.471 -532.353)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4745",
    "data-name": "Group 4745",
    transform: "translate(14.067 10.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35026",
    "data-name": "Path 35026",
    className: "cls-3",
    d: "M333.438 531.7l-.369-.2-.369.235.034.436.369.184.352-.235z",
    transform: "translate(-332.465 -531.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35027",
    "data-name": "Path 35027",
    className: "cls-5",
    d: "M331.95 531.6a.6.6 0 0 0 .553-.62.585.585 0 0 0-.62-.553.588.588 0 0 0 .067 1.174zm0 .034a.631.631 0 0 1-.654-.587.62.62 0 0 1 .587-.654.621.621 0 1 1 .067 1.241z",
    transform: "translate(-331.296 -530.396)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4746",
    "data-name": "Group 4746",
    transform: "translate(11.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35028",
    "data-name": "Path 35028",
    className: "cls-3",
    d: "M315.32 471.7l-.419.017-.2.369.218.369.419-.034.2-.369z",
    transform: "translate(-314.502 -471.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35029",
    "data-name": "Path 35029",
    className: "cls-5",
    d: "M314.456 471.34a.584.584 0 1 0-.8-.184.592.592 0 0 0 .8.184zm.017.034a.621.621 0 1 1 .2-.855.641.641 0 0 1-.201.854z",
    transform: "translate(-313.52 -470.22)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35030",
    "data-name": "Path 35030",
    className: "cls-3",
    d: "M266.337 521.667l-.134-.067-6.1 12.289.134.067z",
    transform: "translate(-257.969 -512.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35031",
    "data-name": "Path 35031",
    className: "cls-3",
    d: "M271.841 534.2L259.2 544.477l.034.033 12.641-10.277z",
    transform: "translate(-257.22 -523.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35032",
    "data-name": "Path 35032",
    className: "cls-3",
    d: "M299.8 519.234l5.734 2.313.05-.134-5.734-2.313z",
    transform: "translate(-291.014 -510.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35033",
    "data-name": "Path 35033",
    className: "cls-3",
    d: "M259.9 548.4l.2.017.771-9.321h-.2z",
    transform: "translate(-257.803 -527.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35034",
    "data-name": "Path 35034",
    className: "cls-3",
    d: "M266.3 522.7l4.862-2.833-.1-.168-4.862 2.833z",
    transform: "translate(-263.047 -511.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35035",
    "data-name": "Path 35035",
    className: "cls-3",
    d: "M264.8 506.069h.134l.2-6.069H265z",
    transform: "translate(-261.881 -495.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35036",
    "data-name": "Path 35036",
    className: "cls-3",
    d: "M268 498.817l4.979 3.183.084-.1-5-3.2z",
    transform: "translate(-264.545 -493.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35037",
    "data-name": "Path 35037",
    className: "cls-3",
    d: "M298.3 482.11l.05.017 3.085-7.31-.05-.017z",
    transform: "translate(-289.765 -474.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35038",
    "data-name": "Path 35038",
    className: "cls-3",
    d: "M271.034 477.341l7.578-4.091-.017-.05-7.595 4.091z",
    transform: "translate(-267.042 -472.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752",
    transform: "translate(0 21.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748",
    transform: "translate(7.907 11.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35039",
    "data-name": "Path 35039",
    className: "cls-3",
    d: "M243.259 580.387l-.469-.587-.721.151-.268.721.469.587.721-.134z",
    transform: "translate(-241.425 -579.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35040",
    "data-name": "Path 35040",
    className: "cls-5",
    d: "M240.29 579.537a1.041 1.041 0 0 0 1.324-.637 1.054 1.054 0 0 0-.587-1.358 1.027 1.027 0 0 0-1.324.637 1.067 1.067 0 0 0 .587 1.358zm-.017.067a1.134 1.134 0 0 1-.637-1.459 1.1 1.1 0 1 1 2.062.771 1.129 1.129 0 0 1-1.424.684z",
    transform: "translate(-239.563 -577.389)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749",
    transform: "translate(10.327 6.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35041",
    "data-name": "Path 35041",
    className: "cls-3",
    d: "M256.989 551.785l-.5-.285-.486.318.017.587.5.285.486-.3z",
    transform: "translate(-255.664 -551.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35042",
    "data-name": "Path 35042",
    className: "cls-5",
    d: "M254.852 551.591a.817.817 0 0 0 .771-.838.8.8 0 0 0-.8-.8.818.818 0 0 0-.771.838.827.827 0 0 0 .8.8zm0 .05a.873.873 0 1 1 .822-.889.86.86 0 0 1-.822.889z",
    transform: "translate(-253.997 -549.897)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35043",
    "data-name": "Path 35043",
    className: "cls-3",
    d: "M192.534 586.919l1.039-8.818-.134.033-1.039 8.8z",
    transform: "translate(-192.4 -566.937)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750",
    transform: "translate(7.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35044",
    "data-name": "Path 35044",
    className: "cls-3",
    d: "M240.055 513.42l-.05-.453-.436-.168-.369.3.067.453.419.151z",
    transform: "translate(-238.949 -512.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35045",
    "data-name": "Path 35045",
    className: "cls-5",
    d: "M237.868 512.584a.619.619 0 0 0 .889.084.622.622 0 1 0-.754-.989.665.665 0 0 0-.135.905zm-.034.034a.693.693 0 0 1 .134-.956.686.686 0 0 1 .956.1.693.693 0 0 1-.134.956.686.686 0 0 1-.955-.101z",
    transform: "translate(-237.701 -511.513)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35046",
    "data-name": "Path 35046",
    className: "cls-3",
    d: "M244.2 523.27l-2.582-6.17-.117.05 2.582 6.17z",
    transform: "translate(-233.268 -516.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35047",
    "data-name": "Path 35047",
    className: "cls-3",
    d: "M241.95 517.1h-.05l.335 10.83h.05z",
    transform: "translate(-233.601 -516.163)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751",
    transform: "translate(9.187 7.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35048",
    "data-name": "Path 35048",
    className: "cls-5",
    d: "M247.25 560.041l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.067-.151l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.067-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.067-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.067-.151l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.067-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.134l-.034-.017.034-.1.05.017zm.067-.151l-.05-.017.034-.1.05.017zm.05-.134l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017zm.05-.151l-.05-.017.034-.1.05.017z",
    transform: "translate(-247.2 -555.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35049",
    "data-name": "Path 35049",
    className: "cls-3",
    d: "M205.361 584.384l-.084-.084-7.477 8.4.1.084z",
    transform: "translate(-196.895 -572.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35050",
    "data-name": "Path 35050",
    className: "cls-3",
    d: "M209.873 576.46l-6.773-1.76v.05l6.756 1.76z",
    transform: "translate(-201.306 -564.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35051",
    "data-name": "Path 35051",
    className: "cls-3",
    d: "M203.577 516h-.05l-7.427 8.215.05-.017z",
    transform: "translate(-195.48 -515.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_270",
    "data-name": "Line 270",
    className: "cls-3",
    transform: "translate(1.006 .668)",
    d: "M6.991 0L0 20.018"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4779",
    "data-name": "Group 4779",
    transform: "translate(26.12 12.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754",
    transform: "translate(0 3.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35052",
    "data-name": "Path 35052",
    className: "cls-5",
    d: "M368.792 483.548l-12.292-1.073.872.956.017-.05.05.017c0 .034-.017.05-.034.084l1.14 1.241.017.017v.017l.05.05.017-.05.117.05-.017.05-.084-.033 1.123 1.224 4.845 2.833 4.342-5.03a1.015 1.015 0 0 1-.163-.303zm.033-.151l.453.034-.067-.755.754-.486.838.419.067.905-.05.033-.57.369.3.352a1.146 1.146 0 0 0 .637-.587 1.278 1.278 0 0 0-.6-1.693 1.261 1.261 0 0 0-1.71.537 1.558 1.558 0 0 0-.052.875zm1.744.972a1.4 1.4 0 0 1-.251.067l1.174 4.091 1.66-1.207zm2.666 2.951l1.291 1.475 1.056-2.23a1.159 1.159 0 0 1-.369-.268.913.913 0 0 1-.184-.3zm1.827-1.425l.218-.151-.084-.033.034-.05.084.034.184-.6.687-.134.469.536-.2.671-.436.084.134.352a.97.97 0 1 0-.8-1.693.867.867 0 0 0-.29.989zm.687.671a.981.981 0 0 0 .218.034l-.1-.268zm-.436-.788l-.235.168a.977.977 0 0 0 .184.3.857.857 0 0 0 .352.251l.117-.268zm.671.872a1.461 1.461 0 0 1-.268-.034l-1.09 2.3 3.755 4.275.017-.017zm2.582 6.522l.084.235.453-.033.319.453-.235.5-.553.05-.251-.352-.235.117a.776.776 0 0 0 .788.486.756.756 0 0 0 .7-.822.77.77 0 0 0-.838-.687.535.535 0 0 0-.232.053zm-.5.922c0-.034-.017-.05-.017-.084l-3.856.017c0 .017 0 .034-.017.034a1.348 1.348 0 0 1-1.693.872 1.248 1.248 0 0 1-.419-.218l-.888 1.391a1.431 1.431 0 0 1 .419.218 1.725 1.725 0 0 1 .57.637zm-5.968 2.984l-.4.2-.067 1.09-1.023.469-.956-.654.067-1.056-.386-.285a1.592 1.592 0 0 0 .486 2.146 1.527 1.527 0 0 0 2.28-1.911zm-7.7-4.007l4.929 3.588.034-.05-3.454-3.772-1.475-.151c-.016.114-.016.251-.032.385zm-.184.067l-.671-.486-.62 1.358-1.66.151-.956-1.375.654-1.442-.386-.553a2.343 2.343 0 0 0-.5 3.185 2.293 2.293 0 0 0 3.2.553 2.231 2.231 0 0 0 .94-1.391zm-4.46-7.025l-3.705-2.18.486.7c.017-.017.05-.034.067-.05l.034.05c-.017.017-.05.034-.067.067l4.057 5.885a2.4 2.4 0 0 1 2.6-.05l.268-.319zm4.828 2.833l-4.661-2.733 3.6 3.94zm.05.034l-1.056 1.224 1.358 1.475 2.414-1.107zm5.667-4.627l.2-.05-.251-.285.017.218zm1.14 4.208l-1.157-4.04.235 3.923a.8.8 0 0 1 .62.352zm.017.067l-.3.218c0 .017.017.017.017.034a.748.748 0 0 1-.05.771l.738.419zm3.051.235l-1.308-1.509-1.677 1.224.436 1.542 1.542.889zm3.923 4.392v-.017zm-.05.017a.81.81 0 0 0-.252.369l.235.134.151-.318-.017-.05zm-.268.738a.127.127 0 0 0 .017.067l.134-.067zm.218-.168l-.235-.134c0 .05-.017.084-.017.134zm-.285.017a.571.571 0 0 1 .017-.168l-4.46-2.548-.57 1.207a1.019 1.019 0 0 1 .218.05 1.376 1.376 0 0 1 .972 1.475zm-6.052.7l.2-.319-.2-.771-.386-.034a1.228 1.228 0 0 0 .387 1.128zm-4.409-3.923l4.074 2.381a1.281 1.281 0 0 1 .721-.6l-1.375-2.6a.846.846 0 0 1-1.274-.168zm3.5-1.827a.734.734 0 0 0-.57-.335l.017.235.352.235zm0 .821a.767.767 0 0 0 .05-.738c0-.017-.017-.017-.017-.033l-.184.134-.05.52zm-.117.134l-.117-.218-.469.235-.386-.252-.235.1a.771.771 0 0 0 .989.285.426.426 0 0 0 .222-.146zm.084-.084l-.1-.05.067.117c.02-.029.02-.047.037-.063zm.838.469l-.8-.453a.3.3 0 0 1-.067.084l1.392 2.615c.034-.017.067-.017.1-.034zm.972 2.18l.6-1.274-1.492-.855.62 2.163a1.3 1.3 0 0 1 .277-.03zm-.034.084a.954.954 0 0 0-.218.017l.084.268zm-.285.034l-.084.017.168.319zm-.822.62l.369.218.5-.453-.184-.335a1.279 1.279 0 0 0-.679.574zm.3.251l-.335-.2c-.017.05-.05.1-.067.151zm2.112.553a1.275 1.275 0 0 0-.905-1.391c-.084-.017-.151-.034-.235-.05l-.184.4.738.218.2.821zm-4.325-4.946l-.05-.017a.79.79 0 0 0-.05.587l.235-.1.034-.4-.117-.034.017-.067.117.034.386-.2-.017-.252a1.4 1.4 0 0 0-.251.067.7.7 0 0 0-.319.3l.034.017zm-3.973 3.739l5.717.6c.017-.067.05-.134.067-.184l-4.107-2.414-2.465 1.14zm-1.425-.151l1.324.134-.754-.822-.62.285a1.653 1.653 0 0 1 .057.408zm-.654.084l.486.352a1.819 1.819 0 0 0 .017-.3zm.5-.1a2.056 2.056 0 0 0-.034-.319l-.553.252zm-.285-1.291a2.215 2.215 0 0 1 .352.754l.553-.251-1.341-1.459-.251.3a2.807 2.807 0 0 1 .697.66zm-.453 1.123l.671-.3a2.642 2.642 0 0 0-.335-.738 2.416 2.416 0 0 0-.671-.637l-.453.537zm-.855-1.207l.017.034.436-.5a2.318 2.318 0 0 0-2.414.067l.386.553zm8.349 4.946l.922-1.442a1.306 1.306 0 0 1-.419-1.207l-5.516-.587 3.4 3.722a1.647 1.647 0 0 1 1.623-.482zm-.067.1a1.568 1.568 0 0 0-1.492.469l.335.369.872-.4zm1.123.855a1.669 1.669 0 0 0-.536-.6 1.6 1.6 0 0 0-.419-.2l-.285.436.838.57zm-2.481-.168l-.168-.184c-.017.017-.017.034-.034.034zm4.51-2.833h-.436l-.57.52-.754-.235-.218.335a1.506 1.506 0 0 0 .4.2 1.236 1.236 0 0 0 1.576-.821zm.5-5.046l-.989 2.1 4.443 2.548a.894.894 0 0 1 .268-.386zm-5.4-5.382l-.319-.034a1.844 1.844 0 0 0 .134.252zm-.151.251a1.221 1.221 0 0 0 .453.369 1.19 1.19 0 0 0 .62.134l-.017-.352-.8-.4h-.017zm-3.051 3.688l-.084-.033-1.241 1.425 2.749 1.609 2.23-1.023a.8.8 0 0 1 .05-.62h.002l.017-.05h.017a.812.812 0 0 1 .352-.318.829.829 0 0 1 .268-.084l-.235-3.99a1.493 1.493 0 0 1-.654-.151 1.524 1.524 0 0 1-.469-.385l-3.051 3.521.067.034zm-9.556-5.029l-.52 1.257.084.034-.017.033.05.034.017-.05.117.034-.017.05-.084-.033.822.486-.034-.034.084-.1.05.034a.2.2 0 0 1-.084.084l2.7 1.593-1.073-1.174-.084-.034.017-.034zm-2.6-1.291l1.66-.218 1.006 1.324 12.222 1.073a1.413 1.413 0 0 1 .084-.905 1.341 1.341 0 0 1 1.811-.57 1.357 1.357 0 0 1 .637 1.794l.067.034-.034.05-.084-.034a1.313 1.313 0 0 1-.637.57l2.565 2.934 1.811-1.324a.9.9 0 0 1-.067-.369l-.084-.034.034-.05.05.034a1.014 1.014 0 0 1 .319-.687 1.038 1.038 0 0 1 1.459.117 1.052 1.052 0 0 1-.05 1.475.92.92 0 0 1-.52.235l2.4 6.471a.963.963 0 0 1 .235-.067.838.838 0 0 1 .905.721.83.83 0 0 1-1.593.369l-5.9 2.884a1.647 1.647 0 0 1-.1 1.643 1.681 1.681 0 0 1-2.347.4 1.7 1.7 0 0 1-.52-2.3l-4.828-3.554a2.459 2.459 0 0 1-4.392.838 2.486 2.486 0 0 1 .536-3.4l-4.677-6.773-1.609.2-.997-1.334z",
    transform: "translate(-352.362 -479.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35053",
    "data-name": "Path 35053",
    className: "cls-3",
    d: "M379 491.117h.067c0-.034.017-.084.017-.117h-.067a.285.285 0 0 0-.017.117z",
    transform: "translate(-373.836 -488.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35054",
    "data-name": "Path 35054",
    className: "cls-3",
    d: "M378.867 492.534c0-.034.017-.084.017-.117l-.067-.017-.017.117z",
    transform: "translate(-373.67 -489.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35055",
    "data-name": "Path 35055",
    className: "cls-3",
    d: "M378.55 494.034c.017-.034.017-.084.034-.117l-.05-.017c-.017.034-.017.084-.034.117z",
    transform: "translate(-373.42 -490.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35056",
    "data-name": "Path 35056",
    className: "cls-3",
    d: "M352.017 477.95l-.034-.05c-.034.033-.067.05-.084.084l.034.05z",
    transform: "translate(-351.28 -477.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35057",
    "data-name": "Path 35057",
    className: "cls-3",
    d: "M350.934 479.034l-.05-.034c-.034.034-.05.067-.084.084l.05.034z",
    transform: "translate(-350.364 -478.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35058",
    "data-name": "Path 35058",
    className: "cls-3",
    d: "M371.3 476.217l.034-.05c-.034-.017-.067-.05-.1-.067l-.034.05a.348.348 0 0 1 .1.067z",
    transform: "translate(-367.344 -475.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35059",
    "data-name": "Path 35059",
    className: "cls-3",
    d: "M350.017 480.133l-.05-.034a.352.352 0 0 0-.067.1l.05.034z",
    transform: "translate(-349.615 -479.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35060",
    "data-name": "Path 35060",
    className: "cls-3",
    d: "M349.217 481.333l-.05-.033c-.017.033-.05.067-.067.1l.05.033a.353.353 0 0 1 .067-.1z",
    transform: "translate(-348.949 -480.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35061",
    "data-name": "Path 35061",
    className: "cls-3",
    d: "M348.45 482.6a.813.813 0 0 0-.05.117l.05.017.05-.1z",
    transform: "translate(-348.367 -481.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35062",
    "data-name": "Path 35062",
    className: "cls-3",
    d: "M376 499.3l.05.034c.017-.034.05-.067.067-.1l-.05-.034a.352.352 0 0 0-.067.1z",
    transform: "translate(-371.339 -494.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35063",
    "data-name": "Path 35063",
    className: "cls-3",
    d: "M354.634 476.05l-.034-.05a.352.352 0 0 0-.1.067l.034.05a.354.354 0 0 1 .1-.067z",
    transform: "translate(-353.444 -475.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35064",
    "data-name": "Path 35064",
    className: "cls-3",
    d: "M355.851 475.35l-.034-.05-.117.05.034.05c.033-.016.083-.033.117-.05z",
    transform: "translate(-354.443 -475.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35065",
    "data-name": "Path 35065",
    className: "cls-3",
    d: "M357.234 474.767l-.017-.067c-.034.017-.084.034-.117.05l.017.05a.425.425 0 0 1 .117-.033z",
    transform: "translate(-355.608 -474.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35066",
    "data-name": "Path 35066",
    className: "cls-3",
    d: "M358.634 474.35l-.017-.05c-.034.017-.084.017-.117.033l.017.067z",
    transform: "translate(-356.773 -474.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35067",
    "data-name": "Path 35067",
    className: "cls-3",
    d: "M360.034 474.067l-.017-.067c-.034 0-.084.017-.117.017l.017.05z",
    transform: "translate(-357.939 -473.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35068",
    "data-name": "Path 35068",
    className: "cls-3",
    d: "M378.4 485.217c-.017-.034-.017-.084-.034-.117l-.067.017c.017.034.017.084.034.117z",
    transform: "translate(-373.254 -483.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35069",
    "data-name": "Path 35069",
    className: "cls-3",
    d: "M377.55 496.734c.017-.034.034-.084.05-.117l-.05-.017-.05.117z",
    transform: "translate(-372.588 -492.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35070",
    "data-name": "Path 35070",
    className: "cls-3",
    d: "M361.617 473.867v-.067a.286.286 0 0 0-.117.017v.067c.034 0 .067-.017.117-.017z",
    transform: "translate(-359.27 -473.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35071",
    "data-name": "Path 35071",
    className: "cls-3",
    d: "M369.917 475.5l.034-.05a.815.815 0 0 0-.117-.05l-.034.05a.807.807 0 0 1 .117.05z",
    transform: "translate(-366.179 -475.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35072",
    "data-name": "Path 35072",
    className: "cls-3",
    d: "M365.917 474.184l.017-.067-.117-.017-.017.067a.285.285 0 0 1 .117.017z",
    transform: "translate(-362.849 -474.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35073",
    "data-name": "Path 35073",
    className: "cls-3",
    d: "M368.617 474.9l.017-.05-.117-.05-.017.05a.819.819 0 0 1 .117.05z",
    transform: "translate(-365.097 -474.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35074",
    "data-name": "Path 35074",
    className: "cls-3",
    d: "M367.317 474.4l.017-.067c-.034-.017-.084-.017-.117-.034l-.017.067a1.07 1.07 0 0 0 .117.034z",
    transform: "translate(-364.015 -474.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35075",
    "data-name": "Path 35075",
    className: "cls-3",
    d: "M363.017 473.867v-.067h-.117v.067z",
    transform: "translate(-360.436 -473.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35076",
    "data-name": "Path 35076",
    className: "cls-3",
    d: "M364.517 473.884v-.067c-.034 0-.084-.017-.117-.017v.067a.25.25 0 0 0 .117.017z",
    transform: "translate(-361.684 -473.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35077",
    "data-name": "Path 35077",
    className: "cls-3",
    d: "M348.2 496.817c.017.034.034.084.05.117l.05-.034-.05-.1z",
    transform: "translate(-348.2 -492.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35078",
    "data-name": "Path 35078",
    className: "cls-3",
    d: "M371.8 503.367l.034.05c.034-.017.067-.05.1-.067l-.034-.05c-.033.017-.066.05-.1.067z",
    transform: "translate(-367.843 -498.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35079",
    "data-name": "Path 35079",
    className: "cls-3",
    d: "M378.984 488.217c0-.034-.017-.084-.017-.117l-.067.017.017.117z",
    transform: "translate(-373.753 -485.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35080",
    "data-name": "Path 35080",
    className: "cls-3",
    d: "M378.784 486.717c0-.034-.017-.084-.017-.117l-.067.017a.285.285 0 0 1 .017.117z",
    transform: "translate(-373.587 -484.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35081",
    "data-name": "Path 35081",
    className: "cls-3",
    d: "M370.5 504.067l.034.05a.35.35 0 0 0 .1-.067l-.034-.05a.35.35 0 0 1-.1.067z",
    transform: "translate(-366.761 -498.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35082",
    "data-name": "Path 35082",
    className: "cls-3",
    d: "M367.9 505.482l.017.067c.034-.017.084-.017.117-.034l-.017-.05a.138.138 0 0 0-.117.017z",
    transform: "translate(-364.597 -500.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35083",
    "data-name": "Path 35083",
    className: "cls-3",
    d: "M366.5 505.734l.017.067c.034-.017.084-.017.117-.034l-.017-.067z",
    transform: "translate(-363.432 -500.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35084",
    "data-name": "Path 35084",
    className: "cls-3",
    d: "M369.2 504.85l.017.05a.822.822 0 0 1 .117-.05l-.034-.05z",
    transform: "translate(-365.679 -499.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35085",
    "data-name": "Path 35085",
    className: "cls-3",
    d: "M352.9 476.817l.034.05.05-.05c.034-.017.067-.05.1-.067l-.034-.05c-.034.017-.067.05-.1.067z",
    transform: "translate(-352.112 -476.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35086",
    "data-name": "Path 35086",
    className: "cls-3",
    d: "M377.217 482.517a.956.956 0 0 0-.067-.117l-.05.034.05.1z",
    transform: "translate(-372.255 -480.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35087",
    "data-name": "Path 35087",
    className: "cls-3",
    d: "M377.9 483.817c-.017-.034-.034-.084-.05-.117l-.05.017c.017.034.034.084.05.117z",
    transform: "translate(-372.837 -482.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35088",
    "data-name": "Path 35088",
    className: "cls-3",
    d: "M376.517 481.3l-.067-.1-.05.034c.017.034.05.067.067.1z",
    transform: "translate(-371.672 -479.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35089",
    "data-name": "Path 35089",
    className: "cls-3",
    d: "M374.684 479.017l.05-.034c-.034-.033-.05-.067-.084-.084l-.05.034c.034.017.05.051.084.084z",
    transform: "translate(-370.174 -478.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35090",
    "data-name": "Path 35090",
    className: "cls-3",
    d: "M373.6 477.934l.034-.05c-.034-.034-.067-.05-.1-.084l-.033.05a.445.445 0 0 1 .099.084z",
    transform: "translate(-369.258 -477.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35091",
    "data-name": "Path 35091",
    className: "cls-3",
    d: "M375.55 480l.034.033.05-.033-.034-.034-.05-.067-.05.05z",
    transform: "translate(-370.923 -478.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35092",
    "data-name": "Path 35092",
    className: "cls-3",
    d: "M372.5 477.017l.034-.05c-.034-.017-.067-.05-.1-.067l-.034.05c.034.017.067.05.1.067z",
    transform: "translate(-368.343 -476.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35093",
    "data-name": "Path 35093",
    className: "cls-3",
    d: "M349.7 499.334c.017.034.05.067.067.1l.05-.033c-.017-.034-.05-.067-.067-.1z",
    transform: "translate(-349.448 -495.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35094",
    "data-name": "Path 35094",
    className: "cls-3",
    d: "M351.55 501.5l-.05.05c.034.034.067.05.084.084l.034-.05c-.001-.017-.034-.051-.068-.084z",
    transform: "translate(-350.947 -496.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35095",
    "data-name": "Path 35095",
    className: "cls-3",
    d: "M353.833 503.4l-.034.05.1.067.034-.05c-.033-.017-.066-.05-.1-.067z",
    transform: "translate(-352.861 -498.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35096",
    "data-name": "Path 35096",
    className: "cls-3",
    d: "M352.733 502.5l-.034.05c.034.034.067.05.1.084l.034-.05c-.033-.034-.066-.051-.1-.084z",
    transform: "translate(-351.946 -497.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35097",
    "data-name": "Path 35097",
    className: "cls-3",
    d: "M355.134 504.2l-.034.05a.944.944 0 0 1 .117.067l.034-.05a.955.955 0 0 0-.117-.067z",
    transform: "translate(-353.943 -499.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35098",
    "data-name": "Path 35098",
    className: "cls-3",
    d: "M376.8 498l.05.034a.352.352 0 0 1 .067-.1l-.05-.033a.35.35 0 0 0-.067.099z",
    transform: "translate(-372.005 -493.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35099",
    "data-name": "Path 35099",
    className: "cls-3",
    d: "M348.9 498.133a.352.352 0 0 0 .067.1l.05-.034a.352.352 0 0 0-.067-.1z",
    transform: "translate(-348.783 -494.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35100",
    "data-name": "Path 35100",
    className: "cls-3",
    d: "M356.417 504.8l-.017.05c.034.017.084.034.117.05l.017-.067a.426.426 0 0 1-.117-.033z",
    transform: "translate(-355.025 -499.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35101",
    "data-name": "Path 35101",
    className: "cls-3",
    d: "M350.65 500.5l-.05.034.084.1.034-.05z",
    transform: "translate(-350.198 -496.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35102",
    "data-name": "Path 35102",
    className: "cls-3",
    d: "M363.6 506.263v.067h.134v-.067a.358.358 0 0 0-.134 0z",
    transform: "translate(-361.018 -500.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35103",
    "data-name": "Path 35103",
    className: "cls-3",
    d: "M357.817 505.4l-.017.067a.31.31 0 0 0 .117.034l.017-.05z",
    transform: "translate(-356.19 -500.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35104",
    "data-name": "Path 35104",
    className: "cls-3",
    d: "M359.217 505.8l-.017.067c.034.017.084.017.117.033l.017-.067a1.079 1.079 0 0 1-.117-.033z",
    transform: "translate(-357.356 -500.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35105",
    "data-name": "Path 35105",
    className: "cls-3",
    d: "M374 501.484l.05.05.084-.084-.05-.05a.2.2 0 0 1-.084.084z",
    transform: "translate(-369.674 -496.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35106",
    "data-name": "Path 35106",
    className: "cls-3",
    d: "M362.1 506.2v.067h.117v-.067a.142.142 0 0 1-.117 0z",
    transform: "translate(-359.77 -500.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35107",
    "data-name": "Path 35107",
    className: "cls-3",
    d: "M365 506.117v.067l.117-.017-.017-.067a.294.294 0 0 0-.1.017z",
    transform: "translate(-362.183 -500.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35108",
    "data-name": "Path 35108",
    className: "cls-3",
    d: "M360.7 506.1v.067l.117.017v-.067a.284.284 0 0 0-.117-.017z",
    transform: "translate(-358.604 -500.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35109",
    "data-name": "Path 35109",
    className: "cls-3",
    d: "M373.317 499l.034-.05-.117-.05-.034.067z",
    transform: "translate(-369.009 -494.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35110",
    "data-name": "Path 35110",
    className: "cls-3",
    d: "M447.6 526.3l.034-.05-.117-.05-.017.05z",
    transform: "translate(-430.852 -517.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35111",
    "data-name": "Path 35111",
    className: "cls-3",
    d: "M449.617 527.1l.017-.067-.117-.033-.017.05z",
    transform: "translate(-432.517 -518.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35112",
    "data-name": "Path 35112",
    className: "cls-3",
    d: "M450.617 527.4l.033-.05-.117-.05-.034.067z",
    transform: "translate(-433.349 -518.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35113",
    "data-name": "Path 35113",
    className: "cls-3",
    d: "M448.617 526.7l.017-.067-.117-.033-.017.05z",
    transform: "translate(-431.685 -517.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35114",
    "data-name": "Path 35114",
    className: "cls-3",
    d: "M372.317 498.6l.017-.05-.1-.05-.034.067z",
    transform: "translate(-368.176 -494.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35115",
    "data-name": "Path 35115",
    className: "cls-3",
    d: "M371.317 498.3l.017-.067-.117-.034-.017.05z",
    transform: "translate(-367.344 -494.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35116",
    "data-name": "Path 35116",
    className: "cls-3",
    d: "M377.517 500.5l.017-.05-.117-.05-.017.067z",
    transform: "translate(-372.505 -495.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35117",
    "data-name": "Path 35117",
    className: "cls-3",
    d: "M381.617 502.1l.017-.067-.117-.034-.017.05z",
    transform: "translate(-375.917 -497.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35118",
    "data-name": "Path 35118",
    className: "cls-3",
    d: "M382.617 502.4l.017-.05-.1-.05-.034.067z",
    transform: "translate(-376.75 -497.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35119",
    "data-name": "Path 35119",
    className: "cls-3",
    d: "M383.7 502.8l.034-.05-.117-.05-.017.067z",
    transform: "translate(-377.665 -497.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35120",
    "data-name": "Path 35120",
    className: "cls-3",
    d: "M375.333 499.7l-.034.05.117.05.017-.067z",
    transform: "translate(-370.757 -495.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35121",
    "data-name": "Path 35121",
    className: "cls-3",
    d: "M380.617 501.7l.017-.067-.117-.033-.017.05z",
    transform: "translate(-375.085 -496.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35122",
    "data-name": "Path 35122",
    className: "cls-3",
    d: "M374.317 499.3l-.017.05.117.05.017-.05z",
    transform: "translate(-369.924 -495.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35123",
    "data-name": "Path 35123",
    className: "cls-3",
    d: "M376.417 500.2l.034-.067-.117-.034-.034.05z",
    transform: "translate(-371.589 -495.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35124",
    "data-name": "Path 35124",
    className: "cls-3",
    d: "M378.517 500.9l.017-.05-.117-.05-.017.067z",
    transform: "translate(-373.337 -496.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35125",
    "data-name": "Path 35125",
    className: "cls-3",
    d: "M379.517 501.3l.017-.067-.1-.034-.034.05z",
    transform: "translate(-374.169 -496.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35126",
    "data-name": "Path 35126",
    className: "cls-3",
    d: "M439.317 523.3l.017-.067-.117-.034-.017.05z",
    transform: "translate(-423.944 -514.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35127",
    "data-name": "Path 35127",
    className: "cls-3",
    d: "M405.317 510.8l.017-.067-.117-.034-.017.05z",
    transform: "translate(-395.644 -504.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35128",
    "data-name": "Path 35128",
    className: "cls-3",
    d: "M406.317 511.1l.017-.05-.1-.05-.034.067z",
    transform: "translate(-396.476 -504.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35129",
    "data-name": "Path 35129",
    className: "cls-3",
    d: "M407.417 511.5l.017-.05-.117-.05-.017.067z",
    transform: "translate(-397.392 -505.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35130",
    "data-name": "Path 35130",
    className: "cls-3",
    d: "M408.417 511.9l.017-.05-.117-.05-.017.067z",
    transform: "translate(-398.224 -505.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35131",
    "data-name": "Path 35131",
    className: "cls-3",
    d: "M402.217 509.6l.017-.05-.117-.05-.017.067z",
    transform: "translate(-393.064 -503.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35132",
    "data-name": "Path 35132",
    className: "cls-3",
    d: "M404.317 510.4l.017-.067-.117-.034-.017.05z",
    transform: "translate(-394.812 -504.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35133",
    "data-name": "Path 35133",
    className: "cls-3",
    d: "M403.217 510l.034-.05-.117-.05-.034.067z",
    transform: "translate(-393.896 -503.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35134",
    "data-name": "Path 35134",
    className: "cls-3",
    d: "M413.6 513.8l.034-.067-.117-.034-.017.05z",
    transform: "translate(-402.552 -507.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35135",
    "data-name": "Path 35135",
    className: "cls-3",
    d: "M414.617 514.2l.017-.067-.117-.034-.017.05z",
    transform: "translate(-403.385 -507.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35136",
    "data-name": "Path 35136",
    className: "cls-3",
    d: "M416.617 514.9l.034-.05-.117-.05-.034.067z",
    transform: "translate(-405.049 -507.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35137",
    "data-name": "Path 35137",
    className: "cls-3",
    d: "M401.217 509.2l.017-.05-.117-.05-.017.067z",
    transform: "translate(-392.231 -503.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35138",
    "data-name": "Path 35138",
    className: "cls-3",
    d: "M415.617 514.6l.017-.067-.117-.034-.017.05z",
    transform: "translate(-404.217 -507.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35139",
    "data-name": "Path 35139",
    className: "cls-3",
    d: "M410.5 512.7l.034-.067-.117-.034-.017.05z",
    transform: "translate(-399.972 -506.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35140",
    "data-name": "Path 35140",
    className: "cls-3",
    d: "M412.517 513.4l.017-.05-.117-.05-.017.067z",
    transform: "translate(-401.637 -506.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35141",
    "data-name": "Path 35141",
    className: "cls-3",
    d: "M411.517 513l.017-.05-.117-.05-.017.067z",
    transform: "translate(-400.804 -506.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35142",
    "data-name": "Path 35142",
    className: "cls-3",
    d: "M409.417 512.3l.017-.067-.1-.034-.034.05z",
    transform: "translate(-399.056 -505.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35143",
    "data-name": "Path 35143",
    className: "cls-3",
    d: "M390.917 505.5l.017-.067-.117-.034-.017.05z",
    transform: "translate(-383.658 -500.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35144",
    "data-name": "Path 35144",
    className: "cls-3",
    d: "M392.917 506.2l.017-.05-.1-.05-.034.067z",
    transform: "translate(-385.323 -500.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35145",
    "data-name": "Path 35145",
    className: "cls-3",
    d: "M389.9 505.1l.034-.067-.117-.034-.017.05z",
    transform: "translate(-382.826 -499.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35146",
    "data-name": "Path 35146",
    className: "cls-3",
    d: "M391.917 505.8l.017-.05-.117-.05-.017.067z",
    transform: "translate(-384.491 -500.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35147",
    "data-name": "Path 35147",
    className: "cls-3",
    d: "M388.817 504.7l.017-.05-.117-.05-.017.067z",
    transform: "translate(-381.91 -499.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35148",
    "data-name": "Path 35148",
    className: "cls-3",
    d: "M386.717 503.9l.034-.05-.117-.05-.033.067z",
    transform: "translate(-380.162 -498.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35149",
    "data-name": "Path 35149",
    className: "cls-3",
    d: "M387.817 504.3l.017-.05-.117-.05-.017.067z",
    transform: "translate(-381.078 -499.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35150",
    "data-name": "Path 35150",
    className: "cls-3",
    d: "M399.117 508.5l.017-.067-.117-.034-.017.05z",
    transform: "translate(-390.483 -502.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35151",
    "data-name": "Path 35151",
    className: "cls-3",
    d: "M398.117 508.1l.017-.05-.117-.05-.017.067z",
    transform: "translate(-389.651 -502.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35152",
    "data-name": "Path 35152",
    className: "cls-3",
    d: "M400.117 508.9l.033-.067-.117-.033-.034.05z",
    transform: "translate(-391.316 -502.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35153",
    "data-name": "Path 35153",
    className: "cls-3",
    d: "M397.1 507.7l.034-.05-.117-.05-.017.067z",
    transform: "translate(-388.819 -501.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35154",
    "data-name": "Path 35154",
    className: "cls-3",
    d: "M396.017 507.4l.017-.067-.117-.033-.017.05z",
    transform: "translate(-387.903 -501.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35155",
    "data-name": "Path 35155",
    className: "cls-3",
    d: "M394 506.6l.034-.067-.117-.034-.017.05z",
    transform: "translate(-386.238 -501.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35156",
    "data-name": "Path 35156",
    className: "cls-3",
    d: "M395.017 507l.017-.067-.117-.034-.017.05z",
    transform: "translate(-387.071 -501.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35157",
    "data-name": "Path 35157",
    className: "cls-3",
    d: "M434.2 521.4l.034-.067-.117-.034-.017.05z",
    transform: "translate(-419.699 -513.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35158",
    "data-name": "Path 35158",
    className: "cls-3",
    d: "M419.717 516.1l.017-.067-.1-.034-.034.05z",
    transform: "translate(-407.63 -508.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35159",
    "data-name": "Path 35159",
    className: "cls-3",
    d: "M420.8 516.4l.034-.05-.117-.05-.017.067z",
    transform: "translate(-408.545 -509.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35160",
    "data-name": "Path 35160",
    className: "cls-3",
    d: "M418.717 515.7l.017-.067-.117-.034-.017.05z",
    transform: "translate(-406.797 -508.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35161",
    "data-name": "Path 35161",
    className: "cls-3",
    d: "M417.717 515.3l.017-.05-.117-.05-.017.067z",
    transform: "translate(-405.965 -508.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35162",
    "data-name": "Path 35162",
    className: "cls-3",
    d: "M421.817 516.8l.017-.05-.117-.05-.017.067z",
    transform: "translate(-409.378 -509.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35163",
    "data-name": "Path 35163",
    className: "cls-3",
    d: "M431.1 520.2l.034-.05-.117-.05-.017.067z",
    transform: "translate(-417.118 -512.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35164",
    "data-name": "Path 35164",
    className: "cls-3",
    d: "M433.117 521l.017-.067-.117-.034-.017.05z",
    transform: "translate(-418.783 -513.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35165",
    "data-name": "Path 35165",
    className: "cls-3",
    d: "M430.017 519.9l.034-.067-.117-.034-.034.05z",
    transform: "translate(-416.203 -512.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35166",
    "data-name": "Path 35166",
    className: "cls-3",
    d: "M427 518.7l.034-.05-.117-.05-.017.067z",
    transform: "translate(-413.706 -511.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35167",
    "data-name": "Path 35167",
    className: "cls-3",
    d: "M428.017 519.1l.017-.05-.117-.05-.017.05z",
    transform: "translate(-414.538 -511.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35168",
    "data-name": "Path 35168",
    className: "cls-3",
    d: "M425.917 518.3l.017-.05-.117-.05-.017.067z",
    transform: "translate(-412.79 -510.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35169",
    "data-name": "Path 35169",
    className: "cls-3",
    d: "M424.917 518l.017-.067-.117-.033-.017.05z",
    transform: "translate(-411.958 -510.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35170",
    "data-name": "Path 35170",
    className: "cls-3",
    d: "M422.817 517.2l.017-.05-.1-.05-.034.067z",
    transform: "translate(-410.21 -509.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35171",
    "data-name": "Path 35171",
    className: "cls-3",
    d: "M423.9 517.6l.033-.067-.117-.033-.017.05z",
    transform: "translate(-411.125 -510.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35172",
    "data-name": "Path 35172",
    className: "cls-3",
    d: "M432.117 520.6l.017-.05-.117-.05-.017.067z",
    transform: "translate(-417.951 -512.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35173",
    "data-name": "Path 35173",
    className: "cls-3",
    d: "M443.417 524.8l.017-.067-.1-.034-.034.05z",
    transform: "translate(-427.356 -516.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35174",
    "data-name": "Path 35174",
    className: "cls-3",
    d: "M440.317 523.6l.017-.05-.1-.05-.033.067z",
    transform: "translate(-424.776 -515.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35175",
    "data-name": "Path 35175",
    className: "cls-3",
    d: "M441.417 524l.017-.05-.117-.05-.017.067z",
    transform: "translate(-425.692 -515.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35176",
    "data-name": "Path 35176",
    className: "cls-3",
    d: "M442.417 524.4l.017-.05-.117-.05-.017.067z",
    transform: "translate(-426.524 -515.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35177",
    "data-name": "Path 35177",
    className: "cls-3",
    d: "M445.517 525.5l.017-.05-.117-.05-.017.067z",
    transform: "translate(-429.104 -516.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35178",
    "data-name": "Path 35178",
    className: "cls-3",
    d: "M444.5 525.2l.033-.067-.117-.034-.017.05z",
    transform: "translate(-428.272 -516.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35179",
    "data-name": "Path 35179",
    className: "cls-3",
    d: "M437.217 522.5l.034-.05-.117-.05-.034.067z",
    transform: "translate(-422.196 -514.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35180",
    "data-name": "Path 35180",
    className: "cls-3",
    d: "M438.317 522.9l.017-.067-.117-.034-.017.05z",
    transform: "translate(-423.111 -514.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35181",
    "data-name": "Path 35181",
    className: "cls-3",
    d: "M446.517 525.9l.017-.05-.117-.05-.017.067z",
    transform: "translate(-429.937 -517.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35182",
    "data-name": "Path 35182",
    className: "cls-3",
    d: "M435.217 521.784l.017-.05-.117-.034-.017.05z",
    transform: "translate(-420.531 -513.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35183",
    "data-name": "Path 35183",
    className: "cls-3",
    d: "M436.217 522.1l.017-.05-.117-.05-.017.067z",
    transform: "translate(-421.363 -513.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35184",
    "data-name": "Path 35184",
    className: "cls-3",
    d: "M481.534 507.35l-.1-.05-.034.05.117.05z",
    transform: "translate(-459.069 -501.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35185",
    "data-name": "Path 35185",
    className: "cls-3",
    d: "M480.534 506.85l-.1-.05-.034.05.117.05z",
    transform: "translate(-458.236 -501.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35186",
    "data-name": "Path 35186",
    className: "cls-3",
    d: "M483.417 508.2l-.017.067.1.05.034-.05z",
    transform: "translate(-460.734 -502.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35187",
    "data-name": "Path 35187",
    className: "cls-3",
    d: "M459.817 496.717l.017-.067-.1-.05-.033.05z",
    transform: "translate(-441.007 -492.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35188",
    "data-name": "Path 35188",
    className: "cls-3",
    d: "M465.717 499.617l.034-.067-.117-.05-.033.067z",
    transform: "translate(-445.918 -495.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35189",
    "data-name": "Path 35189",
    className: "cls-3",
    d: "M468.717 501.1l.017-.05-.1-.05-.034.05z",
    transform: "translate(-448.415 -496.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35190",
    "data-name": "Path 35190",
    className: "cls-3",
    d: "M467.717 500.6l.017-.05-.1-.05-.034.05z",
    transform: "translate(-447.582 -496.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35191",
    "data-name": "Path 35191",
    className: "cls-3",
    d: "M471.7 502.517l.034-.067-.117-.05-.017.067z",
    transform: "translate(-450.912 -497.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35192",
    "data-name": "Path 35192",
    className: "cls-3",
    d: "M470.7 502.017l.034-.05-.117-.067-.017.067z",
    transform: "translate(-450.08 -497.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2183",
    "data-name": "Rectangle 2183",
    className: "cls-3",
    transform: "rotate(-64.132 13.923 -13.89)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35193",
    "data-name": "Path 35193",
    className: "cls-3",
    d: "M466.717 500.117l.034-.067-.117-.05-.034.05z",
    transform: "translate(-446.75 -495.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35194",
    "data-name": "Path 35194",
    className: "cls-3",
    d: "M463.8 498.617l.034-.05-.117-.067-.017.067z",
    transform: "translate(-444.336 -494.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    className: "cls-3",
    transform: "rotate(-64.132 13.186 -13.442)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35195",
    "data-name": "Path 35195",
    className: "cls-3",
    d: "M458.9 496.217l.034-.05-.117-.067-.017.067z",
    transform: "translate(-440.258 -492.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35196",
    "data-name": "Path 35196",
    className: "cls-3",
    d: "M462.8 498.2l.033-.05-.1-.05-.033.05z",
    transform: "translate(-443.504 -494.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35197",
    "data-name": "Path 35197",
    className: "cls-3",
    d: "M472.617 503.017l.034-.067-.117-.05-.034.05z",
    transform: "translate(-451.661 -498.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35198",
    "data-name": "Path 35198",
    className: "cls-3",
    d: "M478.6 505.917l.033-.067-.117-.05-.017.05z",
    transform: "translate(-456.655 -500.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35199",
    "data-name": "Path 35199",
    className: "cls-3",
    d: "M477.6 505.417l.034-.05-.117-.067-.017.067z",
    transform: "translate(-455.823 -500.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35200",
    "data-name": "Path 35200",
    className: "cls-3",
    d: "M461.817 497.7l.017-.05-.1-.05-.034.05z",
    transform: "translate(-442.672 -493.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35201",
    "data-name": "Path 35201",
    className: "cls-3",
    d: "M479.6 506.417l.034-.067-.117-.05-.017.05z",
    transform: "translate(-457.487 -500.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35202",
    "data-name": "Path 35202",
    className: "cls-3",
    d: "M476.6 505l.033-.05-.117-.05-.017.05z",
    transform: "translate(-454.99 -499.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35203",
    "data-name": "Path 35203",
    className: "cls-3",
    d: "M473.617 503.5l.034-.05-.117-.05-.033.05z",
    transform: "translate(-452.493 -498.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35204",
    "data-name": "Path 35204",
    className: "cls-3",
    d: "M474.617 504l.017-.05-.1-.05-.034.05z",
    transform: "translate(-453.326 -498.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35205",
    "data-name": "Path 35205",
    className: "cls-3",
    d: "M475.617 504.5l.017-.05-.1-.05-.033.05z",
    transform: "translate(-454.158 -499.27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(.827 23.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35206",
    "data-name": "Path 35206",
    className: "cls-5",
    d: "M360.2 607.634l11.182 5.214-.5-1.207-.034.033-.05-.033c.017-.017.033-.05.05-.067l-.654-1.559-.017-.017.017-.017-.034-.067-.034.033-.1-.084.034-.05.067.067-.637-1.543-3.588-4.325-5.75 3.269a2.541 2.541 0 0 1 .048.353zm-.084.134l-.419-.2-.2.721-.889.2-.637-.671.235-.872.05-.017.654-.151-.168-.436a1.233 1.233 0 0 0-.8 2.129 1.253 1.253 0 0 0 1.777.084 1.167 1.167 0 0 0 .398-.787zm-1.324-1.492a1.259 1.259 0 0 1 .251.017l.285-4.242-1.961.57zm-1.509-3.688l-.721-1.827-1.744 1.744a1.026 1.026 0 0 1 .251.386.8.8 0 0 1 .067.335zm-2.2.7l-.252.084.067.067-.05.05-.067-.067-.386.5-.687-.117-.268-.671.419-.553.436.067v-.369a.84.84 0 0 0-.536.05.982.982 0 0 0-.52 1.274.994.994 0 0 0 1.257.57.947.947 0 0 0 .591-.881zm-.419-.855a1 1 0 0 0-.184-.1v.285zm.134.872l.285-.084a.751.751 0 0 0-.067-.335 1.043 1.043 0 0 0-.251-.352l-.2.2zm-.335-1.039a1.02 1.02 0 0 1 .235.117l1.794-1.794-2.079-5.315h-.034zm-.218-7.008v-.251l-.436-.117-.151-.536.386-.386.536.151.117.419.268-.034a.779.779 0 0 0-1.526-.184.765.765 0 0 0 .57.922 1.113 1.113 0 0 0 .24.019zm.788-.7c0 .034-.017.05-.017.084l3.638 1.308.017-.033a1.335 1.335 0 0 1 1.894-.235 1.5 1.5 0 0 1 .319.335l1.308-1.006a2.251 2.251 0 0 1-.335-.352 1.674 1.674 0 0 1-.319-.788zm6.622-.771l.453-.05.419-1.006 1.123-.1.687.939-.419.972.268.4a1.6 1.6 0 0 0 .268-2.2 1.578 1.578 0 0 0-2.2-.4 1.6 1.6 0 0 0-.595 1.444zm5.885 6.421l-3.42-5.063a.087.087 0 0 1-.067.034l1.978 4.728 1.341.654a2.274 2.274 0 0 1 .172-.354zm.184-.017l.469.687 1.039-1.056 1.609.419.436 1.609-1.107 1.123.168.654a2.314 2.314 0 0 0-1.291-4.443 2.424 2.424 0 0 0-1.319 1.006zm1.827 8.131l2.75 3.3-.218-.838c-.034 0-.05.017-.084.033l-.017-.05c.034-.017.067-.017.084-.034l-1.827-6.907a2.463 2.463 0 0 1-2.465-.838l-.352.2zm-3.588-4.309l3.454 4.158-2.062-4.946zm-.034-.05l1.408-.788-.771-1.861-2.649.218zm-6.891 2.414a.888.888 0 0 0-.218-.017l.134.352.067-.218zm.352-4.342l-.285 4.208 1.107-3.772a.764.764 0 0 1-.453-.536zm0-.067l.352-.1v-.034a.8.8 0 0 1 .319-.721l-.553-.654zm-2.783-1.274l.721 1.861 1.995-.587.1-1.593-1.157-1.358zm-2.213-5.482v.017zm.067 0a.731.731 0 0 0 .369-.268l-.184-.218-.252.251v.05zm.5-.587a.127.127 0 0 1 .017-.067l-.151.017zm-.268.067l.168.2c.017-.033.05-.084.067-.117l-.235-.084zm.285.1c-.017.05-.05.1-.067.151l3.336 3.923.956-.939a1.255 1.255 0 0 1-.2-.117 1.372 1.372 0 0 1-.419-1.727zm5.922 1.408l-.3.218-.084.8.352.168a1.251 1.251 0 0 0 .032-1.186zm2.817 5.18l-3.018-3.638a1.321 1.321 0 0 1-.872.335l.419 2.917a.964.964 0 0 1 .235-.067.819.819 0 0 1 .905.654zm-3.906.52a.712.712 0 0 0 .419.5l.067-.235-.252-.335zm.268-.755a.776.776 0 0 0-.3.671v.034l.218-.067.218-.469zm.168-.1l.034.235.5-.05.285.369.252-.017a.76.76 0 0 0-.838-.6.972.972 0 0 0-.229.063zm-.117.067l.067.084-.017-.134zm-.62-.754l.587.7a.361.361 0 0 1 .084-.05l-.419-2.934a.212.212 0 0 1-.1-.017zm-.184-2.364l-.989.989 1.106 1.308.151-2.246a.759.759 0 0 1-.265-.051zm.067-.067l.2.05.017-.285zm.268.05a.151.151 0 0 1 .084.017l-.05-.352zm.989-.285l-.268-.335-.62.251.05.386a1.288 1.288 0 0 0 .841-.302zm-.2-.352l.251.3a.622.622 0 0 0 .1-.117zm-1.794-1.241a1.292 1.292 0 0 0 .386 1.626c.067.05.134.084.2.134l.319-.319-.62-.469.084-.838zm2.4 6.136l.034.034a.809.809 0 0 0 .251-.536l-.251.017-.168.369.084.084-.034.05-.084-.084-.436.05-.067.235a.7.7 0 0 0 .268.017.86.86 0 0 0 .4-.168l-.034-.033zm5-2.163l-5.164-2.515a1.08 1.08 0 0 1-.134.151l3.051 3.672 2.7-.218zm1.291.637l-1.207-.587.436 1.04.687-.05a1.014 1.014 0 0 1 .08-.402zm.654.151l-.352-.5a1.445 1.445 0 0 0-.117.285zm-.52-.084a1.781 1.781 0 0 0-.067.319l.6-.05zm-.168 1.308a2.381 2.381 0 0 1-.084-.838l-.6.05.771 1.844.352-.2a2.3 2.3 0 0 1-.443-.855zm.8-.905l-.738.067a2.617 2.617 0 0 0 .067.8 2.241 2.241 0 0 0 .419.821l.6-.335zm.4 1.442l-.017-.033-.587.335a2.263 2.263 0 0 0 2.3.754l-.168-.654zm-6.186-7.528l-1.358 1.04a1.312 1.312 0 0 1-.017 1.291l5 2.431-1.945-4.644a1.673 1.673 0 0 1-1.677-.117zm.084-.067a1.529 1.529 0 0 0 1.559.067l-.2-.469-.956.084zm-.754-1.174a1.574 1.574 0 0 0 .3.738 1.274 1.274 0 0 0 .335.335l.4-.318-.587-.821zm2.263 1.006l.1.235a.036.036 0 0 0 .034-.034zm-5.18 1.107l.419.151.7-.3.637.469.319-.251a1.881 1.881 0 0 0-.3-.335 1.308 1.308 0 0 0-1.777.268zm-2.179 4.577l1.643-1.626-3.336-3.923a.891.891 0 0 1-.386.268zm3.252 6.924l.3.134a.761.761 0 0 0-.05-.268zm.235-.2a1.3 1.3 0 0 0-.3-.5 1.249 1.249 0 0 0-.536-.352l-.1.352.62.654h.017zm4.107-2.414l.067.067 1.643-.922-2.029-2.464-2.448.2a.814.814 0 0 1-.251.57l.017.017-.034.05-.017-.017a.835.835 0 0 1-.721.168l-1.123 3.839a1.455 1.455 0 0 1 .889.889l4.057-2.28-.05-.05zm7.293 8l.922-1.006-.067-.05.034-.034-.034-.05-.034.034-.1-.084.034-.05.067.05-.6-.738.017.05-.1.067-.034-.05a.348.348 0 0 0 .1-.067l-2-2.414.6 1.459.067.05-.034.034zm2 2.1l-1.626-.369-.486-1.593-11.136-5.19a1.349 1.349 0 0 1-.386.8 1.334 1.334 0 0 1-1.894-.084 1.366 1.366 0 0 1 0-1.911l-.05-.05.05-.034.05.05a1.263 1.263 0 0 1 .788-.318l-1.425-3.638-2.146.637a.9.9 0 0 1-.067.369l.067.067-.05.034-.05-.05a.989.989 0 0 1-.536.536 1.054 1.054 0 0 1-1.341-.6 1.037 1.037 0 0 1 .553-1.358.954.954 0 0 1 .57-.05l-.067-6.907a.651.651 0 0 1-.252-.034.806.806 0 1 1 .4-1.559.837.837 0 0 1 .62.771l6.522-.687a1.628 1.628 0 0 1 .654-1.509 1.683 1.683 0 0 1 2.347.419 1.705 1.705 0 0 1-.3 2.347l3.387 5.013a2.372 2.372 0 0 1 1.391-1.006 2.45 2.45 0 0 1 3.018 1.727 2.477 2.477 0 0 1-1.643 3.018l2.112 7.98 1.576.352.5 1.593z",
    transform: "translate(-353.131 -591.97)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4761",
    "data-name": "Group 4761",
    transform: "translate(2.469 3.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4756",
    "data-name": "Group 4756",
    transform: "translate(6.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35207",
    "data-name": "Path 35207",
    className: "cls-3",
    d: "M408.542 471.8l.8.838-.319 1.106-1.123.285-.8-.821.319-1.123z",
    transform: "translate(-406.526 -471.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35208",
    "data-name": "Path 35208",
    className: "cls-5",
    d: "M403.833 470.378a1.6 1.6 0 1 1 1.945 1.174 1.594 1.594 0 0 1-1.945-1.174zm-.1.034a1.7 1.7 0 0 0 2.062 1.241 1.731 1.731 0 0 0 1.241-2.079 1.7 1.7 0 1 0-3.3.838z",
    transform: "translate(-403.679 -468.278)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35209",
    "data-name": "Path 35209",
    className: "cls-3",
    d: "M416.4 480.8l12.172 12.876-.1.1L416.3 480.9z",
    transform: "translate(-407.352 -478.701)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(.666 13.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35210",
    "data-name": "Path 35210",
    className: "cls-3",
    d: "M368.9 554.173l-.3-.537.319-.536h.62l.3.553-.319.537z",
    transform: "translate(-368.315 -552.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35211",
    "data-name": "Path 35211",
    className: "cls-5",
    d: "M368.66 551.739a.863.863 0 0 1-1.727-.017.862.862 0 0 1 .872-.855.842.842 0 0 1 .855.872zm.067 0a.942.942 0 0 0-.905-.939.916.916 0 0 0-.922.905.942.942 0 0 0 .905.939.927.927 0 0 0 .922-.905z",
    transform: "translate(-366.9 -550.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758",
    transform: "translate(20.453 14.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35212",
    "data-name": "Path 35212",
    className: "cls-3",
    d: "M487.086 557.557l-.386-.486.218-.587.62-.084.386.486-.218.587z",
    transform: "translate(-486.403 -556.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35213",
    "data-name": "Path 35213",
    className: "cls-5",
    d: "M486.682 555.21a.88.88 0 0 1-.721.989.854.854 0 0 1-.972-.721.87.87 0 0 1 .721-.989.842.842 0 0 1 .972.721zm.067 0a.915.915 0 1 0-.771 1.039.925.925 0 0 0 .771-1.039z",
    transform: "translate(-484.926 -554.426)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4759",
    "data-name": "Group 4759",
    transform: "translate(0 7.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35214",
    "data-name": "Path 35214",
    className: "cls-3",
    d: "M365.521 516.324l-.587-.184-.134-.62.469-.419.587.2.134.62z",
    transform: "translate(-364.486 -514.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35215",
    "data-name": "Path 35215",
    className: "cls-5",
    d: "M364.482 513.591a.858.858 0 0 1-.084 1.224.836.836 0 0 1-1.207-.084.858.858 0 0 1 .084-1.224.837.837 0 0 1 1.207.084zm.05-.05a.908.908 0 0 0-1.291-.084.928.928 0 0 0-.084 1.308.908.908 0 0 0 1.291.084.943.943 0 0 0 .084-1.308z",
    transform: "translate(-362.927 -513.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4760",
    "data-name": "Group 4760",
    transform: "translate(6.407 17.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35216",
    "data-name": "Path 35216",
    className: "cls-3",
    d: "M402.986 577.438l-.386-.2v-.419l.352-.218.386.2v.419z",
    transform: "translate(-402.356 -576.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35217",
    "data-name": "Path 35217",
    className: "cls-5",
    d: "M402.26 575.652a.587.587 0 1 1-.8-.2.582.582 0 0 1 .8.2zm.034-.034a.6.6 0 0 0-.855-.2.626.626 0 0 0-.2.855.611.611 0 0 0 .855.2.634.634 0 0 0 .199-.855z",
    transform: "translate(-401.144 -575.32)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35218",
    "data-name": "Path 35218",
    className: "cls-3",
    d: "M373.017 494.671l-.117-.067 6.622-12 .134.067z",
    transform: "translate(-371.228 -480.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35219",
    "data-name": "Path 35219",
    className: "cls-3",
    d: "M404.6 497.8l1.291-16.3h.067l-1.291 16.3z",
    transform: "translate(-397.613 -479.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35220",
    "data-name": "Path 35220",
    className: "cls-3",
    d: "M372.884 557.9l5.13 3.454-.067.117-5.147-3.454z",
    transform: "translate(-371.145 -542.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35221",
    "data-name": "Path 35221",
    className: "cls-3",
    d: "M376.309 482.6l.117.151-7.209 5.9-.117-.151z",
    transform: "translate(-368.065 -480.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35222",
    "data-name": "Path 35222",
    className: "cls-3",
    d: "M368.184 520.5l.436 5.633-.2.017-.42-5.633z",
    transform: "translate(-367.15 -511.745)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764",
    transform: "translate(17.395 23.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35223",
    "data-name": "Path 35223",
    className: "cls-3",
    d: "M458.995 605.293l-4.795-7.243.034-.05 4.795 7.242z",
    transform: "translate(-453.824 -596.483)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4762",
    "data-name": "Group 4762",
    transform: "translate(0 1.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35224",
    "data-name": "Path 35224",
    className: "cls-3",
    d: "M452.834 597.217l.268-.017.151.235-.134.251h-.285l-.134-.235z",
    transform: "translate(-452.575 -597.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35225",
    "data-name": "Path 35225",
    className: "cls-5",
    d: "M452.164 597a.371.371 0 1 1 .5-.151.38.38 0 0 1-.5.151zm0 .034a.4.4 0 0 0 .536-.151.425.425 0 0 0-.151-.553.389.389 0 0 0-.536.151.4.4 0 0 0 .151.554z",
    transform: "translate(-451.956 -596.277)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4763",
    "data-name": "Group 4763",
    transform: "translate(6.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35226",
    "data-name": "Path 35226",
    className: "cls-3",
    d: "M494 589.5l.134.117-.034.168-.168.067-.134-.117.034-.184z",
    transform: "translate(-493.701 -589.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35227",
    "data-name": "Path 35227",
    className: "cls-5",
    d: "M493.243 589.293a.249.249 0 1 1 .319.151.243.243 0 0 1-.319-.151zm-.017 0a.285.285 0 0 0 .335.168.26.26 0 0 0 .151-.335.285.285 0 0 0-.335-.168.276.276 0 0 0-.151.335z",
    transform: "translate(-493.211 -588.949)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35228",
    "data-name": "Path 35228",
    className: "cls-3",
    d: "M489.517 594.119h-.017l.855-3.219h.017z",
    transform: "translate(-483.206 -590.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35229",
    "data-name": "Path 35229",
    className: "cls-3",
    d: "M496.659 593.836l-1.459-3.319.017-.017 1.459 3.319z",
    transform: "translate(-487.95 -590.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35230",
    "data-name": "Path 35230",
    className: "cls-3",
    d: "M458.351 599.674l-3.051-1.241.017-.034 3.034 1.257z",
    transform: "translate(-454.739 -596.815)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    transform: "translate(3.772 15.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(3.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35231",
    "data-name": "Path 35231",
    className: "cls-3",
    d: "M392.821 545.951l-.017.469-.419.218-.386-.252.017-.469.419-.218z",
    transform: "translate(-391.723 -545.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35232",
    "data-name": "Path 35232",
    className: "cls-5",
    d: "M390.493 544.694a.634.634 0 0 1 .889-.185.651.651 0 0 1 .184.905.634.634 0 0 1-.889.184.651.651 0 0 1-.184-.904zm-.034-.034a.691.691 0 1 0 .956-.2.7.7 0 0 0-.955.201z",
    transform: "translate(-390.351 -544.351)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766",
    transform: "translate(1.109 5.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35233",
    "data-name": "Path 35233",
    className: "cls-3",
    d: "M378.887 579.418l-.084.3-.285.067-.218-.2.084-.3.285-.084z",
    transform: "translate(-378.134 -579.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35234",
    "data-name": "Path 35234",
    className: "cls-5",
    d: "M377.461 578.43a.427.427 0 1 1 0 .6.459.459 0 0 1 0-.6zm-.017-.017a.45.45 0 0 0 0 .637.451.451 0 1 0 .637-.637.436.436 0 0 0-.637 0z",
    transform: "translate(-377.312 -578.275)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35235",
    "data-name": "Path 35235",
    className: "cls-3",
    d: "M370.7 585.925l1.526-4.225.084.034-1.526 4.225z",
    transform: "translate(-370.7 -575.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35236",
    "data-name": "Path 35236",
    className: "cls-3",
    d: "M379.6 555.347l2.5-5.147.034.034-2.5 5.13z",
    transform: "translate(-378.108 -549.219)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4774",
    "data-name": "Group 4774",
    transform: "translate(.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768",
    transform: "translate(9.187 10.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35237",
    "data-name": "Path 35237",
    className: "cls-3",
    d: "M407.6 515.3l1.14-.2.738.888-.4 1.107-1.14.184-.738-.889z",
    transform: "translate(-406.637 -514.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35238",
    "data-name": "Path 35238",
    className: "cls-5",
    d: "M404.99 514.579a1.617 1.617 0 0 1-.956-2.062 1.591 1.591 0 0 1 2.045-.955 1.617 1.617 0 0 1 .956 2.062 1.577 1.577 0 0 1-2.045.955zm-.034.1a1.716 1.716 0 1 0-1.006-2.2 1.694 1.694 0 0 0 1.006 2.201z",
    transform: "translate(-403.84 -511.353)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35239",
    "data-name": "Path 35239",
    className: "cls-3",
    d: "M351.1 452.4l.62-.1.4.469-.2.587-.62.117-.4-.469z",
    transform: "translate(-350.588 -451.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35240",
    "data-name": "Path 35240",
    className: "cls-5",
    d: "M349.67 452.036a.852.852 0 0 1-.52-1.107.84.84 0 0 1 1.09-.52.852.852 0 0 1 .52 1.107.86.86 0 0 1-1.09.52zm-.017.05a.923.923 0 1 0-.57-1.174.952.952 0 0 0 .57 1.174z",
    transform: "translate(-349.039 -450.291)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35241",
    "data-name": "Path 35241",
    className: "cls-3",
    d: "M417.6 506.333l17.436-2.833.034.151-17.436 2.817z",
    transform: "translate(-406.106 -494.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35242",
    "data-name": "Path 35242",
    className: "cls-3",
    d: "M355.7 457.084l.1-.084 9.2 10.16-.1.1z",
    transform: "translate(-354.583 -455.875)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    transform: "translate(16.747 24.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35243",
    "data-name": "Path 35243",
    className: "cls-3",
    d: "M451.589 597.823l-.62-.05-.268-.57.352-.5.62.05.268.57z",
    transform: "translate(-450.403 -596.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35244",
    "data-name": "Path 35244",
    className: "cls-5",
    d: "M450.35 594.831a.861.861 0 0 1 .2 1.207.841.841 0 0 1-1.19.2.86.86 0 0 1 .989-1.408zm.017-.034a.915.915 0 0 0-1.274.235.95.95 0 0 0 .218 1.291.928.928 0 0 0 1.056-1.526z",
    transform: "translate(-448.931 -594.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4771",
    "data-name": "Group 4771",
    transform: "translate(28.42 8.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35245",
    "data-name": "Path 35245",
    className: "cls-3",
    d: "M521.272 501.79l-.62.033-.352-.52.268-.553.62-.05.352.52z",
    transform: "translate(-520.007 -500.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35246",
    "data-name": "Path 35246",
    className: "cls-5",
    d: "M519.837 498.7a.878.878 0 0 1 .4 1.157.864.864 0 0 1-1.157.4.878.878 0 0 1-.4-1.157.889.889 0 0 1 1.157-.4zm.034-.05a.918.918 0 0 0-1.224.419.943.943 0 0 0 .419 1.241.918.918 0 0 0 1.224-.419.932.932 0 0 0-.42-1.245z",
    transform: "translate(-518.555 -498.555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772",
    transform: "translate(11.205 21.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35247",
    "data-name": "Path 35247",
    className: "cls-3",
    d: "M419.14 579.272l-.5.369-.57-.235-.067-.62.486-.386.57.252z",
    transform: "translate(-417.643 -578.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35248",
    "data-name": "Path 35248",
    className: "cls-5",
    d: "M416.7 576.711a.865.865 0 0 1 .956.754.861.861 0 0 1-1.71.2.875.875 0 0 1 .754-.954zm-.017-.05a.933.933 0 0 0-.8 1.023.921.921 0 0 0 1.023.8.934.934 0 0 0 .8-1.023.921.921 0 0 0-1.025-.8z",
    transform: "translate(-415.872 -576.653)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773",
    transform: "translate(23.246 22.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35249",
    "data-name": "Path 35249",
    className: "cls-3",
    d: "M489.921 584.054l-.369.2-.352-.235.017-.419.386-.2.352.235z",
    transform: "translate(-488.948 -583.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35250",
    "data-name": "Path 35250",
    className: "cls-5",
    d: "M488.35 582.23a.6.6 0 0 1 .553.62.585.585 0 0 1-.62.553.588.588 0 0 1 .067-1.174zm0-.034a.621.621 0 1 0 .587.654.608.608 0 0 0-.587-.65z",
    transform: "translate(-487.696 -582.196)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35251",
    "data-name": "Path 35251",
    className: "cls-3",
    d: "M422.82 537.006l-.117.05-6.1-12.289.117-.067z",
    transform: "translate(-405.273 -512.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35252",
    "data-name": "Path 35252",
    className: "cls-3",
    d: "M428.241 534.61L415.6 524.333l.033-.034 12.641 10.277z",
    transform: "translate(-404.441 -511.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35253",
    "data-name": "Path 35253",
    className: "cls-3",
    d: "M456.3 588.7l5.717-2.3.067.117-5.734 2.313z",
    transform: "translate(-438.318 -563.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35254",
    "data-name": "Path 35254",
    className: "cls-3",
    d: "M416.4 525.317l.184-.017.771 9.321-.184.017z",
    transform: "translate(-405.107 -512.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35255",
    "data-name": "Path 35255",
    className: "cls-3",
    d: "M422.7 582.5l4.862 2.817-.084.168-4.879-2.817z",
    transform: "translate(-410.267 -560.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35256",
    "data-name": "Path 35256",
    className: "cls-3",
    d: "M421.2 583.8h.134l.2 6.069h-.134z",
    transform: "translate(-409.102 -561.417)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4778",
    "data-name": "Group 4778",
    transform: "translate(.117 5.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4775",
    "data-name": "Group 4775",
    transform: "translate(7.89 7.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35257",
    "data-name": "Path 35257",
    className: "cls-3",
    d: "M399.675 532.372l-.469.587-.738-.151-.268-.721.469-.587.738.134z",
    transform: "translate(-397.825 -531.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35258",
    "data-name": "Path 35258",
    className: "cls-5",
    d: "M396.707 529.158a1.036 1.036 0 0 1 1.324.654 1.054 1.054 0 0 1-.587 1.358 1.073 1.073 0 0 1-.738-2.012zm-.034-.067a1.144 1.144 0 1 0 1.425.687 1.121 1.121 0 0 0-1.424-.687z",
    transform: "translate(-395.963 -529.029)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4776",
    "data-name": "Group 4776",
    transform: "translate(10.327 12.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35259",
    "data-name": "Path 35259",
    className: "cls-3",
    d: "M413.489 562.305l-.5.285-.486-.318.017-.587.48-.285.486.3z",
    transform: "translate(-412.164 -561.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35260",
    "data-name": "Path 35260",
    className: "cls-5",
    d: "M411.352 559.748a.822.822 0 1 1-.8.8.8.8 0 0 1 .8-.8zm0-.05a.873.873 0 0 0-.034 1.744.848.848 0 0 0 .855-.855.871.871 0 0 0-.821-.887z",
    transform: "translate(-410.497 -559.697)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35261",
    "data-name": "Path 35261",
    className: "cls-3",
    d: "M349.017 489.217l1.039 8.818-.117-.017-1.039-8.818z",
    transform: "translate(-348.9 -488.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35262",
    "data-name": "Path 35262",
    className: "cls-3",
    d: "M400.6 565.85l-2.582 6.17-.117-.05 2.582-6.169z",
    transform: "translate(-389.685 -552.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35263",
    "data-name": "Path 35263",
    className: "cls-3",
    d: "M398.35 549.13h-.05l.335-10.83h.05z",
    transform: "translate(-390.018 -529.381)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4777",
    "data-name": "Group 4777",
    transform: "translate(9.171 9.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35264",
    "data-name": "Path 35264",
    className: "cls-5",
    d: "M403.65 539.4l-.05.017.034.1.05-.017zm.067.151l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.05.151l-.034.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.067.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.067.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.067.151l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.033.1.05-.017zm.067.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.067.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.151l-.05.017.034.1.05-.017zm.05.134l-.05.017.034.1.05-.017zm.067.151l-.05.017.034.1.05-.017z",
    transform: "translate(-403.6 -539.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35265",
    "data-name": "Path 35265",
    className: "cls-3",
    d: "M361.778 493.5l-.1.084-7.477-8.4.1-.084z",
    transform: "translate(-353.311 -485.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35266",
    "data-name": "Path 35266",
    className: "cls-3",
    d: "M366.273 534.55l-6.756 1.76-.017-.05 6.773-1.76z",
    transform: "translate(-357.723 -526.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35267",
    "data-name": "Path 35267",
    className: "cls-3",
    d: "M359.977 563.215h-.05L352.5 555l.05.017z",
    transform: "translate(-351.896 -543.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_271",
    "data-name": "Line 271",
    className: "cls-3",
    transform: "translate(.989)",
    d: "M7.008 20.018L0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4814",
    "data-name": "Group 4814",
    transform: "translate(75.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4780",
    "data-name": "Group 4780",
    transform: "translate(4.642 16.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35268",
    "data-name": "Path 35268",
    className: "cls-5",
    d: "M673.951 485.264l8 9.456.05-1.308-.05.017-.034-.05c.034-.017.05-.034.084-.034l.067-1.693-.017-.033h.017v-.067l-.033.017-.05-.1.05-.017.033.084.067-1.677-1.442-5.449-6.639.5a1.085 1.085 0 0 1-.103.354zm-.134.084l-.3-.352-.486.57-.889-.2-.3-.889.587-.687.05.017.654.151.033-.469a1.2 1.2 0 0 0-.872-.033 1.292 1.292 0 0 0 .821 2.448 1.09 1.09 0 0 0 .702-.556zm-.57-1.911a.949.949 0 0 1 .218.134l2.045-3.739-2.029-.3zm.184-3.99l.117-1.962-2.33.838a.992.992 0 0 1 .067.453.762.762 0 0 1-.084.335zm-2.3-.285l-.268-.034.033.084-.05.017-.034-.1-.57.3-.587-.386.034-.721.62-.319.369.251.151-.335a.819.819 0 0 0-.52-.184.991.991 0 0 0-.1 1.978.964.964 0 0 0 .926-.551zm-.034-.956a.657.657 0 0 0-.134-.168l-.117.268zm-.235.855l.3.05a.96.96 0 0 0 .017-.754l-.268.1zm.134-1.09a1.072 1.072 0 0 1 .168.218l2.4-.872.352-5.7h-.033zm2.75-6.455l.1-.235-.346-.281.084-.536.52-.184.436.352-.067.419.252.084a.782.782 0 0 0-1.308-.822.776.776 0 0 0 .117 1.09c.082.047.149.08.216.114zm1.006-.3a.228.228 0 0 1-.05.067l2.77 2.717c.017 0 .017-.017.034-.017a1.356 1.356 0 0 1 1.827.587 1.2 1.2 0 0 1 .151.453l1.626-.352a1.792 1.792 0 0 1-.151-.453 1.825 1.825 0 0 1 .05-.855zm6.371 2.1l.436.151.8-.738 1.073.386.218 1.14-.788.721.084.469a1.62 1.62 0 1 0-1.827-2.129zm2.666 8.315l-.989-6.035-.067.017-.2 5.113.956 1.157a1.99 1.99 0 0 1 .304-.257zm.168.067l.134.8 1.408-.52 1.291 1.056-.285 1.643-1.492.553-.117.671a2.316 2.316 0 0 0 .7-4.577 2.427 2.427 0 0 0-1.636.369zm-1.76 8.148l1.109 4.154.151-.838a.126.126 0 0 1-.084-.017v-.067a.212.212 0 0 1 .1.017l1.257-7.041a2.438 2.438 0 0 1-1.895-1.811l-.419.033zm-1.442-5.432l1.391 5.231.2-5.365zm-.017-.067l1.609-.117.084-2.012-2.515-.922zm-7.31-.7a.7.7 0 0 0-.184-.117l-.017.385.151-.168zm2.163-3.806l-2.029 3.688 2.6-2.951a.784.784 0 0 1-.184-.687zm.017-.05l.369.05c0-.017 0-.034.017-.034a.8.8 0 0 1 .587-.52l-.235-.822zm-1.995-2.33l-.117 2 2.062.318.771-1.408-.486-1.71zm.3-5.918l-.017.017zm.05.034a.843.843 0 0 0 .453-.084l-.084-.268-.335.117-.017.05zm.7-.318c.017-.017.033-.034.033-.05l-.134-.05zm-.268-.05l.067.251a.441.441 0 0 0 .1-.084l-.168-.168zm.218.2a.929.929 0 0 1-.134.1l1.375 4.963 1.257-.453-.134-.184a1.366 1.366 0 0 1 .352-1.744zm4.812 3.772l-.369.084-.4.687.251.3a1.311 1.311 0 0 0 .527-1.081zm.369 5.9l-1.224-4.577a1.293 1.293 0 0 1-.939-.067l-.838 2.817a1.293 1.293 0 0 1 .251.034.823.823 0 0 1 .553.972zm-3.789-1.174a.723.723 0 0 0 .168.637l.151-.184-.084-.419zm.57-.587a.74.74 0 0 0-.553.486v.034l.218.033.4-.335zm.2-.017l-.067.235.486.168.1.453.235.084a.791.791 0 0 0-.52-.905c-.057-.025-.14-.025-.224-.038zm-.134.017l.034.117.034-.117c-.009-.02-.042-.007-.058-.007zm-.252-.939l.252.889c.034 0 .067-.017.1-.017l.855-2.85c-.033-.017-.05-.034-.084-.05zm.838-2.23l-1.325.486.469 1.66 1.09-1.978a.845.845 0 0 1-.224-.175zm.084-.034a.663.663 0 0 0 .168.134l.134-.252zm.218.168l.067.034.1-.352zm1.023.134l-.117-.419-.671-.034-.117.369a1.141 1.141 0 0 0 .915.077zm-.033-.386l.1.369a.6.6 0 0 0 .151-.067zm-1.123-1.878a1.3 1.3 0 0 0-.335 1.643 1.386 1.386 0 0 0 .134.2l.419-.151-.369-.687.436-.721zm-.386 6.572l.017.05a.847.847 0 0 0 .453-.386l-.251-.084-.3.268.05.1-.05.034-.05-.1-.419-.134-.168.184a1.071 1.071 0 0 0 .235.134.779.779 0 0 0 .436.017l-.017-.034zm5.465.151l-3.645-4.478a.9.9 0 0 1-.184.084l1.224 4.627 2.565.939zm.905 1.106l-.855-1.039-.034 1.123.637.235a2.083 2.083 0 0 1 .262-.325zm.536.419l-.1-.6c-.084.067-.151.134-.235.2zm-.436-.3l-.2.251.587.218zm-.7 1.123a2.458 2.458 0 0 1 .285-.788l-.57-.2-.084 1.995.4-.034a2.359 2.359 0 0 1-.024-.98zm1.107-.469l-.687-.251a2.032 2.032 0 0 0-.268.754 2.415 2.415 0 0 0 .034.922l.7-.05zm-.252 1.475v-.034l-.671.05a2.308 2.308 0 0 0 1.777 1.66l.117-.671zm-2.448-9.439l-1.676.369a1.322 1.322 0 0 1-.553 1.157l3.537 4.325.184-5.046a1.656 1.656 0 0 1-1.485-.812zm.1-.017a1.543 1.543 0 0 0 1.391.721l.017-.5-.905-.335zm-.184-1.391a1.449 1.449 0 0 0-.034.8 1.792 1.792 0 0 0 .151.453l.5-.117-.2-.989zm1.643 1.861v.252h.05zm-5.214-1.174l.318.319.771.034.386.7.4-.084a1.229 1.229 0 0 0-.134-.419 1.281 1.281 0 0 0-1.744-.553zm-3.906 3.219l2.179-.788-1.375-4.963a.873.873 0 0 1-.469.084zm.05 7.662l.2.252a1.257 1.257 0 0 0 .084-.268zm.285-.084a1.779 1.779 0 0 0-.05-.587 1.333 1.333 0 0 0-.335-.536l-.235.268.285.855.017.017zm4.778-.453l.033.084 1.895-.151-.821-3.1-2.314-.855a.822.822 0 0 1-.469.419v.017l-.05.034-.017-.017a.839.839 0 0 1-.721-.151l-2.649 3a1.459 1.459 0 0 1 .369.57 1.49 1.49 0 0 1 .067.6l4.661-.352-.033-.067zm3.269 10.344l1.257-.52v-.017l-.034-.084.034-.017-.017-.067-.05.017-.05-.084.05-.034.033.084-.251-.922v.05l-.117.017v-.067a.285.285 0 0 0 .117-.017l-.8-3.035-.067 1.593.034.084-.034.017zm.939 2.75l-1.324-1.023.218-1.643-7.963-9.405a1.257 1.257 0 0 1-.7.57 1.342 1.342 0 0 1-1.693-.872 1.357 1.357 0 0 1 .8-1.727l-.034-.084.067-.017.034.084a1.355 1.355 0 0 1 .855.034l.235-3.889-2.23-.335a1 1 0 0 1-.218.3l.034.084-.05.017-.017-.05a.976.976 0 0 1-.721.251 1.024 1.024 0 0 1-.956-1.106 1.044 1.044 0 0 1 1.073-1.006 1 1 0 0 1 .536.2l2.85-6.3a.593.593 0 0 1-.218-.134.8.8 0 1 1 1.023-1.241.818.818 0 0 1 .251.956l6.237 2.129a1.638 1.638 0 0 1 1.241-1.107 1.723 1.723 0 0 1 .7 3.37l.972 5.968a2.461 2.461 0 0 1 3.722 2.5 2.489 2.489 0 0 1-2.783 2.045l-1.442 8.131 1.291.989-.218 1.66z",
    transform: "translate(-669.289 -470.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35269",
    "data-name": "Path 35269",
    className: "cls-3",
    d: "M716.95 537.9l-.05.034.05.1.067-.017z",
    transform: "translate(-708.918 -526.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35270",
    "data-name": "Path 35270",
    className: "cls-3",
    d: "M716.05 535.9l-.05.033.05.1.05-.017z",
    transform: "translate(-708.169 -524.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35271",
    "data-name": "Path 35271",
    className: "cls-3",
    d: "M715.55 534.9l-.05.033.05.1.067-.017z",
    transform: "translate(-707.753 -524.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35272",
    "data-name": "Path 35272",
    className: "cls-3",
    d: "M716.55 536.9l-.05.034.05.1.05-.017z",
    transform: "translate(-708.585 -525.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35273",
    "data-name": "Path 35273",
    className: "cls-3",
    d: "M745.967 599.8l-.067.033.05.1.067-.017z",
    transform: "translate(-733.056 -578.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35274",
    "data-name": "Path 35274",
    className: "cls-3",
    d: "M720.75 545.9l-.05.033.05.1.05-.017z",
    transform: "translate(-712.081 -533.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35275",
    "data-name": "Path 35275",
    className: "cls-3",
    d: "M736.15 578.9l-.05.017.05.117.067-.034z",
    transform: "translate(-724.899 -560.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35276",
    "data-name": "Path 35276",
    className: "cls-3",
    d: "M735.667 577.9l-.067.017.067.117.05-.034z",
    transform: "translate(-724.483 -559.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35277",
    "data-name": "Path 35277",
    className: "cls-3",
    d: "M735.25 576.9l-.05.017.05.117.05-.034z",
    transform: "translate(-724.15 -558.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35278",
    "data-name": "Path 35278",
    className: "cls-3",
    d: "M734.75 575.9l-.05.017.05.117.05-.034z",
    transform: "translate(-723.734 -558.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35279",
    "data-name": "Path 35279",
    className: "cls-3",
    d: "M737.55 581.8l-.05.033.05.117.067-.034z",
    transform: "translate(-726.064 -563.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35280",
    "data-name": "Path 35280",
    className: "cls-3",
    d: "M736.65 579.8l-.05.034.05.117.05-.034z",
    transform: "translate(-725.315 -561.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35281",
    "data-name": "Path 35281",
    className: "cls-3",
    d: "M737.067 580.8l-.067.034.05.117.067-.033z",
    transform: "translate(-725.648 -562.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35282",
    "data-name": "Path 35282",
    className: "cls-3",
    d: "M732.45 570.9l-.05.017.05.117.05-.034z",
    transform: "translate(-721.819 -553.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35283",
    "data-name": "Path 35283",
    className: "cls-3",
    d: "M731.95 569.9l-.05.017.05.117.05-.034z",
    transform: "translate(-721.403 -553.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35284",
    "data-name": "Path 35284",
    className: "cls-3",
    d: "M731.05 567.9l-.05.017.05.117.05-.034z",
    transform: "translate(-720.654 -551.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35285",
    "data-name": "Path 35285",
    className: "cls-3",
    d: "M738.05 582.9l-.05.017.05.117.05-.034z",
    transform: "translate(-726.48 -563.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35286",
    "data-name": "Path 35286",
    className: "cls-3",
    d: "M731.467 568.9l-.067.017.05.117.067-.034z",
    transform: "translate(-720.987 -552.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35287",
    "data-name": "Path 35287",
    className: "cls-3",
    d: "M733.85 573.9l-.05.017.05.117.05-.034z",
    transform: "translate(-722.984 -556.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35288",
    "data-name": "Path 35288",
    className: "cls-3",
    d: "M732.867 571.9l-.067.017.05.117.067-.034z",
    transform: "translate(-722.152 -554.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35289",
    "data-name": "Path 35289",
    className: "cls-3",
    d: "M733.35 572.9l-.05.017.05.117.067-.034z",
    transform: "translate(-722.568 -555.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35290",
    "data-name": "Path 35290",
    className: "cls-3",
    d: "M734.267 574.9l-.067.017.05.117.067-.033z",
    transform: "translate(-723.318 -557.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35291",
    "data-name": "Path 35291",
    className: "cls-3",
    d: "M742.75 592.8l-.05.034.05.117.05-.034z",
    transform: "translate(-730.392 -572.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35292",
    "data-name": "Path 35292",
    className: "cls-3",
    d: "M741.767 590.8l-.067.034.05.117.067-.034z",
    transform: "translate(-729.56 -570.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35293",
    "data-name": "Path 35293",
    className: "cls-3",
    d: "M743.167 593.8l-.067.034.05.117.067-.034z",
    transform: "translate(-730.725 -573.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35294",
    "data-name": "Path 35294",
    className: "cls-3",
    d: "M742.25 591.8l-.05.034.05.117.05-.034z",
    transform: "translate(-729.976 -571.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35295",
    "data-name": "Path 35295",
    className: "cls-3",
    d: "M743.65 594.8l-.05.034.05.117.05-.034z",
    transform: "translate(-731.142 -573.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35296",
    "data-name": "Path 35296",
    className: "cls-3",
    d: "M744.567 596.8l-.067.034.05.117.067-.033z",
    transform: "translate(-731.891 -575.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35297",
    "data-name": "Path 35297",
    className: "cls-3",
    d: "M744.15 595.8l-.05.034.05.1.05-.017z",
    transform: "translate(-731.558 -574.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35298",
    "data-name": "Path 35298",
    className: "cls-3",
    d: "M738.95 584.8l-.05.034.05.117.067-.033z",
    transform: "translate(-727.23 -565.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35299",
    "data-name": "Path 35299",
    className: "cls-3",
    d: "M739.45 585.8l-.05.034.05.117.05-.034z",
    transform: "translate(-727.646 -566.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35300",
    "data-name": "Path 35300",
    className: "cls-3",
    d: "M738.55 583.8l-.05.034.05.117.05-.033z",
    transform: "translate(-726.897 -564.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35301",
    "data-name": "Path 35301",
    className: "cls-3",
    d: "M739.867 586.8l-.067.034.067.117.05-.033z",
    transform: "translate(-727.979 -567.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35302",
    "data-name": "Path 35302",
    className: "cls-3",
    d: "M740.367 587.8l-.067.034.05.117.067-.034z",
    transform: "translate(-728.395 -568.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35303",
    "data-name": "Path 35303",
    className: "cls-3",
    d: "M741.35 589.8l-.05.034.05.117.05-.034z",
    transform: "translate(-729.227 -569.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35304",
    "data-name": "Path 35304",
    className: "cls-3",
    d: "M740.85 588.8l-.05.034.05.117.05-.033z",
    transform: "translate(-728.811 -568.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35305",
    "data-name": "Path 35305",
    className: "cls-3",
    d: "M723.05 550.9l-.05.034.05.1.067-.017z",
    transform: "translate(-713.995 -537.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35306",
    "data-name": "Path 35306",
    className: "cls-3",
    d: "M729.567 564.9l-.067.017.067.117.05-.033z",
    transform: "translate(-719.406 -548.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35307",
    "data-name": "Path 35307",
    className: "cls-3",
    d: "M729.15 563.9l-.05.017.05.117.05-.034z",
    transform: "translate(-719.073 -548.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35308",
    "data-name": "Path 35308",
    className: "cls-3",
    d: "M730.067 565.9l-.067.017.05.117.067-.034z",
    transform: "translate(-719.822 -549.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35309",
    "data-name": "Path 35309",
    className: "cls-3",
    d: "M730.55 566.9l-.05.017.05.117.05-.034z",
    transform: "translate(-720.238 -550.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35310",
    "data-name": "Path 35310",
    className: "cls-3",
    d: "M728.667 562.9l-.067.017.05.117.067-.034z",
    transform: "translate(-718.656 -547.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35311",
    "data-name": "Path 35311",
    className: "cls-3",
    d: "M724.45 553.9l-.05.034.05.1.05-.017z",
    transform: "translate(-715.161 -539.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35312",
    "data-name": "Path 35312",
    className: "cls-3",
    d: "M723.55 551.9l-.05.034.05.1.05-.017z",
    transform: "translate(-714.411 -538.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35313",
    "data-name": "Path 35313",
    className: "cls-3",
    d: "M724.95 554.9l-.05.017.05.117.05-.017z",
    transform: "translate(-715.577 -540.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35314",
    "data-name": "Path 35314",
    className: "cls-3",
    d: "M726.35 557.9l-.05.017.05.117.05-.034z",
    transform: "translate(-716.742 -543.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35315",
    "data-name": "Path 35315",
    className: "cls-3",
    d: "M725.867 556.9l-.067.017.05.117.067-.017z",
    transform: "translate(-716.326 -542.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35316",
    "data-name": "Path 35316",
    className: "cls-3",
    d: "M726.85 558.9l-.05.017.05.117.05-.017z",
    transform: "translate(-717.158 -543.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35317",
    "data-name": "Path 35317",
    className: "cls-3",
    d: "M727.25 559.9l-.05.017.05.117.067-.017z",
    transform: "translate(-717.491 -544.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35318",
    "data-name": "Path 35318",
    className: "cls-3",
    d: "M728.25 561.9l-.05.017.05.117.05-.033z",
    transform: "translate(-718.324 -546.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35319",
    "data-name": "Path 35319",
    className: "cls-3",
    d: "M727.75 560.9l-.05.017.05.117.05-.034z",
    transform: "translate(-717.907 -545.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35320",
    "data-name": "Path 35320",
    className: "cls-3",
    d: "M723.967 552.9l-.067.034.067.1.05-.017z",
    transform: "translate(-714.745 -539.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35321",
    "data-name": "Path 35321",
    className: "cls-3",
    d: "M718.85 541.9l-.05.034.05.1.05-.017z",
    transform: "translate(-710.499 -529.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35322",
    "data-name": "Path 35322",
    className: "cls-3",
    d: "M720.25 544.9l-.05.034.05.1.05-.017z",
    transform: "translate(-711.665 -532.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35323",
    "data-name": "Path 35323",
    className: "cls-3",
    d: "M719.767 543.9l-.067.034.05.1.067-.017z",
    transform: "translate(-711.248 -531.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35324",
    "data-name": "Path 35324",
    className: "cls-3",
    d: "M719.35 542.9l-.05.034.05.1.05-.017z",
    transform: "translate(-710.915 -530.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35325",
    "data-name": "Path 35325",
    className: "cls-3",
    d: "M717.95 539.9l-.05.034.05.1.05-.017z",
    transform: "translate(-709.75 -528.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35326",
    "data-name": "Path 35326",
    className: "cls-3",
    d: "M718.367 540.9l-.067.033.05.1.067-.017z",
    transform: "translate(-710.083 -529.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35327",
    "data-name": "Path 35327",
    className: "cls-3",
    d: "M721.65 547.9l-.05.034.05.1.05-.017z",
    transform: "translate(-712.83 -534.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35328",
    "data-name": "Path 35328",
    className: "cls-3",
    d: "M721.167 546.9l-.067.034.05.1.067-.017z",
    transform: "translate(-712.414 -534.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35329",
    "data-name": "Path 35329",
    className: "cls-3",
    d: "M717.45 538.9l-.05.034.05.1.05-.017z",
    transform: "translate(-709.334 -527.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35330",
    "data-name": "Path 35330",
    className: "cls-3",
    d: "M722.567 549.9l-.067.034.05.1.067-.017z",
    transform: "translate(-713.579 -536.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35331",
    "data-name": "Path 35331",
    className: "cls-3",
    d: "M722.15 548.9l-.05.033.05.1.05-.017z",
    transform: "translate(-713.246 -535.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35332",
    "data-name": "Path 35332",
    className: "cls-3",
    d: "M679.4 527.333l.034.1.067-.017-.034-.117z",
    transform: "translate(-677.705 -517.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35333",
    "data-name": "Path 35333",
    className: "cls-3",
    d: "M679.8 528.417l.034.117.05-.017-.034-.117z",
    transform: "translate(-678.038 -518.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35334",
    "data-name": "Path 35334",
    className: "cls-3",
    d: "M678.734 525.434l.067-.034-.05-.1-.05.017z",
    transform: "translate(-677.122 -516.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35335",
    "data-name": "Path 35335",
    className: "cls-3",
    d: "M687.367 550.3l-.067.017.05.117.067-.034z",
    transform: "translate(-684.28 -536.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35336",
    "data-name": "Path 35336",
    className: "cls-3",
    d: "M685.25 544l-.05.017.034.117.067-.017z",
    transform: "translate(-682.533 -531.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35337",
    "data-name": "Path 35337",
    className: "cls-3",
    d: "M684.167 540.9l-.067.017.034.117.067-.017z",
    transform: "translate(-681.617 -529.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35338",
    "data-name": "Path 35338",
    className: "cls-3",
    d: "M684.55 541.9l-.05.017.033.117.05-.017z",
    transform: "translate(-681.95 -529.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35339",
    "data-name": "Path 35339",
    className: "cls-3",
    d: "M683.067 537.7l-.067.034.05.117.05-.034z",
    transform: "translate(-680.701 -526.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35340",
    "data-name": "Path 35340",
    className: "cls-3",
    d: "M683.45 538.8l-.05.017.033.117.067-.017z",
    transform: "translate(-681.034 -527.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35341",
    "data-name": "Path 35341",
    className: "cls-3",
    d: "M683.767 539.8l-.067.033.05.1.05-.017z",
    transform: "translate(-681.284 -528.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35342",
    "data-name": "Path 35342",
    className: "cls-3",
    d: "M684.867 543l-.067.017.05.117.05-.017z",
    transform: "translate(-682.2 -530.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35343",
    "data-name": "Path 35343",
    className: "cls-3",
    d: "M685.95 546.1l-.05.017.05.117.05-.017z",
    transform: "translate(-683.115 -533.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35344",
    "data-name": "Path 35344",
    className: "cls-3",
    d: "M685.567 545l-.067.033.05.117.05-.034z",
    transform: "translate(-682.782 -532.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35345",
    "data-name": "Path 35345",
    className: "cls-3",
    d: "M687.767 551.3l-.067.017.05.117.05-.017z",
    transform: "translate(-684.613 -537.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35346",
    "data-name": "Path 35346",
    className: "cls-3",
    d: "M686.35 547.1l-.05.017.034.117.05-.017z",
    transform: "translate(-683.448 -534.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35347",
    "data-name": "Path 35347",
    className: "cls-3",
    d: "M682.75 536.7l-.05.017.034.117.05-.017z",
    transform: "translate(-680.452 -525.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35348",
    "data-name": "Path 35348",
    className: "cls-3",
    d: "M680.55 530.5l-.05.017.034.117.067-.017z",
    transform: "translate(-678.62 -520.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35349",
    "data-name": "Path 35349",
    className: "cls-3",
    d: "M680.867 531.5l-.067.017.05.117.05-.017z",
    transform: "translate(-678.87 -521.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35350",
    "data-name": "Path 35350",
    className: "cls-3",
    d: "M686.667 548.2l-.067.017.05.117.05-.017z",
    transform: "translate(-683.698 -535.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35351",
    "data-name": "Path 35351",
    className: "cls-3",
    d: "M680.167 529.4l-.067.017.05.117.05-.017z",
    transform: "translate(-678.288 -519.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35352",
    "data-name": "Path 35352",
    className: "cls-3",
    d: "M681.25 532.5l-.05.034.05.117.05-.034z",
    transform: "translate(-679.203 -522.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35353",
    "data-name": "Path 35353",
    className: "cls-3",
    d: "M682.35 535.7l-.05.017.034.117.067-.017z",
    transform: "translate(-680.119 -524.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35354",
    "data-name": "Path 35354",
    className: "cls-3",
    d: "M681.967 534.6l-.067.017.05.117.05-.017z",
    transform: "translate(-679.786 -523.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35355",
    "data-name": "Path 35355",
    className: "cls-3",
    d: "M681.65 533.6l-.05.017.033.117.067-.017z",
    transform: "translate(-679.536 -522.939)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4781",
    "data-name": "Group 4781",
    transform: "translate(24.102 .351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35356",
    "data-name": "Path 35356",
    className: "cls-5",
    d: "M799.018 390.169l-4.309-11.618-.486 1.207h.05v.067h-.084l-.637 1.576v.017h-.017l-.034.067h.05l.017.117h-.068v-.1l-.62 1.542-.486 5.616 6.4 1.777a3.08 3.08 0 0 1 .224-.268zm.151-.033l.168.436.654-.369.771.486-.017.939-.788.453-.05-.034-.57-.369-.185.419a1.156 1.156 0 0 0 .8.319 1.3 1.3 0 0 0 .05-2.6 1.428 1.428 0 0 0-.833.319zm-.117 2a.88.88 0 0 1-.168-.184l-3.185 2.817 1.811.972zm-1.526 3.688l-.788 1.811h2.462a1.082 1.082 0 0 1 .084-.453 1.82 1.82 0 0 1 .184-.3zm2.062 1.056l.235.134v-.1h.067v.1l.637-.084.419.57-.285.654-.687.1-.268-.369-.251.268a.867.867 0 0 0 .419.352.957.957 0 0 0 1.257-.553.951.951 0 0 0-1.542-1.073zm-.285.905a.711.711 0 0 0 .067.2l.2-.2zm.5-.721l-.268-.134a1.036 1.036 0 0 0-.184.285.938.938 0 0 0-.084.419h.285zm-.5.989a1.488 1.488 0 0 1-.084-.252h-2.548l-2.263 5.247.017.017zm-4.778 5.13l-.184.184.235.386-.268.486h-.553l-.285-.486.2-.369-.2-.168a.756.756 0 0 0-.1.922.759.759 0 1 0 1.308-.771.526.526 0 0 0-.153-.188zm-1.039-.05c.017-.017.05-.034.067-.05l-1.676-3.487-.034.017a1.34 1.34 0 0 1-1.509-1.174 1.469 1.469 0 0 1 0-.47l-1.643-.218a1.592 1.592 0 0 1-.017.486 1.762 1.762 0 0 1-.335.788zm-5.264-4.141l-.352-.285-1.006.419-.872-.721.184-1.157.989-.4.084-.469a1.628 1.628 0 0 0-.453 3.219 1.678 1.678 0 0 0 1.425-.611zm.3-8.735l-1.123 6.019c.017 0 .05.017.067.017l1.928-4.761-.5-1.408a1.382 1.382 0 0 1-.371.129zm-.134-.117l.151-.8-1.492.017-.855-1.442.822-1.459 1.576-.017.335-.587a2.319 2.319 0 0 0-2.213 4.074 2.474 2.474 0 0 0 1.677.209zm4.426-7.075l.369-4.292-.436.738c.034.017.05.034.084.034l-.034.05c-.034-.017-.05-.034-.084-.034l-3.571 6.2a2.489 2.489 0 0 1 1.174 2.347l.4.117zm-.486 5.6l.469-5.4-2.012 4.979zm0 .067l-1.559-.436-.755 1.878 2.045 1.727zm6.622 3.152a.66.66 0 0 0 .134.168l.151-.352-.2.117zm-3.32 2.85l3.169-2.783-3.437 1.895a.8.8 0 0 1-.05.7zm-.05.05l-.319-.168c-.017.017-.017.017-.017.034a.806.806 0 0 1-.721.285l-.067.855zm1.09 2.867l.788-1.844-1.828-.989-1.207 1.056-.134 1.777zm-2.28 5.465zm-.05-.05a.7.7 0 0 0-.453-.067l-.017.285h.352l.034-.034zm-.771.067c-.017.017-.034.017-.05.034l.117.084zm.251.134l.017-.268a.438.438 0 0 0-.134.05l.117.218zm-.134-.268l.151-.05.4-5.147H792.9c.017.067.034.151.05.218a1.352 1.352 0 0 1-.922 1.509zm-3.236-5.18l.369.05.62-.5-.134-.369a1.178 1.178 0 0 0-.854.814zm1.643-5.683l-.419 4.728a1.309 1.309 0 0 1 .855.386l1.76-2.364a1.381 1.381 0 0 1-.218-.117.818.818 0 0 1-.184-1.09zm3.152 2.4a.748.748 0 0 0 .05-.654l-.218.117-.05.419zm-.721.352a.775.775 0 0 0 .687-.268c0-.017.017-.017.017-.034l-.2-.1-.486.184zm-.2-.05l.151-.2-.4-.319.067-.469-.2-.168a.764.764 0 0 0 .168 1.023 1.1 1.1 0 0 0 .214.125zm.134.034l.017-.117-.084.1c.017-.009.05.008.067.008zm-.067.972l.067-.922c-.034 0-.067-.017-.1-.017l-1.777 2.4c.017.017.034.05.067.084zm-1.559 1.811h1.408l.134-1.727-1.677 1.492a1.067 1.067 0 0 1 .135.226zm-.1 0a.7.7 0 0 0-.117-.184l-.218.184zm-.134-.235c-.017-.017-.033-.05-.05-.067l-.218.285zm-.922-.486l-.034.419.62.251.235-.318a1.312 1.312 0 0 0-.822-.361zm-.084.386l.034-.386a.628.628 0 0 0-.168.017zm.4 2.146a1.285 1.285 0 0 0 .872-1.425c-.017-.084-.033-.168-.05-.235h-.469l.117.771-.654.536zm2.6-6.052v-.05a.833.833 0 0 0-.553.2l.2.168.369-.134-.017-.117h.067v.117l.335.268.218-.117a.533.533 0 0 0-.184-.2.771.771 0 0 0-.4-.168v.05zm-5.08-2l1.911 5.449c.067 0 .134-.017.2-.017l.419-4.761-2.079-1.76zm-.47-1.358l.453 1.257.419-1.039-.52-.436a3.973 3.973 0 0 1-.351.214zm-.369-.57l-.117.6a1.447 1.447 0 0 0 .285-.117zm.318.419a1.446 1.446 0 0 0 .268-.168l-.469-.4zm1.04-.8a2.244 2.244 0 0 1-.536.654l.469.386.754-1.844-.386-.1a2.748 2.748 0 0 1-.3.899zm-1.207.067l.57.469a2.686 2.686 0 0 0 .52-.62 2.218 2.218 0 0 0 .285-.872l-.671-.184zm.721-1.308l-.017.034.654.184a2.325 2.325 0 0 0-1.09-2.163l-.335.587zm-.888 9.724l1.71.218a1.328 1.328 0 0 1 .905-.905l-1.844-5.264-1.894 4.694a1.655 1.655 0 0 1 1.123 1.248zm-.117-.017a1.6 1.6 0 0 0-1.056-1.157l-.184.469.738.62zm-.285 1.375a1.833 1.833 0 0 0 .319-.738 1.473 1.473 0 0 0 0-.469l-.5-.067-.151 1.006zm-.922-2.314l.084-.235a.062.062 0 0 1-.05-.017zm4.51 2.884l-.2-.4-.721-.3-.118-.788-.4-.05a1.375 1.375 0 0 0-.017.453 1.3 1.3 0 0 0 1.459 1.09zm4.778-1.71h-2.314l-.386 5.13a.783.783 0 0 1 .469.084zm2.548-7.226l-.117-.319a1.193 1.193 0 0 0-.168.235zm-.3-.034a1.3 1.3 0 0 0-.134.57 1.522 1.522 0 0 0 .134.62l.318-.184.017-.905v-.017zm-4.644-1.19l-.017-.1-1.827-.5-.285 3.185 1.878 1.593a.838.838 0 0 1 .587-.235v-.017h.067v.034a.771.771 0 0 1 .436.184.752.752 0 0 1 .184.218l3.5-1.928a1.464 1.464 0 0 1-.151-.671 1.315 1.315 0 0 1 .134-.587l-4.493-1.257v.084zm.436-10.847l-1.358.067v.084h-.05v.067h.05l.017.117h-.067v-.084l-.084.956.017-.05.117.033-.017.05c-.034-.017-.084-.017-.117-.034l-.268 3.135.587-1.475v-.084h.034zm.067-2.9l.905 1.408-.771 1.475 4.292 11.568a1.3 1.3 0 0 1 .855-.3 1.341 1.341 0 0 1 1.291 1.408 1.371 1.371 0 0 1-1.341 1.358v.084h-.067v-.084a1.323 1.323 0 0 1-.788-.318l-1.542 3.588 1.978 1.073a1.4 1.4 0 0 1 .3-.218v-.084h.067v.067a.98.98 0 0 1 .754 0 1.065 1.065 0 0 1-.821 1.962 1.052 1.052 0 0 1-.436-.369l-4.828 4.962a.671.671 0 0 1 .168.2.809.809 0 0 1-.268 1.123.841.841 0 0 1-1.123-.3.854.854 0 0 1 .1-.989l-5.147-4.124a1.648 1.648 0 0 1-2.917-1.341 1.7 1.7 0 0 1 1.861-1.459l1.106-5.952a2.472 2.472 0 1 1 .654-4.61l4.124-7.159-.872-1.375.771-1.492z",
    transform: "translate(-785.365 -375.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4787",
    "data-name": "Group 4787",
    transform: "translate(9.364 17.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4782",
    "data-name": "Group 4782",
    transform: "translate(0 17.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35357",
    "data-name": "Path 35357",
    className: "cls-3",
    d: "M701.6 591.344l.017-1.174 1.023-.57.989.6-.017 1.157-1.006.57z",
    transform: "translate(-700.905 -589.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35358",
    "data-name": "Path 35358",
    className: "cls-5",
    d: "M700.548 588.878a1.6 1.6 0 1 1-.57-2.2 1.612 1.612 0 0 1 .57 2.2zm.1.067a1.714 1.714 0 1 0-2.347.6 1.737 1.737 0 0 0 2.347-.6z",
    transform: "translate(-697.455 -586.355)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35359",
    "data-name": "Path 35359",
    className: "cls-3",
    d: "M707.1 504.554l.4-17.754h.134l-.4 17.754z",
    transform: "translate(-705.483 -485.496)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4783",
    "data-name": "Group 4783",
    transform: "translate(14.951 14.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35360",
    "data-name": "Path 35360",
    className: "cls-3",
    d: "M789.807 567.436l-.168.6-.6.168-.436-.453.151-.6.62-.151z",
    transform: "translate(-788.271 -566.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35361",
    "data-name": "Path 35361",
    className: "cls-5",
    d: "M786.966 565.37a.87.87 0 0 1 1.224 0 .855.855 0 0 1-.017 1.224.87.87 0 0 1-1.224 0 .855.855 0 0 1 .017-1.224zm-.05-.034a.925.925 0 1 0 1.308.017.9.9 0 0 0-1.308-.016z",
    transform: "translate(-786.637 -565.062)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4784",
    "data-name": "Group 4784",
    transform: "translate(1.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35362",
    "data-name": "Path 35362",
    className: "cls-3",
    d: "M708.157 481.169l-.067.62-.587.268-.5-.386.084-.62.57-.252z",
    transform: "translate(-706.652 -480.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35363",
    "data-name": "Path 35363",
    className: "cls-5",
    d: "M705.155 479.44a.863.863 0 1 1 .184 1.207.86.86 0 0 1-.184-1.207zm-.05-.034a.924.924 0 1 0 1.291-.2.918.918 0 0 0-1.291.2z",
    transform: "translate(-704.925 -479.025)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4785",
    "data-name": "Group 4785",
    transform: "translate(10.987 19.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35364",
    "data-name": "Path 35364",
    className: "cls-3",
    d: "M765.772 596.734l.268.57-.335.52-.62-.033-.285-.57.335-.52z",
    transform: "translate(-764.496 -596.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35365",
    "data-name": "Path 35365",
    className: "cls-5",
    d: "M763.057 595.386a.89.89 0 0 1 .922-.821.86.86 0 0 1 .8.905.89.89 0 0 1-.922.822.86.86 0 0 1-.8-.906zm-.067-.017a.92.92 0 0 0 .872.972.91.91 0 0 0 .972-.872.92.92 0 0 0-.872-.972.943.943 0 0 0-.972.872z",
    transform: "translate(-762.988 -594.497)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4786",
    "data-name": "Group 4786",
    transform: "translate(14.055 8.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35366",
    "data-name": "Path 35366",
    className: "cls-3",
    d: "M783.3 529.1l.117.4-.3.3-.4-.1-.117-.4.285-.3z",
    transform: "translate(-782.381 -528.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35367",
    "data-name": "Path 35367",
    className: "cls-5",
    d: "M781.344 528.122a.571.571 0 0 1 .7-.436.586.586 0 0 1-.268 1.14.583.583 0 0 1-.432-.704zm-.034-.017a.628.628 0 1 0 .754-.469.644.644 0 0 0-.753.47z",
    transform: "translate(-781.293 -527.623)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35368",
    "data-name": "Path 35368",
    className: "cls-3",
    d: "M724.511 570.9l.034.134-13.211 3.839-.033-.134z",
    transform: "translate(-708.979 -555.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35369",
    "data-name": "Path 35369",
    className: "cls-3",
    d: "M723.04 531.634l-12.406 10.679-.034-.05 12.406-10.663z",
    transform: "translate(-708.396 -522.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35370",
    "data-name": "Path 35370",
    className: "cls-3",
    d: "M786.524 538.4l-1.224-6.086.134-.017 1.224 6.086z",
    transform: "translate(-770.573 -523.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35371",
    "data-name": "Path 35371",
    className: "cls-3",
    d: "M711.8 593.9l.017-.2 9.3.905-.017.2z",
    transform: "translate(-709.395 -574.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35372",
    "data-name": "Path 35372",
    className: "cls-3",
    d: "M769.2 576.909l3.672-4.309.151.117-3.688 4.309z",
    transform: "translate(-757.172 -556.912)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4799",
    "data-name": "Group 4799",
    transform: "translate(14.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4788",
    "data-name": "Group 4788",
    transform: "translate(6.828 7.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35373",
    "data-name": "Path 35373",
    className: "cls-3",
    d: "M772.81 422.718l.3.989-.721.754-.989-.218-.3-.989.7-.754z",
    transform: "translate(-770.576 -421.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35374",
    "data-name": "Path 35374",
    className: "cls-5",
    d: "M768.112 420.485a1.427 1.427 0 1 1 1.073 1.71 1.422 1.422 0 0 1-1.073-1.71zm-.1-.034a1.523 1.523 0 1 0 1.827-1.14 1.522 1.522 0 0 0-1.828 1.14z",
    transform: "translate(-767.973 -419.273)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4789",
    "data-name": "Group 4789",
    transform: "translate(12.103 3.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35375",
    "data-name": "Path 35375",
    className: "cls-5",
    d: "M799.464 397.649a.368.368 0 1 1 .285.436.363.363 0 0 1-.285-.436zm-.017 0a.385.385 0 1 0 .453-.3.364.364 0 0 0-.452.3z",
    transform: "translate(-799.437 -397.337)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4790",
    "data-name": "Group 4790",
    transform: "translate(10.287 2.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35376",
    "data-name": "Path 35376",
    className: "cls-3",
    d: "M789.384 386.6l.151.1-.034.184-.168.05-.134-.1.034-.184z",
    transform: "translate(-789.099 -386.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35377",
    "data-name": "Path 35377",
    className: "cls-5",
    d: "M788.634 386.352a.249.249 0 1 1 .318.151.242.242 0 0 1-.318-.151zm-.017 0a.26.26 0 1 0 .151-.335.26.26 0 0 0-.151.335z",
    transform: "translate(-788.6 -386)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35378",
    "data-name": "Path 35378",
    className: "cls-3",
    d: "M779 411.549l7.226-2.649.017.067-7.226 2.649z",
    transform: "translate(-770.323 -402.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35379",
    "data-name": "Path 35379",
    className: "cls-3",
    d: "M764.727 431.8l-1.66 8.55H763l1.677-8.534z",
    transform: "translate(-757.005 -422.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35380",
    "data-name": "Path 35380",
    className: "cls-3",
    d: "M782.439 400.2l.05.034-3.739 4.392-.05-.034z",
    transform: "translate(-770.073 -395.725)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4791",
    "data-name": "Group 4791",
    transform: "translate(6.913 3.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35381",
    "data-name": "Path 35381",
    className: "cls-3",
    d: "M769.5 392.8l.252.1.033.251-.2.168-.252-.084-.033-.268z",
    transform: "translate(-769.162 -392.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35382",
    "data-name": "Path 35382",
    className: "cls-5",
    d: "M768.58 392.759a.366.366 0 0 1 .05-.5.351.351 0 0 1 .5.05.366.366 0 0 1-.05.5.338.338 0 0 1-.5-.05zm-.017.017a.393.393 0 0 0 .536.067.376.376 0 1 0-.469-.587.344.344 0 0 0-.067.52z",
    transform: "translate(-768.475 -392.167)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4792",
    "data-name": "Group 4792",
    transform: "translate(4.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35383",
    "data-name": "Path 35383",
    className: "cls-3",
    d: "M755.385 374.3l.2.151-.034.268-.235.1-.218-.168.034-.251z",
    transform: "translate(-754.953 -374.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35384",
    "data-name": "Path 35384",
    className: "cls-5",
    d: "M754.285 374.043a.34.34 0 0 1 .2-.469.358.358 0 0 1 .469.184.34.34 0 0 1-.2.469.345.345 0 0 1-.469-.184zm-.034 0a.383.383 0 0 0 .7-.3.375.375 0 0 0-.5-.2.389.389 0 0 0-.199.5z",
    transform: "translate(-754.222 -373.508)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35385",
    "data-name": "Path 35385",
    className: "cls-3",
    d: "M770.8 395.217l.05-.017.821 5.164h-.05z",
    transform: "translate(-763.498 -391.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35386",
    "data-name": "Path 35386",
    className: "cls-3",
    d: "M781.96 387.717l-1.626 6.388-.033-.017 1.643-6.388z",
    transform: "translate(-771.405 -385.321)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4793",
    "data-name": "Group 4793",
    transform: "translate(2.914 12.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35387",
    "data-name": "Path 35387",
    className: "cls-3",
    d: "M745.617 447.9l-.017-.251.235-.151.218.134.017.252-.218.134z",
    transform: "translate(-745.437 -447.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35388",
    "data-name": "Path 35388",
    className: "cls-5",
    d: "M745.341 447.374a.351.351 0 0 1-.486.151.36.36 0 1 1 .335-.637.343.343 0 0 1 .151.486zm.017.017a.386.386 0 1 0-.52.168.4.4 0 0 0 .52-.169z",
    transform: "translate(-744.624 -446.824)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794",
    transform: "translate(.939 10.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35389",
    "data-name": "Path 35389",
    className: "cls-3",
    d: "M734.117 436.27l-.017-.369.3-.2.319.168.017.369-.3.2z",
    transform: "translate(-733.889 -435.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35390",
    "data-name": "Path 35390",
    className: "cls-5",
    d: "M733.826 435.508a.52.52 0 0 1-.687.218.5.5 0 0 1-.2-.687.52.52 0 0 1 .687-.218.53.53 0 0 1 .2.687zm.017.017a.533.533 0 1 0-.721.218.516.516 0 0 0 .721-.218z",
    transform: "translate(-732.844 -434.745)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795",
    transform: "translate(5.674 17.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35391",
    "data-name": "Path 35391",
    className: "cls-3",
    d: "M762.1 481.42l-.2-.184.067-.268.268-.067.2.184-.067.268z",
    transform: "translate(-761.764 -480.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35392",
    "data-name": "Path 35392",
    className: "cls-5",
    d: "M761.861 480.375a.377.377 0 1 1-.469-.251.372.372 0 0 1 .469.251zm.017 0a.4.4 0 1 0-.268.5.417.417 0 0 0 .268-.5z",
    transform: "translate(-761.088 -480.088)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4796",
    "data-name": "Group 4796",
    transform: "translate(3.888 9.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35393",
    "data-name": "Path 35393",
    className: "cls-3",
    d: "M751.384 433.3l-.184-.184.067-.251.251-.067.184.184-.067.252z",
    transform: "translate(-751.072 -432.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35394",
    "data-name": "Path 35394",
    className: "cls-5",
    d: "M751.168 432.332a.36.36 0 0 1-.268.436.353.353 0 0 1-.436-.268.362.362 0 0 1 .7-.168zm.034 0a.388.388 0 1 0-.285.469.407.407 0 0 0 .283-.469z",
    transform: "translate(-750.437 -432.037)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4797",
    "data-name": "Group 4797",
    transform: "translate(4.367 14.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35395",
    "data-name": "Path 35395",
    className: "cls-3",
    d: "M753.9 463.219l-.1-.151.067-.168h.184l.1.134-.084.168z",
    transform: "translate(-753.715 -462.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35396",
    "data-name": "Path 35396",
    className: "cls-5",
    d: "M753.794 462.526a.246.246 0 0 1-.235.268.238.238 0 0 1-.268-.235.248.248 0 0 1 .235-.268.271.271 0 0 1 .268.235zm.017 0a.261.261 0 0 0-.52.05.276.276 0 0 0 .285.251.291.291 0 0 0 .235-.301z",
    transform: "translate(-753.289 -462.289)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4798",
    "data-name": "Group 4798",
    transform: "translate(0 14.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35397",
    "data-name": "Path 35397",
    className: "cls-3",
    d: "M727.917 458.785l-.017-.184.151-.1.168.084.017.168-.151.117z",
    transform: "translate(-727.79 -458.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35398",
    "data-name": "Path 35398",
    className: "cls-5",
    d: "M727.739 458.4a.246.246 0 0 1-.335.117.267.267 0 0 1-.117-.335.246.246 0 0 1 .335-.117.256.256 0 0 1 .117.335zm.017.017a.266.266 0 1 0-.352.134.289.289 0 0 0 .352-.131z",
    transform: "translate(-727.243 -458.041)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35399",
    "data-name": "Path 35399",
    className: "cls-3",
    d: "M747.633 434.051L747.6 434l4.594-2.9.017.05z",
    transform: "translate(-744.187 -421.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35400",
    "data-name": "Path 35400",
    className: "cls-3",
    d: "M754.9 436.3l3.185-5.5.017.017-3.185 5.5z",
    transform: "translate(-750.263 -421.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35401",
    "data-name": "Path 35401",
    className: "cls-3",
    d: "M790.55 387.9l1.66 1.962-.05.05-1.66-1.962z",
    transform: "translate(-779.895 -385.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35402",
    "data-name": "Path 35402",
    className: "cls-3",
    d: "M774.351 387.7l.017.05-3.051.972-.017-.067z",
    transform: "translate(-763.914 -385.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35403",
    "data-name": "Path 35403",
    className: "cls-3",
    d: "M762.216 378.211l-.017.017-5.6-1.894v-.034z",
    transform: "translate(-751.678 -375.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35404",
    "data-name": "Path 35404",
    className: "cls-3",
    d: "M756.95 375.7l2.33 2.984-.05.034-2.33-2.984z",
    transform: "translate(-751.928 -375.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35405",
    "data-name": "Path 35405",
    className: "cls-3",
    d: "M746.85 449.9l1.258 2.263-.05.034-1.257-2.28z",
    transform: "translate(-743.521 -437.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35406",
    "data-name": "Path 35406",
    className: "cls-3",
    d: "M756.788 432.3v.084l-3.571.3-.017-.084z",
    transform: "translate(-748.848 -422.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35407",
    "data-name": "Path 35407",
    className: "cls-3",
    d: "M747.789 434.933l-.922 2.2-.067-.034.905-2.2z",
    transform: "translate(-743.521 -424.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35408",
    "data-name": "Path 35408",
    className: "cls-3",
    d: "M739.515 434.4l.017.05-2.515.4-.017-.05z",
    transform: "translate(-735.364 -424.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35409",
    "data-name": "Path 35409",
    className: "cls-3",
    d: "M736.65 437.7l1.593 1.911-.05.034-1.593-1.911z",
    transform: "translate(-735.031 -426.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35410",
    "data-name": "Path 35410",
    className: "cls-3",
    d: "M732.084 449.3l.017.017-2.884 1.693-.017-.034z",
    transform: "translate(-728.872 -436.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35411",
    "data-name": "Path 35411",
    className: "cls-3",
    d: "M729.824 439.017l-1.291 3.387h-.033l1.308-3.4z",
    transform: "translate(-728.289 -428.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35412",
    "data-name": "Path 35412",
    className: "cls-3",
    d: "M754.917 463.7l1.291 3.035-.017.017-1.291-3.052z",
    transform: "translate(-750.263 -448.579)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4801",
    "data-name": "Group 4801",
    transform: "translate(20.974 29.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4800",
    "data-name": "Group 4800",
    transform: "translate(0 1.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35413",
    "data-name": "Path 35413",
    className: "cls-3",
    d: "M768.2 558.018l.352-.318.436.151.1.453-.352.318-.436-.134z",
    transform: "translate(-767.949 -557.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35414",
    "data-name": "Path 35414",
    className: "cls-5",
    d: "M767.541 557.668a.651.651 0 1 1 .5-.771.67.67 0 0 1-.5.771zm0 .034a.7.7 0 0 0 .536-.822.714.714 0 0 0-.822-.536.7.7 0 0 0-.536.822.688.688 0 0 0 .822.534z",
    transform: "translate(-766.703 -556.332)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35415",
    "data-name": "Path 35415",
    className: "cls-3",
    d: "M777.4 547.734l-5.4 1.894v-.034l5.4-1.894z",
    transform: "translate(-771.112 -547.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809",
    transform: "translate(0 9.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4802",
    "data-name": "Group 4802",
    transform: "translate(14.433 20.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35416",
    "data-name": "Path 35416",
    className: "cls-3",
    d: "M732.656 561.214l-.956-.671.1-1.157 1.056-.486.956.654-.1 1.157z",
    transform: "translate(-731.028 -558.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35417",
    "data-name": "Path 35417",
    className: "cls-5",
    d: "M730.877 556.563a1.631 1.631 0 0 1-.788 2.146 1.6 1.6 0 0 1-2.129-.771 1.631 1.631 0 0 1 .788-2.146 1.591 1.591 0 0 1 2.129.771zm.084-.05a1.716 1.716 0 0 0-2.28-.822 1.737 1.737 0 0 0-.838 2.28 1.721 1.721 0 0 0 3.118-1.458z",
    transform: "translate(-727.69 -555.528)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35418",
    "data-name": "Path 35418",
    className: "cls-3",
    d: "M662.918 512.245L648.5 501.917l.067-.117L663 512.127z",
    transform: "translate(-647.343 -489.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35419",
    "data-name": "Path 35419",
    className: "cls-3",
    d: "M733.634 584.331h-.134l.6-13.731h.151z",
    transform: "translate(-718.093 -547.245)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803",
    transform: "translate(19.669 7.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35420",
    "data-name": "Path 35420",
    className: "cls-3",
    d: "M761.621 477.9l.4.469-.218.587-.6.117-.4-.469.2-.6z",
    transform: "translate(-760.485 -477.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35421",
    "data-name": "Path 35421",
    className: "cls-5",
    d: "M759 476.968a.868.868 0 1 1 1.006.7.872.872 0 0 1-1.006-.7zm-.067.017a.907.907 0 0 0 1.073.738.93.93 0 0 0 .754-1.073.907.907 0 0 0-1.073-.738.939.939 0 0 0-.751 1.072z",
    transform: "translate(-758.923 -475.894)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4804",
    "data-name": "Group 4804",
    transform: "translate(25.549 7.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35422",
    "data-name": "Path 35422",
    className: "cls-3",
    d: "M797.757 481.3l.553.671-.3.822-.855.151-.553-.654.285-.821z",
    transform: "translate(-796.163 -480.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35423",
    "data-name": "Path 35423",
    className: "cls-5",
    d: "M794.095 480.084a1.215 1.215 0 0 1 .972-1.408 1.2 1.2 0 0 1 1.391.972 1.224 1.224 0 0 1-.972 1.408 1.2 1.2 0 0 1-1.391-.972zm-.084.017a1.281 1.281 0 0 0 1.492 1.039 1.312 1.312 0 0 0 1.039-1.492 1.286 1.286 0 1 0-2.532.453z",
    transform: "translate(-793.993 -478.59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4805",
    "data-name": "Group 4805",
    transform: "translate(0 10.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35424",
    "data-name": "Path 35424",
    className: "cls-3",
    d: "M644.3 496.8l.486.4-.117.62-.6.2-.469-.4.117-.62z",
    transform: "translate(-643.265 -496.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35425",
    "data-name": "Path 35425",
    className: "cls-5",
    d: "M641.718 496.182a.87.87 0 1 1 1.107.537.88.88 0 0 1-1.107-.537zm-.067.034a.923.923 0 1 0 .57-1.174.923.923 0 0 0-.57 1.174z",
    transform: "translate(-641.601 -494.991)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806",
    transform: "translate(21.506 13.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35426",
    "data-name": "Path 35426",
    className: "cls-3",
    d: "M772.086 514l.6.1.235.57-.369.5-.62-.1-.235-.57z",
    transform: "translate(-771.395 -513.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35427",
    "data-name": "Path 35427",
    className: "cls-5",
    d: "M770.27 513.642a.86.86 0 1 1 1.207-.151.872.872 0 0 1-1.207.151zm-.034.05a.921.921 0 1 0-.168-1.291.932.932 0 0 0 .169 1.291z",
    transform: "translate(-769.881 -512.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807",
    transform: "translate(13.868 5.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35428",
    "data-name": "Path 35428",
    className: "cls-3",
    d: "M726 462.8l.419.117.084.419-.319.285-.4-.134-.084-.4z",
    transform: "translate(-725.469 -462.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35429",
    "data-name": "Path 35429",
    className: "cls-5",
    d: "M724.518 462.518a.569.569 0 0 1 .05-.822.581.581 0 1 1 .788.855.6.6 0 0 1-.838-.033zm-.033.017a.629.629 0 1 0 .05-.889.62.62 0 0 0-.051.889z",
    transform: "translate(-724.32 -461.495)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4808",
    "data-name": "Group 4808",
    transform: "translate(23.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35430",
    "data-name": "Path 35430",
    className: "cls-3",
    d: "M781.237 432.6l.285.319-.117.4-.419.1-.285-.318.134-.4z",
    transform: "translate(-780.486 -432.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35431",
    "data-name": "Path 35431",
    className: "cls-5",
    d: "M779.486 432.048a.586.586 0 1 1 .7.436.571.571 0 0 1-.7-.436zm-.05.017a.63.63 0 0 0 .754.469.644.644 0 0 0 .469-.755.63.63 0 0 0-.754-.469.643.643 0 0 0-.469.755z",
    transform: "translate(-779.423 -431.293)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35432",
    "data-name": "Path 35432",
    className: "cls-3",
    d: "M742.109 483.3l.134.05-4.309 13.06-.134-.05z",
    transform: "translate(-721.672 -474.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35433",
    "data-name": "Path 35433",
    className: "cls-3",
    d: "M728.05 465.6l1.777 16.245-.067.017-1.76-16.245z",
    transform: "translate(-713.515 -459.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35434",
    "data-name": "Path 35434",
    className: "cls-3",
    d: "M734.817 467.432l-5.717-2.414.05-.117 5.717 2.414z",
    transform: "translate(-714.431 -459.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35435",
    "data-name": "Path 35435",
    className: "cls-3",
    d: "M738.151 525.193l-.151-.134 6.019-7.159.151.117z",
    transform: "translate(-721.839 -503.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35436",
    "data-name": "Path 35436",
    className: "cls-3",
    d: "M766.975 488.616l-1.475-5.466.184-.05 1.475 5.465z",
    transform: "translate(-744.728 -474.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35437",
    "data-name": "Path 35437",
    className: "cls-3",
    d: "M776.2 493.843l-.1-.084 4.124-4.459.1.084z",
    transform: "translate(-753.551 -479.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35438",
    "data-name": "Path 35438",
    className: "cls-3",
    d: "M771.5 481.091l-5.8-1.257.017-.134 5.818 1.257z",
    transform: "translate(-744.895 -471.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35439",
    "data-name": "Path 35439",
    className: "cls-3",
    d: "M765.05 443.31l-.05-.034 2.951-7.377.05.017z",
    transform: "translate(-744.312 -435.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35440",
    "data-name": "Path 35440",
    className: "cls-3",
    d: "M786.531 443.482L784 435.217l.05-.017 2.532 8.265z",
    transform: "translate(-760.126 -434.545)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4813",
    "data-name": "Group 4813",
    transform: "translate(18.096 24.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810",
    transform: "translate(0 6.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35441",
    "data-name": "Path 35441",
    className: "cls-3",
    d: "M752.019 559.584l.738-.084.436.62-.318.7-.754.084-.419-.62z",
    transform: "translate(-751.337 -559.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35442",
    "data-name": "Path 35442",
    className: "cls-5",
    d: "M750.2 559.042a1.078 1.078 0 0 1 .889-1.961 1.078 1.078 0 0 1-.889 1.961zm-.034.067a1.145 1.145 0 1 0-.52-1.492 1.11 1.11 0 0 0 .522 1.492z",
    transform: "translate(-749.537 -556.936)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811",
    transform: "translate(2.149 1.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35443",
    "data-name": "Path 35443",
    className: "cls-3",
    d: "M764.536 530.6l.553.134.134.57-.436.419-.553-.151-.134-.572z",
    transform: "translate(-763.808 -530.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35444",
    "data-name": "Path 35444",
    className: "cls-5",
    d: "M762.615 530.142a.825.825 0 1 1 1.14 0 .8.8 0 0 1-1.14 0zm-.033.034a.884.884 0 0 0 1.274-1.224.85.85 0 0 0-1.207 0 .858.858 0 0 0-.067 1.223z",
    transform: "translate(-762.357 -528.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35445",
    "data-name": "Path 35445",
    className: "cls-3",
    d: "M761.1 599.491l5.465-6.991.084.1-5.465 6.991z",
    transform: "translate(-759.161 -580.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2185",
    "data-name": "Rectangle 2185",
    className: "cls-3",
    transform: "rotate(-22.544 8.105 -7.02)",
    d: "M0 0h6.706v.134H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35446",
    "data-name": "Path 35446",
    className: "cls-3",
    d: "M767.08 518.9l.033.034-7.88 7.461-.033-.034z",
    transform: "translate(-757.58 -518.878)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4812",
    "data-name": "Group 4812",
    transform: "translate(1.368 2.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35447",
    "data-name": "Path 35447",
    className: "cls-5",
    d: "M757.7 540.224l.05.017.033-.1-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.05-.151l.05.017.033-.1-.05-.017zm.067-.134l.05.017.05-.1-.05-.017zm.067-.151l.05.017.034-.1-.05-.017zm.067-.134l.05.017.033-.1-.05-.017zm.05-.134l.05.017.034-.1-.05-.017zm.067-.151l.05.017.05-.1-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.05-.134l.05.017.034-.1-.05-.017zm.067-.151l.05.017.034-.1-.05-.017zm.067-.134l.05.017.033-.1-.05-.017zm.067-.134l.05.017.033-.1-.05-.017zm.05-.151l.05.017.034-.084-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.067-.151l.05.017.033-.1-.05-.017zm.05-.134l.05.017.033-.084-.05-.017zm.067-.134l.05.017.033-.1-.05-.017zm.067-.151l.05.017.033-.084-.05-.017zm.05-.134l.05.017.034-.1-.05-.017zm.067-.151l.05.017.034-.1-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.067-.134l.05.017.033-.084-.05-.017zm.05-.151l.05.017.033-.1-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.067-.134l.05.017.034-.1-.05-.017zm.05-.151l.05.017.034-.084-.05-.017zm.067-.134l.05.017.033-.1-.05-.017z",
    transform: "translate(-757.7 -536.2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35448",
    "data-name": "Path 35448",
    className: "cls-3",
    d: "M755.07 566.5h.134l-.587 11.249h-.117z",
    transform: "translate(-753.668 -558.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35449",
    "data-name": "Path 35449",
    className: "cls-3",
    d: "M757.133 566.4l6.069 3.521-.034.034-6.069-3.521z",
    transform: "translate(-755.832 -558.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_272",
    "data-name": "Line 272",
    className: "cls-3",
    transform: "translate(.832 .056)",
    d: "M9.103 0L0 19.196"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    "data-name": "Group 4839",
    transform: "translate(44.863 8.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4815",
    "data-name": "Group 4815",
    transform: "translate(14.184 3.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35450",
    "data-name": "Path 35450",
    className: "cls-5",
    d: "M562.652 465.976l-9.808-7.645.218 1.291.033-.033.034.05c-.017.017-.05.034-.067.05l.285 1.677.017.017-.017.017.017.067.034-.034.084.1-.05.033-.05-.067.285 1.66 2.548 5.046 6.4-1.878a2.509 2.509 0 0 1 .037-.351zm.117-.117l.369.285.352-.671h.905l.469.8-.436.8h-.721l.067.453a1.2 1.2 0 0 0 .855-.151 1.3 1.3 0 0 0 .419-1.76 1.264 1.264 0 0 0-1.727-.486 1.287 1.287 0 0 0-.552.73zm.956 1.777a.966.966 0 0 1-.235-.084l-1.224 4.107 2.062-.117zm.654 3.957l.3 1.961 2.1-1.324a1.157 1.157 0 0 1-.168-.419 1.237 1.237 0 0 1 0-.352zm2.314-.2l.268-.017-.05-.084.05-.034.05.084.486-.419.654.268.117.721-.536.453-.419-.168-.084.369a.851.851 0 0 0 .536.084 1 1 0 0 0-.318-1.978.93.93 0 0 0-.755.72zm.235.939a.654.654 0 0 0 .168.134l.067-.285zm.05-.889l-.3.017a1.214 1.214 0 0 0-.017.352.86.86 0 0 0 .168.4l.252-.151zm.1 1.107a.7.7 0 0 1-.2-.184l-2.163 1.358.855 5.683h.034zm-1.358 6.924l-.05.251.4.218.034.553-.469.285-.5-.268-.017-.419-.268-.033a.776.776 0 0 0 .419.838.76.76 0 0 0 1.039-.3.781.781 0 0 0-.335-1.039.882.882 0 0 0-.253-.088zm-.922.5c0-.034.017-.05.033-.084l-3.269-2.1-.033.034a1.377 1.377 0 0 1-1.911-.184 1.4 1.4 0 0 1-.235-.4l-1.509.687a1.736 1.736 0 0 1 .251.419 1.908 1.908 0 0 1 .134.855zm-6.673-.738l-.453-.05-.637.889-1.123-.151-.453-1.09.62-.872-.168-.453a1.632 1.632 0 0 0 1.308 2.984 1.574 1.574 0 0 0 .906-1.255zm-4.342-7.628l2.23 5.734.067-.017-.872-5.08-1.174-.939c-.083.102-.167.22-.251.304zm-.185-.034l-.3-.771-1.257.8-1.492-.771-.067-1.677 1.341-.855-.017-.687a2.347 2.347 0 0 0-2.146 2.431 2.323 2.323 0 0 0 2.414 2.23 2.366 2.366 0 0 0 1.526-.698zm.034-8.4l-1.962-3.873.034.872a.125.125 0 0 0 .084-.017l.017.067a.213.213 0 0 0-.1.017l.235 7.209a2.448 2.448 0 0 1 2.23 1.375l.4-.117zm2.548 5.063l-2.464-4.862.922 5.315zm.034.05l-1.559.453.352 2 2.649.386zm7.293-.821a.951.951 0 0 0 .2.067l-.05-.386-.117.2zm-1.324 4.191l1.224-4.057-1.928 3.454a.862.862 0 0 1 .335.637zm-.017.067l-.369.017v.034a.811.811 0 0 1-.469.637l.4.754zm2.448 1.861l-.285-1.995-2.079.117-.47 1.542.822 1.593zm.956 5.885v-.017zm-.067-.017a.793.793 0 0 0-.419.184l.134.251.3-.184.017-.05zm-.62.469c0 .017-.017.034-.017.05l.151.017zm.268 0l-.117-.235a.3.3 0 0 0-.084.117l.2.117zm-.251-.168c.034-.05.067-.084.1-.134l-2.381-4.61-1.14.721a1.562 1.562 0 0 1 .168.168 1.352 1.352 0 0 1 .017 1.777zm-5.5-2.7l.335-.151.251-.771-.3-.251a1.3 1.3 0 0 0-.286 1.177zm-1.593-5.734l2.146 4.258a1.3 1.3 0 0 1 .939-.117l.235-2.951a1.268 1.268 0 0 1-.252.017.822.822 0 0 1-.738-.838zm3.957.369a.731.731 0 0 0-.3-.587l-.117.218.185.4zm-.453.687a.73.73 0 0 0 .436-.587v-.034l-.218.017-.319.419zm-.184.05l.017-.252-.52-.067-.184-.436-.252-.034a.78.78 0 0 0 .687.788.425.425 0 0 0 .251.006zm.134-.034l-.05-.1-.017.134c.016-.012.05-.012.067-.026zm.453.872l-.419-.821c-.033.017-.067.017-.1.034l-.235 2.984c.034.017.067.017.1.034zm-.369 2.381l1.207-.754-.8-1.542-.654 2.163a.606.606 0 0 1 .246.138zm-.067.034c-.067-.034-.117-.067-.184-.1l-.084.268zm-.251-.117l-.084-.034-.034.369zm-1.039.084l.2.386.671-.117.034-.386a1.314 1.314 0 0 0-.907.121zm.117.369l-.168-.352c-.05.033-.084.067-.134.1zm1.492 1.626a1.3 1.3 0 0 0-.017-1.677 1.562 1.562 0 0 0-.168-.168l-.386.235.5.587-.268.8zm-.989-6.555l-.034-.033a.773.773 0 0 0-.352.469l.251.033.252-.318-.067-.1.05-.034.067.1.436.05.117-.218a1.476 1.476 0 0 0-.252-.084.955.955 0 0 0-.436.067l.034.034zm-5.382.989l4.51 3.638a.6.6 0 0 1 .168-.117l-2.163-4.292-2.7-.386zm-1.123-.905l1.04.838-.2-1.107-.671-.1a1.461 1.461 0 0 1-.172.373zm-.6-.3l.218.57a1.383 1.383 0 0 0 .184-.251zm.486.2a2.164 2.164 0 0 0 .134-.285l-.6-.084zm.453-1.257a2.363 2.363 0 0 1-.117.838l.6.084-.335-1.978-.386.117a2.223 2.223 0 0 1 .233.942zm-.989.7l.738.1a2.124 2.124 0 0 0 .1-.8 2.658 2.658 0 0 0-.218-.905l-.671.2zm-.067-1.492v.033l.654-.184a2.337 2.337 0 0 0-2.079-1.274l.017.687zm4.376 8.768l1.576-.721a1.33 1.33 0 0 1 .3-1.257l-4.359-3.521.872 5.013a1.67 1.67 0 0 1 1.606.497zm-.1.05a1.543 1.543 0 0 0-1.509-.419l.084.5.956.134zm.486 1.325a1.7 1.7 0 0 0-.134-.8 1.635 1.635 0 0 0-.251-.4l-.469.218.4.939zm-2.012-1.492l-.05-.252c-.017 0-.034.017-.05.017zm5.348.084l-.369-.235-.771.134-.52-.6-.369.168a1.321 1.321 0 0 0 .235.385 1.29 1.29 0 0 0 1.794.151zm3.169-4.007L562.669 475l2.381 4.594a.79.79 0 0 1 .436-.184zm-1.66-7.528l-.251-.2a1.631 1.631 0 0 0-.017.285zm-.268.151a1.352 1.352 0 0 0 .184.553 1.175 1.175 0 0 0 .453.453l.184-.319-.469-.788-.017-.017zm-4.577 1.442l-.067-.084-1.827.536 1.459 2.867 2.448.352a.736.736 0 0 1 .386-.5l-.017-.017.05-.034.017.017a.872.872 0 0 1 .469-.084.8.8 0 0 1 .285.084l1.961-3.5a1.45 1.45 0 0 1-.469-.486 1.267 1.267 0 0 1-.184-.587l-4.493 1.324.05.067zm-5.348-9.506l-1.123.771.05.067-.034.033.034.05.034-.034.084.1-.05.034-.05-.067.436.855-.017-.05.117-.034.017.067c-.033.017-.084.017-.117.034l1.425 2.817-.268-1.576-.05-.067.034-.017zm-1.5-2.508l1.509.721.134 1.676 9.757 7.611a1.3 1.3 0 0 1 .57-.7 1.354 1.354 0 0 1 1.844.5 1.385 1.385 0 0 1-.436 1.878l.034.067-.05.034-.05-.067a1.231 1.231 0 0 1-.838.134l.587 3.89 2.247-.134a1.21 1.21 0 0 1 .151-.335l-.05-.084.05-.033.033.05a1 1 0 0 1 .654-.4 1.062 1.062 0 0 1 .335 2.1.938.938 0 0 1-.57-.084l-1.475 6.79a.563.563 0 0 1 .235.084.814.814 0 1 1-1.19.553l-6.555-.788a1.636 1.636 0 0 1-.972 1.341 1.732 1.732 0 0 1-1.392-3.169l-2.2-5.683a2.378 2.378 0 0 1-1.593.671 2.486 2.486 0 0 1-.285-4.962l-.285-8.3-1.475-.7-.134-1.677z",
    transform: "translate(-548.67 -454.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35451",
    "data-name": "Path 35451",
    className: "cls-3",
    d: "M573.7 475.3l.05.034a.346.346 0 0 0 .067-.1l-.05-.034c-.017.033-.05.067-.067.1z",
    transform: "translate(-568.821 -470.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35452",
    "data-name": "Path 35452",
    className: "cls-3",
    d: "M572.75 476.617c.034-.034.05-.067.084-.084l-.05-.034-.084.084z",
    transform: "translate(-567.989 -471.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35453",
    "data-name": "Path 35453",
    className: "cls-3",
    d: "M571.65 477.534c.033-.034.067-.05.084-.084l-.05-.05-.084.084z",
    transform: "translate(-567.073 -472.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35454",
    "data-name": "Path 35454",
    className: "cls-3",
    d: "M558.117 449.567v-.067c-.034 0-.084.017-.117.017l.017.067z",
    transform: "translate(-555.753 -449.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35455",
    "data-name": "Path 35455",
    className: "cls-3",
    d: "M556.534 449.867l-.017-.067c-.033.017-.084.017-.117.034l.017.067a.427.427 0 0 1 .117-.034z",
    transform: "translate(-554.422 -449.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35456",
    "data-name": "Path 35456",
    className: "cls-3",
    d: "M575.45 458.451l.05-.034c-.017-.034-.034-.084-.05-.117l-.05.034a.831.831 0 0 0 .05.117z",
    transform: "translate(-570.236 -456.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35457",
    "data-name": "Path 35457",
    className: "cls-3",
    d: "M555.134 450.267l-.017-.067c-.033.017-.084.034-.117.05l.017.067z",
    transform: "translate(-553.256 -450.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35458",
    "data-name": "Path 35458",
    className: "cls-3",
    d: "M553.751 450.85l-.034-.05c-.033.017-.084.034-.117.05l.033.05c.034-.016.084-.033.118-.05z",
    transform: "translate(-552.091 -450.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35459",
    "data-name": "Path 35459",
    className: "cls-3",
    d: "M552.5 451.5a.353.353 0 0 0-.1.067l.034.05a.354.354 0 0 0 .1-.067z",
    transform: "translate(-551.092 -451.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35460",
    "data-name": "Path 35460",
    className: "cls-3",
    d: "M566.7 480.834l.017.067c.033-.017.084-.034.117-.05l-.033-.05a.655.655 0 0 0-.101.033z",
    transform: "translate(-562.995 -475.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35461",
    "data-name": "Path 35461",
    className: "cls-3",
    d: "M561.417 449.367v-.067h-.117v.067z",
    transform: "translate(-558.5 -449.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35462",
    "data-name": "Path 35462",
    className: "cls-3",
    d: "M562.817 449.484v-.067l-.117-.017v.067c.05 0 .084.017.117.017z",
    transform: "translate(-559.666 -449.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35463",
    "data-name": "Path 35463",
    className: "cls-3",
    d: "M564.317 449.7l.017-.067c-.034-.017-.084-.017-.117-.034l-.017.067a1.083 1.083 0 0 0 .117.034z",
    transform: "translate(-560.914 -449.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35464",
    "data-name": "Path 35464",
    className: "cls-3",
    d: "M565.717 450.1l.017-.067a.31.31 0 0 0-.117-.034l-.017.067z",
    transform: "translate(-562.079 -449.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35465",
    "data-name": "Path 35465",
    className: "cls-3",
    d: "M567.1 450.6l.033-.05c-.033-.017-.084-.034-.117-.05l-.017.067a.24.24 0 0 1 .101.033z",
    transform: "translate(-563.245 -450.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35466",
    "data-name": "Path 35466",
    className: "cls-3",
    d: "M576.367 470.134c.017-.034.017-.084.034-.117l-.067-.017c-.017.034-.017.084-.034.117z",
    transform: "translate(-570.985 -466.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35467",
    "data-name": "Path 35467",
    className: "cls-3",
    d: "M569.334 479.417c.034-.017.067-.05.1-.067l-.034-.05-.1.067z",
    transform: "translate(-565.159 -474.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35468",
    "data-name": "Path 35468",
    className: "cls-3",
    d: "M568.4 451.217l.034-.05a.35.35 0 0 1-.1-.067l-.034.05c.034.017.067.05.1.067z",
    transform: "translate(-564.327 -450.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35469",
    "data-name": "Path 35469",
    className: "cls-3",
    d: "M574.667 457.234l.05-.034a.351.351 0 0 0-.067-.1l-.05.034a.352.352 0 0 1 .067.1z",
    transform: "translate(-569.57 -455.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35470",
    "data-name": "Path 35470",
    className: "cls-3",
    d: "M572.067 453.734l.05-.05-.084-.084-.034.05a.111.111 0 0 0 .068.084z",
    transform: "translate(-567.406 -452.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35471",
    "data-name": "Path 35471",
    className: "cls-3",
    d: "M573.867 456.034l.05-.034-.067-.1-.05.034a.348.348 0 0 1 .067.1z",
    transform: "translate(-568.904 -454.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35472",
    "data-name": "Path 35472",
    className: "cls-3",
    d: "M572.984 454.834l.05-.034c-.034-.034-.05-.067-.084-.1l-.05.034c.034.033.05.066.084.1z",
    transform: "translate(-568.155 -453.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35473",
    "data-name": "Path 35473",
    className: "cls-3",
    d: "M569.7 451.917l.034-.05-.1-.067-.034.05a.35.35 0 0 0 .1.067z",
    transform: "translate(-565.409 -451.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35474",
    "data-name": "Path 35474",
    className: "cls-3",
    d: "M570.8 452.734l.034-.05c-.034-.034-.067-.05-.1-.084l-.034.05a.444.444 0 0 0 .1.084z",
    transform: "translate(-566.324 -452.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35475",
    "data-name": "Path 35475",
    className: "cls-3",
    d: "M544.717 463.4c0 .034-.017.084-.017.117h.067a.283.283 0 0 1 .017-.117z",
    transform: "translate(-544.683 -461.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35476",
    "data-name": "Path 35476",
    className: "cls-3",
    d: "M561 482v.067h.117V482z",
    transform: "translate(-558.25 -476.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35477",
    "data-name": "Path 35477",
    className: "cls-3",
    d: "M575.35 472.751a.812.812 0 0 0 .05-.117l-.05-.033-.05.117z",
    transform: "translate(-570.153 -468.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35478",
    "data-name": "Path 35478",
    className: "cls-3",
    d: "M575.95 471.534c.017-.034.034-.084.05-.117l-.05-.017c-.017.034-.034.084-.05.117z",
    transform: "translate(-570.653 -467.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35479",
    "data-name": "Path 35479",
    className: "cls-3",
    d: "M559.6 481.9v.067a.285.285 0 0 1 .117.017v-.067a.285.285 0 0 1-.117-.017z",
    transform: "translate(-557.085 -476.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35480",
    "data-name": "Path 35480",
    className: "cls-3",
    d: "M556.617 481.4l-.017.067c.034.017.084.017.117.034l.017-.067a.427.427 0 0 1-.117-.034z",
    transform: "translate(-554.588 -476.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35481",
    "data-name": "Path 35481",
    className: "cls-3",
    d: "M555.217 481l-.017.067a.309.309 0 0 0 .117.034l.017-.067z",
    transform: "translate(-553.423 -475.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35482",
    "data-name": "Path 35482",
    className: "cls-3",
    d: "M558.117 481.8l-.017.067c.034 0 .084.017.117.017v-.067a.212.212 0 0 0-.1-.017z",
    transform: "translate(-555.837 -476.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35483",
    "data-name": "Path 35483",
    className: "cls-3",
    d: "M559.3 449.4v.067h.184v-.067h-.184z",
    transform: "translate(-556.836 -449.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35484",
    "data-name": "Path 35484",
    className: "cls-3",
    d: "M576.967 467.217c0-.034.017-.084.017-.117h-.067a.286.286 0 0 1-.017.117z",
    transform: "translate(-571.485 -464.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35485",
    "data-name": "Path 35485",
    className: "cls-3",
    d: "M576.767 468.634a.285.285 0 0 0 .017-.117l-.067-.017c0 .033-.017.084-.017.117z",
    transform: "translate(-571.318 -465.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35486",
    "data-name": "Path 35486",
    className: "cls-3",
    d: "M577.167 465.634v-.134h-.067v.117z",
    transform: "translate(-571.651 -462.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35487",
    "data-name": "Path 35487",
    className: "cls-3",
    d: "M576.817 462.734l.067-.017c0-.034-.017-.084-.017-.117l-.067.017c0 .033.017.083.017.117z",
    transform: "translate(-571.402 -460.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35488",
    "data-name": "Path 35488",
    className: "cls-3",
    d: "M576.517 461.334l.067-.017c-.017-.034-.017-.084-.034-.117l-.05.017c0 .033.017.067.017.117z",
    transform: "translate(-571.152 -459.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35489",
    "data-name": "Path 35489",
    className: "cls-3",
    d: "M577 464.184l.017.05.05-.017v-.117H577z",
    transform: "translate(-571.568 -461.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35490",
    "data-name": "Path 35490",
    className: "cls-3",
    d: "M576.034 459.934l.05-.017a.312.312 0 0 1-.034-.117l-.05.017a.429.429 0 0 0 .034.117z",
    transform: "translate(-570.736 -458.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35491",
    "data-name": "Path 35491",
    className: "cls-3",
    d: "M544.6 466.4v.134h.067v-.117z",
    transform: "translate(-544.6 -463.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35492",
    "data-name": "Path 35492",
    className: "cls-3",
    d: "M544.967 469.3l-.067.017c.017.034.017.084.034.117l.067-.017a.241.241 0 0 0-.034-.117z",
    transform: "translate(-544.85 -465.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35493",
    "data-name": "Path 35493",
    className: "cls-3",
    d: "M545.95 472.1l-.05.017.05.117.05-.034z",
    transform: "translate(-545.682 -468.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35494",
    "data-name": "Path 35494",
    className: "cls-3",
    d: "M545.45 470.7l-.05.017a.309.309 0 0 1 .033.117l.067-.017a.82.82 0 0 0-.05-.117z",
    transform: "translate(-545.266 -467.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35495",
    "data-name": "Path 35495",
    className: "cls-3",
    d: "M546.55 473.4l-.05.034a.967.967 0 0 0 .067.117l.05-.034a.742.742 0 0 0-.067-.117z",
    transform: "translate(-546.182 -469.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35496",
    "data-name": "Path 35496",
    className: "cls-3",
    d: "M568.1 480.15l.034.05a.808.808 0 0 1 .117-.05l-.034-.05a.816.816 0 0 0-.117.05z",
    transform: "translate(-564.16 -474.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35497",
    "data-name": "Path 35497",
    className: "cls-3",
    d: "M544.7 464.9v.134h.067v-.117z",
    transform: "translate(-544.683 -462.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35498",
    "data-name": "Path 35498",
    className: "cls-3",
    d: "M547.35 474.6l-.05.034c.017.034.05.067.067.1l.05-.034a.348.348 0 0 1-.067-.1z",
    transform: "translate(-546.847 -470.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35499",
    "data-name": "Path 35499",
    className: "cls-3",
    d: "M544.85 467.8l-.05.017v.117l.067-.017z",
    transform: "translate(-544.767 -464.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35500",
    "data-name": "Path 35500",
    className: "cls-3",
    d: "M552.534 479.7l-.034.05a.943.943 0 0 1 .117.067l.033-.05a.422.422 0 0 0-.116-.067z",
    transform: "translate(-551.176 -474.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35501",
    "data-name": "Path 35501",
    className: "cls-3",
    d: "M548.15 475.8l-.05.034a.447.447 0 0 0 .084.1l.05-.034z",
    transform: "translate(-547.513 -471.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35502",
    "data-name": "Path 35502",
    className: "cls-3",
    d: "M549.05 476.9l-.05.034c.034.034.05.067.084.084l.05-.05c-.017-.001-.05-.034-.084-.068z",
    transform: "translate(-548.262 -472.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35503",
    "data-name": "Path 35503",
    className: "cls-3",
    d: "M563.9 481.634l.017.067.117-.033-.017-.067a1.087 1.087 0 0 1-.117.033z",
    transform: "translate(-560.664 -476.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35504",
    "data-name": "Path 35504",
    className: "cls-3",
    d: "M551.334 478.9l-.033.05a.352.352 0 0 0 .1.067l.034-.05c-.035-.017-.068-.05-.101-.067z",
    transform: "translate(-550.177 -473.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35505",
    "data-name": "Path 35505",
    className: "cls-3",
    d: "M553.834 480.4l-.034.05.117.05.017-.067a.348.348 0 0 1-.1-.033z",
    transform: "translate(-552.258 -475.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35506",
    "data-name": "Path 35506",
    className: "cls-3",
    d: "M550.234 478l-.034.05.1.084.033-.05a.443.443 0 0 0-.099-.084z",
    transform: "translate(-549.261 -473.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35507",
    "data-name": "Path 35507",
    className: "cls-3",
    d: "M564.784 478.951l.034-.05-.067-.1-.05.05z",
    transform: "translate(-561.33 -473.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35508",
    "data-name": "Path 35508",
    className: "cls-3",
    d: "M612.767 542.734l.05-.034-.067-.1-.05.034z",
    transform: "translate(-601.283 -526.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35509",
    "data-name": "Path 35509",
    className: "cls-3",
    d: "M614.084 544.534l.05-.034-.084-.1-.05.034z",
    transform: "translate(-602.365 -528.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35510",
    "data-name": "Path 35510",
    className: "cls-3",
    d: "M614.767 545.434l.05-.034-.067-.1-.05.034z",
    transform: "translate(-602.948 -529.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35511",
    "data-name": "Path 35511",
    className: "cls-3",
    d: "M613.467 543.634l.05-.034-.067-.1-.05.034z",
    transform: "translate(-601.865 -527.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35512",
    "data-name": "Path 35512",
    className: "cls-3",
    d: "M564.084 478.134l.05-.05-.084-.084-.05.034z",
    transform: "translate(-560.747 -473.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35513",
    "data-name": "Path 35513",
    className: "cls-3",
    d: "M563.467 477.234l.05-.034-.067-.1-.05.033z",
    transform: "translate(-560.248 -472.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35514",
    "data-name": "Path 35514",
    className: "cls-3",
    d: "M567.467 482.534l.05-.034-.067-.1-.05.034z",
    transform: "translate(-563.577 -476.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35515",
    "data-name": "Path 35515",
    className: "cls-3",
    d: "M570.084 486.034l.05-.034-.084-.1-.05.034z",
    transform: "translate(-565.742 -479.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35516",
    "data-name": "Path 35516",
    className: "cls-3",
    d: "M570.784 486.934l.05-.034-.084-.1-.05.034z",
    transform: "translate(-566.324 -480.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35517",
    "data-name": "Path 35517",
    className: "cls-3",
    d: "M571.467 487.834l.05-.034-.067-.1-.05.034z",
    transform: "translate(-566.907 -481.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35518",
    "data-name": "Path 35518",
    className: "cls-3",
    d: "M566.05 480.6l-.05.034.084.1.05-.034z",
    transform: "translate(-562.412 -475.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35519",
    "data-name": "Path 35519",
    className: "cls-3",
    d: "M569.467 485.151l.05-.05-.067-.1-.05.05z",
    transform: "translate(-565.242 -479.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35520",
    "data-name": "Path 35520",
    className: "cls-3",
    d: "M565.45 479.7l-.05.034.067.1.05-.034z",
    transform: "translate(-561.913 -474.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35521",
    "data-name": "Path 35521",
    className: "cls-3",
    d: "M566.784 481.634l.05-.033-.084-.1-.05.034z",
    transform: "translate(-562.995 -476.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35522",
    "data-name": "Path 35522",
    className: "cls-3",
    d: "M568.084 483.434l.05-.034-.084-.1-.05.034z",
    transform: "translate(-564.077 -477.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35523",
    "data-name": "Path 35523",
    className: "cls-3",
    d: "M568.784 484.334l.05-.05-.084-.084-.05.034z",
    transform: "translate(-564.66 -478.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35524",
    "data-name": "Path 35524",
    className: "cls-3",
    d: "M607.467 535.634l.05-.034-.067-.1-.05.034z",
    transform: "translate(-596.871 -521.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35525",
    "data-name": "Path 35525",
    className: "cls-3",
    d: "M585.467 506.434l.05-.034-.067-.1-.05.034z",
    transform: "translate(-578.56 -496.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35526",
    "data-name": "Path 35526",
    className: "cls-3",
    d: "M586.084 507.334l.05-.034-.084-.1-.05.034z",
    transform: "translate(-579.059 -497.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35527",
    "data-name": "Path 35527",
    className: "cls-3",
    d: "M586.767 508.234l.05-.034-.067-.1-.05.033z",
    transform: "translate(-579.642 -498.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35528",
    "data-name": "Path 35528",
    className: "cls-3",
    d: "M587.467 509.134l.05-.05-.067-.084-.05.034z",
    transform: "translate(-580.224 -498.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35529",
    "data-name": "Path 35529",
    className: "cls-3",
    d: "M583.467 503.751l.05-.05-.067-.1-.05.05z",
    transform: "translate(-576.895 -494.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35530",
    "data-name": "Path 35530",
    className: "cls-3",
    d: "M584.784 505.534l.034-.034-.067-.1-.05.034z",
    transform: "translate(-577.977 -495.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35531",
    "data-name": "Path 35531",
    className: "cls-3",
    d: "M584.084 504.634l.05-.033-.084-.1-.05.034z",
    transform: "translate(-577.395 -495.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35532",
    "data-name": "Path 35532",
    className: "cls-3",
    d: "M590.784 513.534l.034-.033-.067-.1-.05.033z",
    transform: "translate(-582.971 -502.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35533",
    "data-name": "Path 35533",
    className: "cls-3",
    d: "M591.467 514.434l.05-.034-.067-.1-.05.034z",
    transform: "translate(-583.554 -503.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35534",
    "data-name": "Path 35534",
    className: "cls-3",
    d: "M592.784 516.151l.034-.05-.067-.1-.05.05z",
    transform: "translate(-584.636 -504.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35535",
    "data-name": "Path 35535",
    className: "cls-3",
    d: "M582.784 502.934l.034-.05-.067-.084-.05.034z",
    transform: "translate(-576.313 -493.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35536",
    "data-name": "Path 35536",
    className: "cls-3",
    d: "M592.084 515.334l.05-.05-.084-.084-.05.034z",
    transform: "translate(-584.053 -504.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35537",
    "data-name": "Path 35537",
    className: "cls-3",
    d: "M588.784 510.834l.034-.034-.067-.1-.05.034z",
    transform: "translate(-581.307 -500.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35538",
    "data-name": "Path 35538",
    className: "cls-3",
    d: "M590.084 512.634l.05-.033-.084-.1-.05.034z",
    transform: "translate(-582.389 -501.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35539",
    "data-name": "Path 35539",
    className: "cls-3",
    d: "M589.467 511.734l.05-.034-.067-.1-.05.034z",
    transform: "translate(-581.889 -501.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35540",
    "data-name": "Path 35540",
    className: "cls-3",
    d: "M588.084 509.951l.05-.05-.084-.1-.05.05z",
    transform: "translate(-580.724 -499.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35541",
    "data-name": "Path 35541",
    className: "cls-3",
    d: "M576.084 494.034l.05-.034-.084-.1-.05.034z",
    transform: "translate(-570.736 -486.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35542",
    "data-name": "Path 35542",
    className: "cls-3",
    d: "M577.467 495.834l.05-.034-.067-.1-.05.034z",
    transform: "translate(-571.901 -487.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35543",
    "data-name": "Path 35543",
    className: "cls-3",
    d: "M575.467 493.134l.05-.034-.067-.1-.05.033z",
    transform: "translate(-570.236 -485.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35544",
    "data-name": "Path 35544",
    className: "cls-3",
    d: "M576.784 494.934l.05-.034-.084-.1-.05.034z",
    transform: "translate(-571.318 -487.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35545",
    "data-name": "Path 35545",
    className: "cls-3",
    d: "M574.784 492.234l.05-.034-.084-.1-.05.05z",
    transform: "translate(-569.654 -484.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35546",
    "data-name": "Path 35546",
    className: "cls-3",
    d: "M573.467 490.534l.05-.05-.067-.084-.05.034z",
    transform: "translate(-568.572 -483.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35547",
    "data-name": "Path 35547",
    className: "cls-3",
    d: "M574.084 491.351l.05-.05-.084-.1-.05.05z",
    transform: "translate(-569.071 -484.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35548",
    "data-name": "Path 35548",
    className: "cls-3",
    d: "M581.467 501.134l.05-.034-.067-.1-.05.034z",
    transform: "translate(-575.23 -492.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35549",
    "data-name": "Path 35549",
    className: "cls-3",
    d: "M580.784 500.234l.034-.034-.067-.1-.05.034z",
    transform: "translate(-574.648 -491.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35550",
    "data-name": "Path 35550",
    className: "cls-3",
    d: "M582.084 502.034l.05-.034-.084-.1-.05.034z",
    transform: "translate(-575.73 -493.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35551",
    "data-name": "Path 35551",
    className: "cls-3",
    d: "M580.084 499.334l.05-.034-.084-.1-.05.034z",
    transform: "translate(-574.065 -490.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35552",
    "data-name": "Path 35552",
    className: "cls-3",
    d: "M579.467 498.434l.05-.034-.067-.1-.05.05z",
    transform: "translate(-573.566 -490.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35553",
    "data-name": "Path 35553",
    className: "cls-3",
    d: "M578.084 496.651l.05-.05-.084-.1-.05.05z",
    transform: "translate(-572.4 -488.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35554",
    "data-name": "Path 35554",
    className: "cls-3",
    d: "M578.784 497.551l.033-.05-.067-.1-.05.05z",
    transform: "translate(-572.983 -489.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35555",
    "data-name": "Path 35555",
    className: "cls-3",
    d: "M604.084 531.234l.05-.034-.084-.1-.05.034z",
    transform: "translate(-594.041 -517.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35556",
    "data-name": "Path 35556",
    className: "cls-3",
    d: "M594.767 518.834l.05-.034-.067-.1-.05.034z",
    transform: "translate(-586.301 -507.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35557",
    "data-name": "Path 35557",
    className: "cls-3",
    d: "M595.467 519.734l.05-.034-.067-.1-.05.034z",
    transform: "translate(-586.883 -507.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35558",
    "data-name": "Path 35558",
    className: "cls-3",
    d: "M594.084 517.934l.05-.034-.084-.1-.05.034z",
    transform: "translate(-585.718 -506.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35559",
    "data-name": "Path 35559",
    className: "cls-3",
    d: "M593.467 517.034l.05-.034-.067-.1-.05.034z",
    transform: "translate(-585.219 -505.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35560",
    "data-name": "Path 35560",
    className: "cls-3",
    d: "M596.084 520.634l.05-.033-.084-.1-.05.033z",
    transform: "translate(-587.383 -508.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35561",
    "data-name": "Path 35561",
    className: "cls-3",
    d: "M602.084 528.534l.05-.034-.084-.1-.05.05z",
    transform: "translate(-592.377 -515.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35562",
    "data-name": "Path 35562",
    className: "cls-3",
    d: "M603.467 530.334l.05-.034-.067-.1-.05.034z",
    transform: "translate(-593.542 -516.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35563",
    "data-name": "Path 35563",
    className: "cls-3",
    d: "M601.467 527.651l.05-.05-.067-.1-.05.05z",
    transform: "translate(-591.877 -514.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35564",
    "data-name": "Path 35564",
    className: "cls-3",
    d: "M599.467 525.034l.05-.033-.067-.1-.05.033z",
    transform: "translate(-590.213 -512.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35565",
    "data-name": "Path 35565",
    className: "cls-3",
    d: "M600.084 525.934l.05-.034-.084-.1-.05.034z",
    transform: "translate(-590.712 -512.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35566",
    "data-name": "Path 35566",
    className: "cls-3",
    d: "M598.767 524.134l.05-.033-.067-.1-.05.033z",
    transform: "translate(-589.63 -511.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35567",
    "data-name": "Path 35567",
    className: "cls-3",
    d: "M598.084 523.234l.05-.033-.084-.1-.05.034z",
    transform: "translate(-589.047 -510.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35568",
    "data-name": "Path 35568",
    className: "cls-3",
    d: "M596.767 521.534l.05-.05-.067-.084-.05.033z",
    transform: "translate(-587.965 -509.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35569",
    "data-name": "Path 35569",
    className: "cls-3",
    d: "M597.467 522.334l.05-.033-.067-.1-.05.05z",
    transform: "translate(-588.548 -509.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35570",
    "data-name": "Path 35570",
    className: "cls-3",
    d: "M602.767 529.434l.05-.034-.067-.1-.05.034z",
    transform: "translate(-592.959 -515.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35571",
    "data-name": "Path 35571",
    className: "cls-3",
    d: "M610.084 539.234l.05-.033-.084-.1-.05.034z",
    transform: "translate(-599.036 -524.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35572",
    "data-name": "Path 35572",
    className: "cls-3",
    d: "M608.084 536.534l.05-.034-.084-.1-.05.034z",
    transform: "translate(-597.371 -521.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35573",
    "data-name": "Path 35573",
    className: "cls-3",
    d: "M608.767 537.434l.05-.034-.067-.1-.05.034z",
    transform: "translate(-597.954 -522.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35574",
    "data-name": "Path 35574",
    className: "cls-3",
    d: "M609.467 538.334l.05-.034-.067-.1-.05.034z",
    transform: "translate(-598.536 -523.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35575",
    "data-name": "Path 35575",
    className: "cls-3",
    d: "M611.467 540.934l.05-.034-.067-.1-.05.05z",
    transform: "translate(-600.201 -525.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35576",
    "data-name": "Path 35576",
    className: "cls-3",
    d: "M610.767 540.051l.05-.05-.067-.1-.05.05z",
    transform: "translate(-599.618 -524.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35577",
    "data-name": "Path 35577",
    className: "cls-3",
    d: "M606.084 533.851l.05-.05-.084-.1-.05.05z",
    transform: "translate(-595.706 -519.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35578",
    "data-name": "Path 35578",
    className: "cls-3",
    d: "M606.767 534.734l.05-.034-.067-.1-.05.05z",
    transform: "translate(-596.289 -520.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35579",
    "data-name": "Path 35579",
    className: "cls-3",
    d: "M612.084 541.834l.05-.033-.084-.1-.05.034z",
    transform: "translate(-600.7 -526.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35580",
    "data-name": "Path 35580",
    className: "cls-3",
    d: "M604.784 532.134l.034-.034-.067-.1-.05.034z",
    transform: "translate(-594.624 -518.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35581",
    "data-name": "Path 35581",
    className: "cls-3",
    d: "M605.467 533.034l.05-.034-.067-.1-.05.034z",
    transform: "translate(-595.207 -518.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35582",
    "data-name": "Path 35582",
    className: "cls-3",
    d: "M651.817 545.3l-.067-.1-.05.034.067.1z",
    transform: "translate(-633.745 -529.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35583",
    "data-name": "Path 35583",
    className: "cls-3",
    d: "M651.217 544.318l-.067-.117-.05.034.067.117z",
    transform: "translate(-633.245 -528.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35584",
    "data-name": "Path 35584",
    className: "cls-3",
    d: "M652.867 547.1l-.067.034.067.1.05-.033z",
    transform: "translate(-634.66 -530.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2186",
    "data-name": "Rectangle 2186",
    className: "cls-3",
    transform: "rotate(-30.696 30.888 -22.567)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35585",
    "data-name": "Path 35585",
    className: "cls-3",
    d: "M642.567 530.134l.05-.034-.05-.1-.067.034z",
    transform: "translate(-626.087 -516.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35586",
    "data-name": "Path 35586",
    className: "cls-3",
    d: "M644.367 532.951l.05-.034-.067-.117-.05.034z",
    transform: "translate(-627.585 -518.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35587",
    "data-name": "Path 35587",
    className: "cls-3",
    d: "M643.767 532.034l.05-.034-.067-.1-.05.034z",
    transform: "translate(-627.086 -518.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35588",
    "data-name": "Path 35588",
    className: "cls-3",
    d: "M646.067 535.834l.05-.033-.067-.1-.05.033z",
    transform: "translate(-629 -521.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35589",
    "data-name": "Path 35589",
    className: "cls-3",
    d: "M645.467 534.851l.05-.034-.067-.117-.05.034z",
    transform: "translate(-628.501 -520.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35590",
    "data-name": "Path 35590",
    className: "cls-3",
    d: "M644.867 533.934l.05-.034-.05-.1-.067.033z",
    transform: "translate(-628.001 -519.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35591",
    "data-name": "Path 35591",
    className: "cls-3",
    d: "M643.167 531.051l.05-.034-.067-.117-.05.034z",
    transform: "translate(-626.586 -517.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35592",
    "data-name": "Path 35592",
    className: "cls-3",
    d: "M641.467 528.234l.05-.034-.067-.1-.05.034z",
    transform: "translate(-625.171 -514.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35593",
    "data-name": "Path 35593",
    className: "cls-3",
    d: "M642.067 529.151l.05-.033-.067-.118-.05.033z",
    transform: "translate(-625.671 -515.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2187",
    "data-name": "Rectangle 2187",
    className: "cls-3",
    transform: "rotate(-30.696 30.567 -22.467)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35594",
    "data-name": "Path 35594",
    className: "cls-3",
    d: "M640.867 527.251l.05-.034-.05-.117-.067.034z",
    transform: "translate(-624.672 -514.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35595",
    "data-name": "Path 35595",
    className: "cls-3",
    d: "M646.65 536.751l.05-.034-.05-.117-.05.034z",
    transform: "translate(-629.499 -521.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35596",
    "data-name": "Path 35596",
    className: "cls-3",
    d: "M650.067 542.451l.05-.034-.067-.117-.05.034z",
    transform: "translate(-632.329 -526.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35597",
    "data-name": "Path 35597",
    className: "cls-3",
    d: "M649.467 541.534l.05-.034-.067-.1-.05.034z",
    transform: "translate(-631.83 -525.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35598",
    "data-name": "Path 35598",
    className: "cls-3",
    d: "M640.35 526.334l.067-.034-.067-.1-.05.034z",
    transform: "translate(-624.256 -513.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35599",
    "data-name": "Path 35599",
    className: "cls-3",
    d: "M650.567 543.434l.05-.034-.05-.1-.067.034z",
    transform: "translate(-632.746 -527.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35600",
    "data-name": "Path 35600",
    className: "cls-3",
    d: "M648.867 540.551l.05-.034-.05-.117-.067.034z",
    transform: "translate(-631.331 -525.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35601",
    "data-name": "Path 35601",
    className: "cls-3",
    d: "M647.167 537.734l.05-.033-.067-.1-.05.033z",
    transform: "translate(-629.916 -522.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35602",
    "data-name": "Path 35602",
    className: "cls-3",
    d: "M647.767 538.651l.05-.034-.067-.117-.05.033z",
    transform: "translate(-630.415 -523.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35603",
    "data-name": "Path 35603",
    className: "cls-3",
    d: "M648.367 539.634l.05-.034-.067-.1-.05.034z",
    transform: "translate(-630.915 -524.378)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4816",
    "data-name": "Group 4816",
    transform: "translate(0 22.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35604",
    "data-name": "Path 35604",
    className: "cls-5",
    d: "M463.754 573.295l6.639 10.545.218-1.291-.05.017-.017-.05c.034-.017.05-.017.084-.033l.3-1.677v-.034h.017l.017-.067-.05.017-.034-.117.05-.017.034.084.285-1.66-.687-5.633-6.639-.419a3.121 3.121 0 0 1-.167.335zm-.134.05l-.251-.386-.57.5-.855-.318-.168-.922.671-.6.05.017.637.235.084-.453a1.167 1.167 0 0 0-.855-.151 1.286 1.286 0 0 0-.989 1.509 1.27 1.27 0 0 0 1.475 1.039 1.2 1.2 0 0 0 .771-.47zm-.3-2l.2.151 2.548-3.437-1.978-.587zm.721-3.94l.386-1.945-2.414.52a1.453 1.453 0 0 1 .017.469 1.139 1.139 0 0 1-.117.335zm-2.23-.6l-.251-.084.017.084-.067.017-.017-.1-.6.218-.52-.469.134-.7.654-.235.335.3.2-.318a1.07 1.07 0 0 0-.486-.268.966.966 0 0 0-1.123.8.981.981 0 0 0 .755 1.157.913.913 0 0 0 .967-.401zm.084-.956a1.83 1.83 0 0 0-.1-.184l-.151.251zm-.352.822l.285.084a1.037 1.037 0 0 0 .117-.318.95.95 0 0 0-.017-.436l-.285.067zm.285-1.073a1.063 1.063 0 0 1 .134.235l2.5-.536 1.123-5.633h-.017zm3.621-6.069l.134-.218-.3-.335.151-.536.536-.117.386.419-.117.419.235.117a.788.788 0 0 0-.1-.939.772.772 0 0 0-1.09-.067.785.785 0 0 0-.034 1.09.472.472 0 0 0 .197.168zm1.039-.151c-.017.017-.034.05-.067.067l2.364 3.1.034-.017a1.359 1.359 0 0 1 1.727.838 1.453 1.453 0 0 1 .084.469l1.66-.134a1.453 1.453 0 0 1-.084-.469 1.667 1.667 0 0 1 .168-.855zm6 2.967l.4.2.905-.62 1.006.536.067 1.174-.872.6.017.486a1.633 1.633 0 0 0-.218-3.252 1.627 1.627 0 0 0-1.305.878zm1.526 8.668l-.151-6.17h-.063l-.889 5.08.788 1.291a1.477 1.477 0 0 1 .315-.199zm.151.1l.017.838 1.459-.335 1.14 1.241-.5 1.609-1.542.352-.218.654a2.327 2.327 0 0 0 1.324-4.46 2.148 2.148 0 0 0-1.68.103zm-2.85 7.88l.536 4.309.268-.821a.182.182 0 0 0-.084-.017l.017-.067a.722.722 0 0 1 .084.017l2.213-6.857a2.493 2.493 0 0 1-1.643-2.062l-.419-.034zm-.7-5.616l.671 5.415.922-5.315zm0-.067l1.609.1.352-2-2.364-1.274zm-7.142-1.727a.659.659 0 0 0-.168-.134l-.084.385.168-.151zm2.649-3.487l-2.515 3.4 2.984-2.582a.806.806 0 0 1-.1-.7zm.05-.067l.352.1c0-.017 0-.017.017-.033a.814.814 0 0 1 .654-.436l-.117-.855zm-1.677-2.582l-.386 1.978 2 .587.956-1.291-.235-1.777zm1.106-5.868l-.017.017h.017zm.05.05a.832.832 0 0 0 .453-.017l-.034-.285-.352.067-.034.034zm.738-.235c.017-.017.034-.033.034-.05l-.134-.067zm-.268-.084l.034.268c.034-.017.084-.05.117-.067l-.151-.2zm.184.235a.672.672 0 0 1-.151.084l.687 5.147 1.308-.285-.1-.2a1.371 1.371 0 0 1 .587-1.677zm4.258 4.426l-.369.034-.5.637.2.335a1.255 1.255 0 0 0 .666-1.004zm-.436 5.952l-.587-4.728a1.369 1.369 0 0 1-.922-.2l-1.224 2.7a1.229 1.229 0 0 1 .235.067.828.828 0 0 1 .419 1.04zm-3.588-1.71a.7.7 0 0 0 .084.654l.184-.168-.034-.436zm.654-.5a.734.734 0 0 0-.6.4c0 .017 0 .017-.017.033l.218.067.436-.285zm.184.017l-.1.218.469.235.033.469.218.117a.781.781 0 0 0-.386-.972.968.968 0 0 0-.236-.068zm-.134-.017l.017.117.05-.117zm-.117-.972l.117.922h.1l1.241-2.716a.291.291 0 0 1-.084-.067zm1.14-2.112l-1.391.3.235 1.727 1.341-1.811a1.158 1.158 0 0 1-.188-.218zm.084-.017a1.375 1.375 0 0 0 .151.168l.168-.235zm.2.2a.233.233 0 0 0 .067.05l.151-.335zm.989.285l-.05-.419-.671-.117-.151.352a1.208 1.208 0 0 0 .871.187zm.017-.386l.05.386c.05-.017.1-.034.168-.05zm-.855-2.045a1.293 1.293 0 0 0-.553 1.593c.034.084.067.151.1.218l.436-.1-.268-.738.52-.671zm-1.291 6.5l.017.05a.777.777 0 0 0 .5-.318l-.235-.117-.335.218.034.117-.067.017-.034-.117-.385-.2-.184.168a1.063 1.063 0 0 0 .218.168.783.783 0 0 0 .436.084l-.017-.034zm5.4.922l-3-4.962-.2.05.587 4.778 2.414 1.291zm.754 1.224l-.7-1.157-.2 1.106.6.335a2.442 2.442 0 0 1 .297-.28zm.469.486l-.017-.62a2.163 2.163 0 0 0-.252.168zm-.4-.352a3.118 3.118 0 0 0-.235.235l.536.285zm-.838 1.023a2.469 2.469 0 0 1 .386-.754l-.536-.285-.352 1.978.4.034a2.413 2.413 0 0 1 .097-.969zm1.174-.319l-.654-.352a2.26 2.26 0 0 0-.369.721 2.481 2.481 0 0 0-.1.922l.7.05zm-.453 1.425l.017-.033-.671-.034a2.264 2.264 0 0 0 1.526 1.894l.2-.654zm-1.14-9.741l-1.71.134a1.366 1.366 0 0 1-.7 1.09l2.9 4.795.872-5.013a1.643 1.643 0 0 1-1.367-1.001zm.1-.017a1.575 1.575 0 0 0 1.274.905l.084-.5-.855-.453zm0-1.408a1.546 1.546 0 0 0-.151.788 1.453 1.453 0 0 0 .084.469l.52-.033-.05-1.023zm1.375 2.079l-.033.251h.05zm-5-1.895l.268.352.771.134.285.754.4-.033a1.437 1.437 0 0 0-.084-.453 1.292 1.292 0 0 0-1.643-.755zm-4.325 2.682l2.263-.486-.687-5.13a.752.752 0 0 1-.469.017zm-.989 7.645l.168.285a1.684 1.684 0 0 0 .117-.251zm.3-.034a1.381 1.381 0 0 0 .017-.587 1.255 1.255 0 0 0-.268-.587l-.268.235.168.888v.017zm4.778.2l.033.1 1.894.117-.386-3.2-2.179-1.173a.861.861 0 0 1-.52.352v.017l-.067.017v-.016a.934.934 0 0 1-.469-.084 1.2 1.2 0 0 1-.235-.168l-3.034 2.632a1.511 1.511 0 0 1 .285.62 1.459 1.459 0 0 1-.017.6l4.661.285-.017-.067zm1.844 10.763l1.324-.335v-.014l-.017-.084.034-.017v-.067l-.067.033-.034-.117.05-.017.033.084-.117-.956v.05h-.117v-.067h.117l-.386-3.135-.268 1.576.017.084-.034.017zm.553 2.884l-1.174-1.207.436-1.609-6.605-10.5a1.237 1.237 0 0 1-.771.469 1.384 1.384 0 0 1-.52-2.716l-.017-.084.05-.017.017.084a1.214 1.214 0 0 1 .838.168l.771-3.856-2.163-.637a.962.962 0 0 1-.252.268l.017.084-.067.017-.017-.067a1.04 1.04 0 1 1-.335-1.928.925.925 0 0 1 .5.268l3.688-5.884-.2-.151a.813.813 0 1 1 1.19-1.106.838.838 0 0 1 .1.989l5.885 2.984a1.657 1.657 0 0 1 1.375-.922 1.742 1.742 0 0 1 .235 3.47l.151 6.086a2.44 2.44 0 0 1 1.727-.1 2.494 2.494 0 0 1 1.626 3.118 2.461 2.461 0 0 1-3.034 1.643l-2.548 7.913 1.14 1.174-.453 1.626z",
    transform: "translate(-459.998 -558.066)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4822",
    "data-name": "Group 4822",
    transform: "translate(11.32 7.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4817",
    "data-name": "Group 4817",
    transform: "translate(12.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35605",
    "data-name": "Path 35605",
    className: "cls-3",
    d: "M605.678 477.186l.235 1.14-.872.771-1.107-.369-.235-1.157.872-.771z",
    transform: "translate(-603.091 -476.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35606",
    "data-name": "Path 35606",
    className: "cls-5",
    d: "M600.256 474.579a1.609 1.609 0 1 1 1.006 2.045 1.62 1.62 0 0 1-1.006-2.045zm-.1-.034a1.715 1.715 0 1 0 2.18-1.09 1.724 1.724 0 0 0-2.181 1.091z",
    transform: "translate(-600.066 -473.366)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35607",
    "data-name": "Path 35607",
    className: "cls-3",
    d: "M610.951 487.4l3.3 17.57-.134.017-3.32-17.57z",
    transform: "translate(-596.838 -485.047)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4818",
    "data-name": "Group 4818",
    transform: "translate(0 8.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35608",
    "data-name": "Path 35608",
    className: "cls-3",
    d: "M529.6 524.022l.05-.637.553-.285.52.352-.034.637-.57.268z",
    transform: "translate(-529.251 -522.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35609",
    "data-name": "Path 35609",
    className: "cls-5",
    d: "M529.158 522.7a.885.885 0 0 1-1.207.252.865.865 0 0 1-.235-1.207.865.865 0 1 1 1.442.956zm.05.017a.928.928 0 0 0-.268-1.291.905.905 0 0 0-1.274.268.94.94 0 0 0 .268 1.291.908.908 0 0 0 1.274-.265z",
    transform: "translate(-527.518 -521.273)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4819",
    "data-name": "Group 4819",
    transform: "translate(16.426 19.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35610",
    "data-name": "Path 35610",
    className: "cls-3",
    d: "M627.567 591.806l-.067-.637.52-.369.57.268.05.62-.5.369z",
    transform: "translate(-627.164 -590.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35611",
    "data-name": "Path 35611",
    className: "cls-5",
    d: "M627.187 590.286a.859.859 0 0 1-1.14.436.892.892 0 0 1-.436-1.157.867.867 0 1 1 1.576.721zm.067.017a.936.936 0 0 0-.453-1.224.93.93 0 1 0 .453 1.224z",
    transform: "translate(-625.492 -588.994)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4820",
    "data-name": "Group 4820",
    transform: "translate(2.835 2.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35612",
    "data-name": "Path 35612",
    className: "cls-3",
    d: "M546.686 490.574l-.386-.486.235-.587.6-.1.4.5-.235.587z",
    transform: "translate(-545.986 -489.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35613",
    "data-name": "Path 35613",
    className: "cls-5",
    d: "M546.216 488.21a.87.87 0 0 1-.721.989.879.879 0 0 1-.989-.738.871.871 0 0 1 .721-.989.9.9 0 0 1 .989.738zm.05 0a.925.925 0 1 0-.771 1.056.926.926 0 0 0 .771-1.056z",
    transform: "translate(-544.426 -487.426)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4821",
    "data-name": "Group 4821",
    transform: "translate(2.846 14.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35614",
    "data-name": "Path 35614",
    className: "cls-3",
    d: "M545.8 562.438l-.2-.369.218-.369.436.017.2.369-.235.369z",
    transform: "translate(-545.415 -561.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35615",
    "data-name": "Path 35615",
    className: "cls-5",
    d: "M545.687 560.934a.587.587 0 1 1-1.173-.034.573.573 0 0 1 .6-.57.564.564 0 0 1 .573.604zm.05 0a.609.609 0 0 0-.6-.637.622.622 0 0 0-.637.62.609.609 0 0 0 .6.637.657.657 0 0 0 .637-.62z",
    transform: "translate(-544.496 -560.296)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35616",
    "data-name": "Path 35616",
    className: "cls-3",
    d: "M534.667 493.056l-.067-.117 12.121-6.538.067.117z",
    transform: "translate(-533.413 -484.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35617",
    "data-name": "Path 35617",
    className: "cls-3",
    d: "M548.2 498.494l9.925-13.094.05.034-9.925 13.094z",
    transform: "translate(-544.732 -483.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35618",
    "data-name": "Path 35618",
    className: "cls-3",
    d: "M532.334 528.8l2.464 5.734-.134.05-2.464-5.734z",
    transform: "translate(-531.415 -519.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35619",
    "data-name": "Path 35619",
    className: "cls-3",
    d: "M560.488 486.2l.017.2-9.288 1.039-.017-.184z",
    transform: "translate(-547.23 -484.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35620",
    "data-name": "Path 35620",
    className: "cls-3",
    d: "M535.467 494.3l-2.7 5.013-.168-.1 2.7-5.013z",
    transform: "translate(-531.748 -490.707)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828",
    transform: "translate(3.486 17.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4823",
    "data-name": "Group 4823",
    transform: "translate(3.032 6.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35621",
    "data-name": "Path 35621",
    className: "cls-3",
    d: "M500.938 567.388l-.436.084-.3-.352.151-.436.453-.084.285.352z",
    transform: "translate(-499.979 -566.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35622",
    "data-name": "Path 35622",
    className: "cls-5",
    d: "M499.754 565.258a.636.636 0 0 1 .386.8.623.623 0 0 1-.8.386.631.631 0 0 1 .419-1.19zm.017-.034a.68.68 0 0 0-.855.4.666.666 0 0 0 .4.855.68.68 0 0 0 .855-.4.665.665 0 0 0-.4-.855z",
    transform: "translate(-498.878 -565.189)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4824",
    "data-name": "Group 4824",
    transform: "translate(0 9.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35623",
    "data-name": "Path 35623",
    className: "cls-3",
    d: "M483.639 588.49l-.62.117-.419-.486.218-.6.62-.117.419.486z",
    transform: "translate(-482.297 -587.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35624",
    "data-name": "Path 35624",
    className: "cls-5",
    d: "M482.016 585.509a.9.9 0 0 1 .536 1.123.872.872 0 1 1-1.643-.587.847.847 0 0 1 1.107-.536zm.017-.067a.933.933 0 1 0 .57 1.19.948.948 0 0 0-.57-1.19z",
    transform: "translate(-480.791 -585.391)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4825",
    "data-name": "Group 4825",
    transform: "translate(11.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35625",
    "data-name": "Path 35625",
    className: "cls-3",
    d: "M554.122 530.286l-.268.386-.469-.05-.184-.436.268-.386.469.05z",
    transform: "translate(-552.957 -529.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35626",
    "data-name": "Path 35626",
    className: "cls-5",
    d: "M552.2 528.309a.633.633 0 0 1 .855.335.657.657 0 0 1-.335.872.633.633 0 0 1-.855-.335.657.657 0 0 1 .335-.872zm-.034-.034a.7.7 0 1 0 .922.352.687.687 0 0 0-.925-.352z",
    transform: "translate(-551.752 -528.21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4826",
    "data-name": "Group 4826",
    transform: "translate(7.151 3.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35627",
    "data-name": "Path 35627",
    className: "cls-3",
    d: "M524.987 550.6l-.235.2-.285-.084-.067-.318.235-.2.285.1z",
    transform: "translate(-524.24 -550.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35628",
    "data-name": "Path 35628",
    className: "cls-5",
    d: "M523.8 549.286a.429.429 0 1 1-.318.52.429.429 0 0 1 .318-.52zm0-.034a.454.454 0 1 0 .536.352.455.455 0 0 0-.536-.352z",
    transform: "translate(-523.442 -549.242)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4827",
    "data-name": "Group 4827",
    transform: "translate(6.992 11.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35629",
    "data-name": "Path 35629",
    className: "cls-3",
    d: "M524 596.52l-.3.084-.2-.235.084-.3.3-.067.2.235z",
    transform: "translate(-523.332 -595.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35630",
    "data-name": "Path 35630",
    className: "cls-5",
    d: "M523.084 595.131a.43.43 0 1 1-.536.285.442.442 0 0 1 .536-.285zm0-.017a.474.474 0 0 0-.57.3.456.456 0 1 0 .872.268.434.434 0 0 0-.302-.568z",
    transform: "translate(-522.497 -595.097)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2188",
    "data-name": "Rectangle 2188",
    className: "cls-3",
    transform: "rotate(-37.49 11.992 -2.376)",
    d: "M0 0h4.51v.101H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35631",
    "data-name": "Path 35631",
    className: "cls-3",
    d: "M485.7 573.519l2.9-3.219.067.067-2.884 3.219z",
    transform: "translate(-484.877 -563.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2189",
    "data-name": "Rectangle 2189",
    className: "cls-3",
    transform: "rotate(-38.3 12.03 -1.914)",
    d: "M0 0h.034v5.784H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35632",
    "data-name": "Path 35632",
    className: "cls-3",
    d: "M488.217 590l6.119 1.391v.034l-6.136-1.392z",
    transform: "translate(-486.958 -579.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35633",
    "data-name": "Path 35633",
    className: "cls-3",
    d: "M525.9 536.884l4.879-2.984.034.034-4.9 2.984z",
    transform: "translate(-518.337 -532.946)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833",
    transform: "translate(13.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4829",
    "data-name": "Group 4829",
    transform: "translate(6.042 14.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35634",
    "data-name": "Path 35634",
    className: "cls-3",
    d: "M581.622 513.4l1.073.453.134 1.157-.922.721-1.073-.469-.134-1.162z",
    transform: "translate(-580.053 -512.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35635",
    "data-name": "Path 35635",
    className: "cls-5",
    d: "M577.268 512.731a1.626 1.626 0 0 1 .319-2.263 1.605 1.605 0 0 1 2.247.319 1.626 1.626 0 0 1-.318 2.263 1.589 1.589 0 0 1-2.248-.319zm-.084.067a1.712 1.712 0 0 0 2.4.335 1.732 1.732 0 0 0 .335-2.414 1.711 1.711 0 0 0-2.4-.335 1.732 1.732 0 0 0-.335 2.416z",
    transform: "translate(-576.838 -510.038)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830",
    transform: "translate(4.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35636",
    "data-name": "Path 35636",
    className: "cls-3",
    d: "M569.486 428.2l.587.251.084.62-.486.386-.587-.235-.084-.622z",
    transform: "translate(-568.655 -427.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35637",
    "data-name": "Path 35637",
    className: "cls-5",
    d: "M567.184 427.943a.879.879 0 0 1 .151-1.224.857.857 0 0 1 1.207.151.865.865 0 1 1-1.358 1.073zm-.05.033a.914.914 0 0 0 1.291.168.95.95 0 0 0 .168-1.308.926.926 0 1 0-1.458 1.14z",
    transform: "translate(-566.939 -426.481)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35638",
    "data-name": "Path 35638",
    className: "cls-3",
    d: "M590.55 521.3l16.279 7.159-.05.117-16.279-7.159z",
    transform: "translate(-582.168 -505.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35639",
    "data-name": "Path 35639",
    className: "cls-3",
    d: "M572.5 434.017l.134-.017 2.28 13.647-.134.017z",
    transform: "translate(-567.186 -432.739)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    "data-name": "Group 4831",
    transform: "translate(24.033 22.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35640",
    "data-name": "Path 35640",
    className: "cls-3",
    d: "M686.87 563.257l-.553-.3-.017-.637.536-.318.553.3.017.62z",
    transform: "translate(-685.939 -561.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35641",
    "data-name": "Path 35641",
    className: "cls-5",
    d: "M685.8 560.626a.866.866 0 1 1-1.19-.285.87.87 0 0 1 1.19.285zm.05-.034a.929.929 0 0 0-1.257-.318.929.929 0 1 0 .956 1.593.922.922 0 0 0 .301-1.274z",
    transform: "translate(-684.148 -560.148)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4832",
    "data-name": "Group 4832",
    transform: "translate(2.373 24.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35642",
    "data-name": "Path 35642",
    className: "cls-3",
    d: "M557.772 573.373l-.62.05-.352-.52.268-.57.62-.033.352.52z",
    transform: "translate(-556.491 -571.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35643",
    "data-name": "Path 35643",
    className: "cls-5",
    d: "M556.272 570.2a.883.883 0 0 1 .4 1.174.85.85 0 0 1-1.157.4.874.874 0 0 1 .754-1.576zm.017-.05a.935.935 0 0 0-1.241.436.925.925 0 0 0 .436 1.241.935.935 0 0 0 1.241-.436.95.95 0 0 0-.436-1.243z",
    transform: "translate(-554.957 -570.057)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35644",
    "data-name": "Path 35644",
    className: "cls-3",
    d: "M578.534 538.464h-.134l1.492-13.764h.151z",
    transform: "translate(-572.096 -508.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35645",
    "data-name": "Path 35645",
    className: "cls-3",
    d: "M591.93 539.242l-5.13-15.625.05-.017 5.13 15.625z",
    transform: "translate(-579.088 -507.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35646",
    "data-name": "Path 35646",
    className: "cls-3",
    d: "M565.193 524.8l.168.1-4.393 8.315-.168-.1z",
    transform: "translate(-557.447 -508.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35647",
    "data-name": "Path 35647",
    className: "cls-3",
    d: "M560.984 576.9l2.582 5.063-.168.1-2.6-5.08z",
    transform: "translate(-557.447 -551.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35648",
    "data-name": "Path 35648",
    className: "cls-3",
    d: "M543.935 577l.117.067-3.135 5.247-.117-.067z",
    transform: "translate(-540.8 -551.765)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4838",
    "data-name": "Group 4838",
    transform: "translate(9.54 5.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    "data-name": "Group 4834",
    transform: "translate(7.751 10.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35649",
    "data-name": "Path 35649",
    className: "cls-3",
    d: "M566.674 522.874l-.721.251-.553-.537.168-.754.721-.235.553.52z",
    transform: "translate(-565.02 -521.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35650",
    "data-name": "Path 35650",
    className: "cls-5",
    d: "M564.471 519.339a1.053 1.053 0 0 1 .771 1.274 1.067 1.067 0 0 1-1.241.838 1.053 1.053 0 0 1-.771-1.274 1.067 1.067 0 0 1 1.241-.838zm.017-.067a1.152 1.152 0 1 0 .821 1.358 1.129 1.129 0 0 0-.821-1.358z",
    transform: "translate(-563.136 -519.246)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4835",
    "data-name": "Group 4835",
    transform: "translate(7.187 16.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35651",
    "data-name": "Path 35651",
    className: "cls-3",
    d: "M562.221 555.756l-.587-.034-.235-.536.335-.486.57.034.252.52z",
    transform: "translate(-561.126 -554.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35652",
    "data-name": "Path 35652",
    className: "cls-5",
    d: "M561.081 552.816a.805.805 0 0 1 .184 1.14.8.8 0 1 1-1.308-.905.829.829 0 0 1 1.124-.235zm.034-.033a.853.853 0 0 0-1.19.251.873.873 0 0 0 .2 1.207.853.853 0 0 0 1.19-.251.887.887 0 0 0-.2-1.207z",
    transform: "translate(-559.769 -552.638)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35653",
    "data-name": "Path 35653",
    className: "cls-3",
    d: "M530.29 457.284l-3.889 8.031-.1-.084 3.889-8.03z",
    transform: "translate(-524.724 -457.167)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836",
    transform: "translate(1.321 20.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35654",
    "data-name": "Path 35654",
    className: "cls-3",
    d: "M527.005 579.737l-.3.352-.453-.084-.151-.453.3-.352.436.1z",
    transform: "translate(-525.878 -578.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35655",
    "data-name": "Path 35655",
    className: "cls-5",
    d: "M525.235 577.784a.627.627 0 0 1 .8.419.621.621 0 1 1-1.174.4.646.646 0 0 1 .374-.819zm-.017-.05a.684.684 0 0 0-.4.872.677.677 0 0 0 .855.436.692.692 0 0 0-.453-1.308z",
    transform: "translate(-524.778 -577.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35656",
    "data-name": "Path 35656",
    className: "cls-3",
    d: "M535.2 557.5l-5.533 3.822-.067-.1 5.516-3.822z",
    transform: "translate(-527.471 -540.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35657",
    "data-name": "Path 35657",
    className: "cls-3",
    d: "M529.75 536l-.05-.017 6.17-8.983.034.017z",
    transform: "translate(-527.554 -515.265)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    "data-name": "Group 4837",
    transform: "translate(7.762 12.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35658",
    "data-name": "Path 35658",
    className: "cls-5",
    d: "M564.156 529.817l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.017.151l-.05-.017-.017.1.05.017zm-.033.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.033.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.033.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.017.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151h-.05l-.017.1.05.017zm-.033.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.017.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017zm-.034.151l-.05-.017-.017.1.05.017z",
    transform: "translate(-563.2 -529.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35659",
    "data-name": "Path 35659",
    className: "cls-3",
    d: "M557.894 468.2l-.117.017-1.777-11.2.134-.017z",
    transform: "translate(-549.445 -457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35660",
    "data-name": "Path 35660",
    className: "cls-3",
    d: "M534.873 512.547l-6.672-2.2.017-.05 6.689 2.213z",
    transform: "translate(-526.306 -501.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35661",
    "data-name": "Path 35661",
    className: "cls-3",
    d: "M518.778 525.965l-.034-.034L516.9 514.9l.05.034z",
    transform: "translate(-516.9 -505.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_273",
    "data-name": "Line 273",
    className: "cls-3",
    transform: "translate(1.76)",
    d: "M0 20.789L4.929 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882",
    transform: "translate(0 2.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4878",
    "data-name": "Group 4878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841",
    transform: "translate(1.623 1.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35662",
    "data-name": "Path 35662",
    className: "cls-5",
    d: "M-5.769 423.237l3.856-11.769.536 1.19h-.05v.067h.084l.687 1.542v.034h.017l.034.067h-.05v.117h.067v-.1L.1 415.91l.7 5.6-6.337 2.012c-.081-.101-.148-.202-.232-.285zm-.168-.034l-.134.436-.671-.352-.754.5.05.939.8.419.05-.034.553-.386.2.419a1.224 1.224 0 0 1-.788.352 1.284 1.284 0 0 1-1.324-1.224 1.276 1.276 0 0 1 1.174-1.358 1.3 1.3 0 0 1 .844.286zm.2 2a1.577 1.577 0 0 0 .151-.2l3.32 2.7-1.777 1.039zm1.677 3.638l.855 1.777-2.464.084a1.107 1.107 0 0 0-.1-.453.877.877 0 0 0-.2-.285zm-2.029 1.123l-.235.134v-.084h-.066v.1l-.637-.067-.386.587.3.654.687.067.251-.369.268.251a1.066 1.066 0 0 1-.4.369.987.987 0 0 1-1.291-.5.969.969 0 0 1 .453-1.308.973.973 0 0 1 1.057.161zm.319.905c-.017.067-.034.134-.05.218l-.2-.2zm-.536-.7l.251-.151a.876.876 0 0 1 .2.285.961.961 0 0 1 .1.419h-.285zm.536.956a.7.7 0 0 0 .067-.251l2.548-.084 2.464 5.164-.017.017zm4.979 4.962l.184.168-.218.4.285.469.553-.017.268-.5-.218-.369.2-.168a.782.782 0 0 1 .134.922.781.781 0 0 1-1.039.335.784.784 0 0 1-.3-1.056 1.773 1.773 0 0 1 .152-.192zm1.056-.1c-.017-.017-.05-.034-.067-.05l1.542-3.554h.034a1.361 1.361 0 0 0 1.476-1.233 1.446 1.446 0 0 0-.034-.469l1.644-.281a1.623 1.623 0 0 0 .034.486 1.578 1.578 0 0 0 .369.771zm5.1-4.325l.352-.3 1.039.369.838-.754-.218-1.14-1.006-.369-.1-.469a1.609 1.609 0 0 1 1.794 1.308 1.573 1.573 0 0 1-1.224 1.878 1.608 1.608 0 0 1-1.477-.532zm-.637-8.718l1.356 5.956-.067.017-2.117-4.675.436-1.425a3.376 3.376 0 0 0 .39.118zm.134-.134l-.184-.8 1.492-.034.8-1.475-.87-1.439-1.593.034-.369-.587A2.324 2.324 0 0 1 6.52 422.5a2.2 2.2 0 0 1-1.66.3zm-4.713-6.917l-.536-4.275.453.738a.128.128 0 0 1-.084.034l.034.05c.034-.017.05-.034.084-.05l3.822 6.086a2.489 2.489 0 0 0-1.09 2.381l-.4.134zm.7 5.6l-.671-5.382 2.2 4.9zm.017.05l1.542-.486.842 1.843-1.978 1.8zm-6.5 3.4a.658.658 0 0 1-.134.168l-.168-.352.2.1zm3.42 2.716L-5.484 425l3.521 1.777a.808.808 0 0 0 .084.7zm.05.05l.319-.184c0 .017.017.017.017.034a.825.825 0 0 0 .738.268l.1.855zm-.989 2.9l-.872-1.811 1.794-1.056 1.241 1.006.2 1.777zm2.515 5.382l-.017-.017zm.034-.05a.814.814 0 0 1 .453-.084l.034.285-.352.017-.034-.034zm.771.034c.017.017.034.017.05.034l-.117.1zm-.235.151l-.034-.268a.393.393 0 0 1 .134.034l-.1.235zm.117-.268l-.151-.05-.587-5.13 1.341-.05c-.017.067-.034.151-.05.218a1.354 1.354 0 0 0 .972 1.475zm3.051-5.3l-.369.067-.637-.486.117-.369a1.177 1.177 0 0 1 .889.793zm-1.878-5.628l.587 4.711a1.3 1.3 0 0 0-.838.419l-1.844-2.314a.531.531 0 0 0 .2-.134.834.834 0 0 0 .151-1.106zm-3.051 2.515a.756.756 0 0 1-.084-.654l.218.117.067.419zm.738.319a.723.723 0 0 1-.687-.251c0-.017-.017-.017-.017-.034l.184-.117.5.168zm.184-.05l-.151-.184.386-.335-.084-.469.184-.168a.777.777 0 0 1-.134 1.023.531.531 0 0 1-.201.132zm-.117.05l-.017-.117.084.1c-.034-.001-.051-.001-.068.016zm.1.956l-.1-.922a.238.238 0 0 0 .1-.034l1.861 2.33a.293.293 0 0 1-.067.084zM.7 430.479l-1.408.05-.2-1.71 1.744 1.425a1.071 1.071 0 0 0-.136.235zm.1 0a1.83 1.83 0 0 1 .1-.184l.218.184zm.134-.235l.05-.067.235.285zm.889-.52l.05.436-.62.285-.251-.3a1.3 1.3 0 0 1 .823-.42zm.117.386l-.05-.386h.17zm-.319 2.163a1.277 1.277 0 0 1-.921-1.392.968.968 0 0 1 .05-.235l.453-.017-.084.771.671.52zm-2.85-5.968v-.05a.743.743 0 0 1 .553.184l-.184.168-.386-.134v-.117h-.064v.117l-.335.285-.235-.117a.671.671 0 0 1 .168-.2.742.742 0 0 1 .4-.184v.05zm5.013-2.179l-1.71 5.516a.808.808 0 0 0-.2 0l-.6-4.745 2.012-1.827zm.419-1.375l-.4 1.274L3.334 423l.5-.469a1.757 1.757 0 0 0 .372.219zm.335-.587l.134.6a1.427 1.427 0 0 1-.285-.1zm-.285.436a2.535 2.535 0 0 1-.285-.168l.453-.419zm-1.073-.771a2.194 2.194 0 0 0 .553.62l-.453.4-.821-1.827.386-.117a2.36 2.36 0 0 0 .338.923zm1.207.017l-.536.486a2.66 2.66 0 0 1-.536-.6 2.382 2.382 0 0 1-.315-.876l.671-.218zm-.787-1.275l.017.033-.637.2a2.353 2.353 0 0 1 1.006-2.213l.369.587zm1.274 9.69l-1.693.285a1.36 1.36 0 0 0-.939-.872l1.643-5.331 2.079 4.61a1.649 1.649 0 0 0-1.087 1.308zm.117-.017A1.555 1.555 0 0 1 6 429.054l.2.47-.721.637zm.335 1.358a1.59 1.59 0 0 1-.335-.721 2.293 2.293 0 0 1-.034-.469l.5-.084.2 1.006zm.838-2.347l-.1-.218a.062.062 0 0 0 .05-.017zm-4.389 3.035l.184-.4.7-.319.084-.788.4-.067a1.378 1.378 0 0 1 .034.453 1.267 1.267 0 0 1-1.375 1.14c-.027-.002-.027-.002-.027-.019zm-4.845-1.526l2.33-.084.587 5.113a.814.814 0 0 0-.453.084zm-2.83-7.125l.1-.3a1.077 1.077 0 0 1 .168.218zm.3-.034a1.255 1.255 0 0 1 .168.553 1.284 1.284 0 0 1-.117.62l-.319-.168-.05-.905v-.017zm4.594-1.358v-.1l1.811-.57.4 3.185-1.827 1.66a.8.8 0 0 0-.6-.2v-.022h-.067v.034a.8.8 0 0 0-.436.2 2.117 2.117 0 0 0-.184.218l-3.571-1.827a1.3 1.3 0 0 0 .117-.671 1.4 1.4 0 0 0-.168-.587l4.46-1.408v.084zm-.855-10.83l1.358.017v.084h.05v.067H-.5v.117h.067v-.084l.117.956-.017-.05-.117.034.017.067c.034-.017.084-.017.117-.034l.386 3.118-.654-1.442v-.084h-.038zm-.168-2.9l-.855 1.442.821 1.442-3.837 11.718a1.291 1.291 0 0 0-.872-.268 1.335 1.335 0 0 0-1.241 1.459 1.37 1.37 0 0 0 1.392 1.308v.084h.067v-.084a1.269 1.269 0 0 0 .771-.352l1.693 3.537-1.945 1.14a1.185 1.185 0 0 0-.3-.2v-.084h-.067v.067a.983.983 0 0 0-.754.034 1.038 1.038 0 0 0-.469 1.391 1.048 1.048 0 0 0 1.375.537.935.935 0 0 0 .419-.386l5.013 4.778a.9.9 0 0 0-.151.2.824.824 0 0 0 .313 1.12.82.82 0 0 0 1.106-.352.832.832 0 0 0-.134-.989L5.3 431.72a1.66 1.66 0 0 0 1.559.553 1.7 1.7 0 0 0 1.308-2.012 1.723 1.723 0 0 0-1.928-1.392l-1.341-5.9a2.352 2.352 0 0 0 1.693-.335 2.469 2.469 0 0 0 .8-3.4 2.5 2.5 0 0 0-3.353-.855l-4.392-7.008.821-1.408-.838-1.463z",
    transform: "translate(8.019 -407.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35663",
    "data-name": "Path 35663",
    className: "cls-3",
    d: "M27.034 432.334l-.017.05c-.034-.017-.084-.017-.117-.034l.017-.05a1.056 1.056 0 0 1 .117.034z",
    transform: "translate(-21.046 -427.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35664",
    "data-name": "Path 35664",
    className: "cls-3",
    d: "M28.417 432.8c-.034-.017-.084-.017-.117-.034l.017-.067.117.033z",
    transform: "translate(-22.211 -427.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35665",
    "data-name": "Path 35665",
    className: "cls-3",
    d: "M29.917 433.084c-.034 0-.084-.017-.117-.017l.017-.067c.034 0 .084.017.117.017z",
    transform: "translate(-23.46 -427.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35666",
    "data-name": "Path 35666",
    className: "cls-3",
    d: "M25.534 402.2l-.034-.05c.034-.017.084-.034.117-.05l.017.05z",
    transform: "translate(-19.88 -401.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35667",
    "data-name": "Path 35667",
    className: "cls-3",
    d: "M26.917 401.784l-.017-.05a.312.312 0 0 1 .117-.034l.017.05a.427.427 0 0 0-.117.034z",
    transform: "translate(-21.046 -401.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35668",
    "data-name": "Path 35668",
    className: "cls-3",
    d: "M16.384 419.4l-.067.017c0-.034-.017-.084-.017-.117h.067c0 .034.017.067.017.1z",
    transform: "translate(-12.223 -416.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35669",
    "data-name": "Path 35669",
    className: "cls-3",
    d: "M28.317 401.2l-.017-.067c.034-.017.084-.017.117-.034l.017.067z",
    transform: "translate(-22.211 -401.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35670",
    "data-name": "Path 35670",
    className: "cls-3",
    d: "M29.817 400.984l-.017-.067c.034 0 .084-.017.117-.017v.067a.212.212 0 0 1-.1.017z",
    transform: "translate(-23.46 -400.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35671",
    "data-name": "Path 35671",
    className: "cls-3",
    d: "M31.3 400.9h.117v.067H31.3z",
    transform: "translate(-24.708 -400.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35672",
    "data-name": "Path 35672",
    className: "cls-3",
    d: "M35.717 432.9l.017.067c-.034 0-.084.017-.117.017l-.017-.067c.05 0 .084-.017.117-.017z",
    transform: "translate(-28.287 -427.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35673",
    "data-name": "Path 35673",
    className: "cls-3",
    d: "M22.734 403.917l-.034-.05c.034-.017.067-.05.1-.067l.034.05a.154.154 0 0 0-.1.067z",
    transform: "translate(-17.55 -403.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35674",
    "data-name": "Path 35674",
    className: "cls-3",
    d: "M21.634 404.734l-.034-.05.1-.084.034.05c-.05.034-.084.05-.1.084z",
    transform: "translate(-16.634 -403.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35675",
    "data-name": "Path 35675",
    className: "cls-3",
    d: "M20.45 405.734l-.05-.05c.034-.034.05-.067.084-.084l.05.05c-.034.034-.05.067-.084.084z",
    transform: "translate(-15.636 -404.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35676",
    "data-name": "Path 35676",
    className: "cls-3",
    d: "M19.55 406.934l-.05-.034a.446.446 0 0 1 .084-.1l.05.034z",
    transform: "translate(-14.886 -405.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35677",
    "data-name": "Path 35677",
    className: "cls-3",
    d: "M18.75 408.134l-.05-.034c.017-.034.05-.067.067-.1l.05.034a.35.35 0 0 0-.067.1z",
    transform: "translate(-14.221 -406.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35678",
    "data-name": "Path 35678",
    className: "cls-3",
    d: "M21.9 429.334c-.034-.034-.067-.05-.1-.084l.034-.05c.034.034.067.05.1.084z",
    transform: "translate(-16.801 -424.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35679",
    "data-name": "Path 35679",
    className: "cls-3",
    d: "M32.834 433.367H32.7v-.067h.117z",
    transform: "translate(-25.873 -427.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35680",
    "data-name": "Path 35680",
    className: "cls-3",
    d: "M18.05 409.251l-.05-.034a.96.96 0 0 1 .067-.117l.05.034a.961.961 0 0 0-.067.117z",
    transform: "translate(-13.638 -407.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35681",
    "data-name": "Path 35681",
    className: "cls-3",
    d: "M16.184 417.834h-.067a.417.417 0 0 0-.017-.134h.067a.37.37 0 0 1 .017.134z",
    transform: "translate(-12.056 -414.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35682",
    "data-name": "Path 35682",
    className: "cls-3",
    d: "M16.567 413.534l-.067-.017.034-.117.067.017a.243.243 0 0 0-.034.117z",
    transform: "translate(-12.389 -411.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35683",
    "data-name": "Path 35683",
    className: "cls-3",
    d: "M16.267 416.334H16.2v-.134h.067z",
    transform: "translate(-12.14 -413.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35684",
    "data-name": "Path 35684",
    className: "cls-3",
    d: "M16.267 415.017H16.2a.285.285 0 0 1 .017-.117h.067a.327.327 0 0 1-.017.117z",
    transform: "translate(-12.14 -412.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35685",
    "data-name": "Path 35685",
    className: "cls-3",
    d: "M17.45 410.734l-.05-.017.05-.117.05.017a.814.814 0 0 0-.05.117z",
    transform: "translate(-13.138 -408.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35686",
    "data-name": "Path 35686",
    className: "cls-3",
    d: "M16.867 412.034l-.067-.017c.017-.034.017-.084.034-.117l.067.017a.242.242 0 0 1-.034.117z",
    transform: "translate(-12.639 -410.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35687",
    "data-name": "Path 35687",
    className: "cls-3",
    d: "M44.45 406.2c.034.034.05.067.084.084l-.05.034c-.034-.034-.05-.067-.084-.1z",
    transform: "translate(-35.612 -405.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35688",
    "data-name": "Path 35688",
    className: "cls-3",
    d: "M41.1 430.6l.034.05c-.034.017-.067.05-.1.067l-.034-.05a.351.351 0 0 1 .1-.067z",
    transform: "translate(-32.782 -425.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35689",
    "data-name": "Path 35689",
    className: "cls-3",
    d: "M24.317 431.117a.966.966 0 0 1-.117-.067l.034-.05.1.05z",
    transform: "translate(-18.798 -425.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35690",
    "data-name": "Path 35690",
    className: "cls-3",
    d: "M23.1 430.317c-.034-.017-.067-.05-.1-.067l.034-.05c.034.017.067.05.1.067z",
    transform: "translate(-17.8 -425.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35691",
    "data-name": "Path 35691",
    className: "cls-3",
    d: "M42.3 429.7l.034.05c-.034.034-.067.05-.1.084l-.034-.05c.034-.034.067-.051.1-.084z",
    transform: "translate(-33.781 -424.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35692",
    "data-name": "Path 35692",
    className: "cls-3",
    d: "M44.484 427.7l.05.034c-.034.034-.05.067-.084.1l-.05-.034c.034-.033.05-.066.084-.1z",
    transform: "translate(-35.612 -423.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35693",
    "data-name": "Path 35693",
    className: "cls-3",
    d: "M45.467 426.5l.05.034a.35.35 0 0 0-.067.1l-.05-.034z",
    transform: "translate(-36.444 -422.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35694",
    "data-name": "Path 35694",
    className: "cls-3",
    d: "M43.567 428.8l.05.05c-.034.034-.067.05-.084.084l-.034-.05z",
    transform: "translate(-34.863 -424.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35695",
    "data-name": "Path 35695",
    className: "cls-3",
    d: "M24.068 402.8l.034.05-.067.034a.352.352 0 0 0-.1.067l-.034-.05c.034-.017.067-.05.1-.067z",
    transform: "translate(-18.549 -402.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35696",
    "data-name": "Path 35696",
    className: "cls-3",
    d: "M19.784 427.334c-.034-.034-.05-.067-.084-.1l.05-.034c.034.034.05.067.084.1z",
    transform: "translate(-15.053 -422.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35697",
    "data-name": "Path 35697",
    className: "cls-3",
    d: "M20.884 428.517l-.084-.084.05-.034c.034.034.05.067.084.084z",
    transform: "translate(-15.968 -423.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35698",
    "data-name": "Path 35698",
    className: "cls-3",
    d: "M18.967 426.134l-.067-.1.05-.034c.017.034.05.067.067.1z",
    transform: "translate(-14.387 -421.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35699",
    "data-name": "Path 35699",
    className: "cls-3",
    d: "M17.6 423.517l-.05.017a.816.816 0 0 1-.05-.117l.05-.017c.017.034.034.084.05.117z",
    transform: "translate(-13.222 -419.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35700",
    "data-name": "Path 35700",
    className: "cls-3",
    d: "M17.1 422.117l-.067.017a.311.311 0 0 1-.034-.117l.067-.017a.243.243 0 0 0 .034.117z",
    transform: "translate(-12.806 -418.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35701",
    "data-name": "Path 35701",
    className: "cls-3",
    d: "M18.2 424.767l.017.05-.05.034-.017-.05-.05-.067.067-.034z",
    transform: "translate(-13.721 -420.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35702",
    "data-name": "Path 35702",
    className: "cls-3",
    d: "M16.6 420.817l-.067.017c-.017-.034-.017-.084-.034-.117l.067-.017a1.068 1.068 0 0 1 .034.117z",
    transform: "translate(-12.389 -417.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35703",
    "data-name": "Path 35703",
    className: "cls-3",
    d: "M46.25 408.5c.017.034.05.067.067.1l-.05.034a.35.35 0 0 0-.067-.1z",
    transform: "translate(-37.11 -407.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35704",
    "data-name": "Path 35704",
    className: "cls-3",
    d: "M47.5 411.217l.05-.017c.017.034.034.084.05.117l-.067.017a.243.243 0 0 0-.033-.117z",
    transform: "translate(-38.192 -409.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35705",
    "data-name": "Path 35705",
    className: "cls-3",
    d: "M48.4 414.017l.05-.017.034.117-.067.017z",
    transform: "translate(-38.941 -411.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35706",
    "data-name": "Path 35706",
    className: "cls-3",
    d: "M48 412.617l.067-.017c.017.034.017.084.034.117l-.067.017a.242.242 0 0 0-.034-.117z",
    transform: "translate(-38.608 -410.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35707",
    "data-name": "Path 35707",
    className: "cls-3",
    d: "M48.6 415.5h.067a.285.285 0 0 0 .017.117h-.067c0-.033-.017-.067-.017-.117z",
    transform: "translate(-39.108 -413.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35708",
    "data-name": "Path 35708",
    className: "cls-3",
    d: "M34.317 433.2v.067c-.034 0-.084.017-.117.017v-.067a.285.285 0 0 1 .117-.017z",
    transform: "translate(-27.122 -427.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35709",
    "data-name": "Path 35709",
    className: "cls-3",
    d: "M45.45 407.3c.017.034.05.067.067.1l-.05.034c-.017-.034-.05-.067-.067-.1z",
    transform: "translate(-36.444 -406.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35710",
    "data-name": "Path 35710",
    className: "cls-3",
    d: "M48.7 417h.067v.117H48.7z",
    transform: "translate(-39.191 -414.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35711",
    "data-name": "Path 35711",
    className: "cls-3",
    d: "M46.9 409.833l.05-.034.067.117-.067.017z",
    transform: "translate(-37.693 -408.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35712",
    "data-name": "Path 35712",
    className: "cls-3",
    d: "M46.95 424l.05.034c-.017.034-.034.084-.05.117l-.05-.034c.017-.033.034-.083.05-.117z",
    transform: "translate(-37.693 -420.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35713",
    "data-name": "Path 35713",
    className: "cls-3",
    d: "M48.617 418.4h.067a.286.286 0 0 1-.017.117H48.6z",
    transform: "translate(-39.108 -415.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35714",
    "data-name": "Path 35714",
    className: "cls-3",
    d: "M48.417 419.9l.067.017c0 .034-.017.084-.017.117l-.067-.017c0-.05.017-.083.017-.117z",
    transform: "translate(-38.941 -416.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35715",
    "data-name": "Path 35715",
    className: "cls-3",
    d: "M38.6 432l.034.05-.117.05-.017-.067a.239.239 0 0 0 .1-.033z",
    transform: "translate(-30.701 -426.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35716",
    "data-name": "Path 35716",
    className: "cls-3",
    d: "M47.55 422.7l.05.017c-.017.034-.034.084-.05.117l-.05-.017a.818.818 0 0 1 .05-.117z",
    transform: "translate(-38.192 -419.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35717",
    "data-name": "Path 35717",
    className: "cls-3",
    d: "M46.267 425.3l.05.034-.067.1-.05-.034a.352.352 0 0 1 .067-.1z",
    transform: "translate(-37.11 -421.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35718",
    "data-name": "Path 35718",
    className: "cls-3",
    d: "M48.034 421.3l.067.017-.034.117-.067-.017c.017-.033.017-.084.034-.117z",
    transform: "translate(-38.608 -417.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35719",
    "data-name": "Path 35719",
    className: "cls-3",
    d: "M36.65 430.317h-.05v-.117h.067z",
    transform: "translate(-29.12 -425.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35720",
    "data-name": "Path 35720",
    className: "cls-3",
    d: "M32.45 509.634h-.05v-.134l.067.017z",
    transform: "translate(-25.624 -491.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35721",
    "data-name": "Path 35721",
    className: "cls-3",
    d: "M32.267 511.834H32.2l.017-.134.067.017z",
    transform: "translate(-25.457 -493.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35722",
    "data-name": "Path 35722",
    className: "cls-3",
    d: "M32.267 513.017H32.2v-.117h.067z",
    transform: "translate(-25.457 -494.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2190",
    "data-name": "Rectangle 2190",
    className: "cls-3",
    transform: "rotate(-86.906 13.155 5.703)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35723",
    "data-name": "Path 35723",
    className: "cls-3",
    d: "M36.667 429.217H36.6l.017-.117h.05z",
    transform: "translate(-29.12 -424.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35724",
    "data-name": "Path 35724",
    className: "cls-3",
    d: "M36.75 428.117h-.05V428h.067z",
    transform: "translate(-29.203 -423.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35725",
    "data-name": "Path 35725",
    className: "cls-3",
    d: "M36.367 434.717H36.3l.017-.117h.05z",
    transform: "translate(-28.87 -428.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2191",
    "data-name": "Rectangle 2191",
    className: "cls-3",
    transform: "rotate(-86.906 7.135 -.645)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35726",
    "data-name": "Path 35726",
    className: "cls-3",
    d: "M36.067 440.234l-.067-.017.017-.117h.05z",
    transform: "translate(-28.62 -433.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35727",
    "data-name": "Path 35727",
    className: "cls-3",
    d: "M36.05 441.334l-.05-.017v-.117h.067z",
    transform: "translate(-28.62 -434.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35728",
    "data-name": "Path 35728",
    className: "cls-3",
    d: "M36.417 432.4h.05v.117H36.4z",
    transform: "translate(-28.953 -427.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2192",
    "data-name": "Rectangle 2192",
    className: "cls-3",
    transform: "rotate(-86.906 7.04 -.746)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35729",
    "data-name": "Path 35729",
    className: "cls-3",
    d: "M36.5 431.3h.067v.117H36.5z",
    transform: "translate(-29.036 -426.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35730",
    "data-name": "Path 35730",
    className: "cls-3",
    d: "M36.467 433.617H36.4v-.117h.067z",
    transform: "translate(-28.953 -428.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35731",
    "data-name": "Path 35731",
    className: "cls-3",
    d: "M36.35 435.817h-.05v-.117h.067z",
    transform: "translate(-28.87 -429.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35732",
    "data-name": "Path 35732",
    className: "cls-3",
    d: "M36.267 436.917H36.2v-.117h.067z",
    transform: "translate(-28.787 -430.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35733",
    "data-name": "Path 35733",
    className: "cls-3",
    d: "M32.867 500.834H32.8l.017-.134h.05z",
    transform: "translate(-25.957 -483.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35734",
    "data-name": "Path 35734",
    className: "cls-3",
    d: "M34.85 464.434h-.05v-.134l.067.017z",
    transform: "translate(-27.621 -453.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35735",
    "data-name": "Path 35735",
    className: "cls-3",
    d: "M34.767 465.617H34.7v-.117h.067z",
    transform: "translate(-27.538 -454.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35736",
    "data-name": "Path 35736",
    className: "cls-3",
    d: "M34.667 466.717H34.6l.017-.117h.05z",
    transform: "translate(-27.455 -455.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35737",
    "data-name": "Path 35737",
    className: "cls-3",
    d: "M34.65 467.817h-.05v-.117h.067z",
    transform: "translate(-27.455 -456.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35738",
    "data-name": "Path 35738",
    className: "cls-3",
    d: "M34.967 461.134H34.9l.017-.134.05.017z",
    transform: "translate(-27.705 -450.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35739",
    "data-name": "Path 35739",
    className: "cls-3",
    d: "M34.867 463.334H34.8l.017-.134.05.017z",
    transform: "translate(-27.621 -452.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35740",
    "data-name": "Path 35740",
    className: "cls-3",
    d: "M34.95 462.234h-.05v-.134l.067.017z",
    transform: "translate(-27.705 -451.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35741",
    "data-name": "Path 35741",
    className: "cls-3",
    d: "M34.367 473.317H34.3v-.117h.067z",
    transform: "translate(-27.205 -461.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35742",
    "data-name": "Path 35742",
    className: "cls-3",
    d: "M34.267 474.417H34.2l.017-.117h.05z",
    transform: "translate(-27.122 -461.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2193",
    "data-name": "Rectangle 2193",
    className: "cls-3",
    transform: "rotate(-86.906 10.289 2.673)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2194",
    "data-name": "Rectangle 2194",
    className: "cls-3",
    transform: "rotate(-86.906 8.89 1.212)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2195",
    "data-name": "Rectangle 2195",
    className: "cls-3",
    transform: "rotate(-86.906 10.194 2.571)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2196",
    "data-name": "Rectangle 2196",
    className: "cls-3",
    transform: "rotate(-86.906 9.73 2.082)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35743",
    "data-name": "Path 35743",
    className: "cls-3",
    d: "M34.367 472.217H34.3l.017-.117h.067z",
    transform: "translate(-27.205 -460.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35744",
    "data-name": "Path 35744",
    className: "cls-3",
    d: "M34.467 471.117H34.4l.017-.117h.05z",
    transform: "translate(-27.288 -459.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35745",
    "data-name": "Path 35745",
    className: "cls-3",
    d: "M34.567 468.917H34.5l.017-.117h.05z",
    transform: "translate(-27.372 -457.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2197",
    "data-name": "Rectangle 2197",
    className: "cls-3",
    transform: "rotate(-86.906 7.966 .232)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35746",
    "data-name": "Path 35746",
    className: "cls-3",
    d: "M35.55 451.234h-.05v-.134h.067z",
    transform: "translate(-28.204 -442.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35747",
    "data-name": "Path 35747",
    className: "cls-3",
    d: "M35.667 447.934l-.067-.017.017-.117h.05z",
    transform: "translate(-28.287 -439.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35748",
    "data-name": "Path 35748",
    className: "cls-3",
    d: "M35.567 450.134H35.5V450h.067z",
    transform: "translate(-28.204 -441.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35749",
    "data-name": "Path 35749",
    className: "cls-3",
    d: "M35.767 446.834l-.067-.017v-.117h.067z",
    transform: "translate(-28.37 -439.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35750",
    "data-name": "Path 35750",
    className: "cls-3",
    d: "M35.867 444.634l-.067-.017v-.117h.067z",
    transform: "translate(-28.454 -437.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35751",
    "data-name": "Path 35751",
    className: "cls-3",
    d: "M35.85 445.734l-.05-.017v-.117h.067z",
    transform: "translate(-28.454 -438.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35752",
    "data-name": "Path 35752",
    className: "cls-3",
    d: "M35.167 457.834H35.1v-.134l.067.017z",
    transform: "translate(-27.871 -448.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35753",
    "data-name": "Path 35753",
    className: "cls-3",
    d: "M35.25 456.734h-.05v-.134l.067.017z",
    transform: "translate(-27.954 -447.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35754",
    "data-name": "Path 35754",
    className: "cls-3",
    d: "M35.067 458.934H35l.017-.134.067.017z",
    transform: "translate(-27.788 -449.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35755",
    "data-name": "Path 35755",
    className: "cls-3",
    d: "M35.267 455.634H35.2l.017-.134h.05z",
    transform: "translate(-27.954 -446.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35756",
    "data-name": "Path 35756",
    className: "cls-3",
    d: "M35.367 454.534H35.3v-.134h.067z",
    transform: "translate(-28.038 -445.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2198",
    "data-name": "Rectangle 2198",
    className: "cls-3",
    transform: "rotate(-86.906 8.245 .528)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35757",
    "data-name": "Path 35757",
    className: "cls-3",
    d: "M35.367 453.434H35.3l.017-.134h.05z",
    transform: "translate(-28.038 -444.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35758",
    "data-name": "Path 35758",
    className: "cls-3",
    d: "M33.167 495.334l-.067-.017.017-.117h.05z",
    transform: "translate(-26.206 -479.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35759",
    "data-name": "Path 35759",
    className: "cls-3",
    d: "M33.967 479.917H33.9l.017-.117h.05z",
    transform: "translate(-26.872 -466.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2199",
    "data-name": "Rectangle 2199",
    className: "cls-3",
    transform: "rotate(-86.906 10.656 3.06)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35760",
    "data-name": "Path 35760",
    className: "cls-3",
    d: "M34.067 478.817H34v-.117h.067z",
    transform: "translate(-26.955 -465.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35761",
    "data-name": "Path 35761",
    className: "cls-3",
    d: "M34.15 477.717h-.05v-.117h.067z",
    transform: "translate(-27.039 -464.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35762",
    "data-name": "Path 35762",
    className: "cls-3",
    d: "M33.867 482.117H33.8l.017-.117h.05z",
    transform: "translate(-26.789 -468.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35763",
    "data-name": "Path 35763",
    className: "cls-3",
    d: "M33.367 492.034l-.067-.017v-.117h.067z",
    transform: "translate(-26.373 -476.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35764",
    "data-name": "Path 35764",
    className: "cls-3",
    d: "M33.267 494.234H33.2v-.134h.067z",
    transform: "translate(-26.29 -478.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35765",
    "data-name": "Path 35765",
    className: "cls-3",
    d: "M33.45 490.934l-.05-.017v-.117h.067z",
    transform: "translate(-26.456 -475.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35766",
    "data-name": "Path 35766",
    className: "cls-3",
    d: "M33.567 487.634l-.067-.017.017-.117h.05z",
    transform: "translate(-26.539 -472.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35767",
    "data-name": "Path 35767",
    className: "cls-3",
    d: "M33.55 488.734l-.05-.017v-.117h.067z",
    transform: "translate(-26.539 -473.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35768",
    "data-name": "Path 35768",
    className: "cls-3",
    d: "M33.667 486.534l-.067-.017v-.117h.067z",
    transform: "translate(-26.623 -472.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35769",
    "data-name": "Path 35769",
    className: "cls-3",
    d: "M33.75 485.417h-.05v-.117h.05z",
    transform: "translate(-26.706 -471.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35770",
    "data-name": "Path 35770",
    className: "cls-3",
    d: "M33.85 483.217h-.05v-.117h.067z",
    transform: "translate(-26.789 -469.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35771",
    "data-name": "Path 35771",
    className: "cls-3",
    d: "M33.767 484.317H33.7l.017-.117h.05z",
    transform: "translate(-26.706 -470.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2200",
    "data-name": "Rectangle 2200",
    className: "cls-3",
    transform: "rotate(-86.906 11.67 4.132)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2201",
    "data-name": "Rectangle 2201",
    className: "cls-3",
    transform: "rotate(-86.906 12.692 5.213)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35772",
    "data-name": "Path 35772",
    className: "cls-3",
    d: "M32.85 501.934h-.05v-.134l.067.017z",
    transform: "translate(-25.957 -484.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35773",
    "data-name": "Path 35773",
    className: "cls-3",
    d: "M32.767 503.034H32.7l.017-.134.05.017z",
    transform: "translate(-25.873 -485.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2202",
    "data-name": "Rectangle 2202",
    className: "cls-3",
    transform: "rotate(-86.906 12.596 5.111)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35774",
    "data-name": "Path 35774",
    className: "cls-3",
    d: "M32.55 507.434h-.05v-.134l.067.017z",
    transform: "translate(-25.707 -489.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35775",
    "data-name": "Path 35775",
    className: "cls-3",
    d: "M32.567 506.334H32.5l.017-.134.067.017z",
    transform: "translate(-25.707 -488.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2203",
    "data-name": "Rectangle 2203",
    className: "cls-3",
    transform: "rotate(-86.906 12.133 4.622)",
    d: "M0 0h.117v.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35776",
    "data-name": "Path 35776",
    className: "cls-3",
    d: "M32.967 499.734H32.9v-.134h.067z",
    transform: "translate(-26.04 -483.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35777",
    "data-name": "Path 35777",
    className: "cls-3",
    d: "M32.467 508.534H32.4l.017-.134.05.017z",
    transform: "translate(-25.624 -490.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35778",
    "data-name": "Path 35778",
    className: "cls-3",
    d: "M33.15 496.434l-.05-.017v-.117h.067z",
    transform: "translate(-26.206 -480.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35779",
    "data-name": "Path 35779",
    className: "cls-3",
    d: "M33.067 497.534H33v-.134h.067z",
    transform: "translate(-26.123 -481.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2204",
    "data-name": "Rectangle 2204",
    className: "cls-3",
    transform: "rotate(-3.15 404.727 -17.82)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35780",
    "data-name": "Path 35780",
    className: "cls-3",
    d: "M1.5 532.434v-.117l.067-.017v.134z",
    transform: "translate(.096 -510.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35781",
    "data-name": "Path 35781",
    className: "cls-3",
    d: "M1.6 535.7h.067v.117h-.05z",
    transform: "translate(.013 -513.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    className: "cls-3",
    transform: "rotate(-3.094 336.815 -16.694)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35782",
    "data-name": "Path 35782",
    className: "cls-3",
    d: "M.667 515.917l-.05.017L.6 515.8h.067z",
    transform: "translate(.845 -496.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35783",
    "data-name": "Path 35783",
    className: "cls-3",
    d: "M.867 519.217l-.067.017v-.134h.067z",
    transform: "translate(.679 -499.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    className: "cls-3",
    transform: "rotate(-3.094 364.164 -17.493)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35784",
    "data-name": "Path 35784",
    className: "cls-3",
    d: "M1.067 522.534H1v-.134h.05z",
    transform: "translate(.512 -502.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35785",
    "data-name": "Path 35785",
    className: "cls-3",
    d: "M.967 521.434H.9v-.134h.067z",
    transform: "translate(.595 -501.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35786",
    "data-name": "Path 35786",
    className: "cls-3",
    d: "M.967 520.334H.9v-.134h.05z",
    transform: "translate(.595 -500.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35787",
    "data-name": "Path 35787",
    className: "cls-3",
    d: "M.767 517.017l-.067.017v-.134h.067z",
    transform: "translate(.762 -497.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    className: "cls-3",
    transform: "rotate(-3.094 350.495 -16.936)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35788",
    "data-name": "Path 35788",
    className: "cls-3",
    d: "M.667 514.817l-.067.017v-.134h.05z",
    transform: "translate(.845 -495.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35789",
    "data-name": "Path 35789",
    className: "cls-3",
    d: "M.267 508.217h-.05L.2 508.1h.067z",
    transform: "translate(1.178 -490.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35790",
    "data-name": "Path 35790",
    className: "cls-3",
    d: "M.567 512.617l-.067.017v-.134h.05z",
    transform: "translate(.928 -493.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35791",
    "data-name": "Path 35791",
    className: "cls-3",
    d: "M1.067 523.634h-.05L1 523.5h.067z",
    transform: "translate(.512 -502.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35792",
    "data-name": "Path 35792",
    className: "cls-3",
    d: "M1.467 530.234H1.4v-.117l.05-.017z",
    transform: "translate(.179 -508.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35793",
    "data-name": "Path 35793",
    className: "cls-3",
    d: "M1.367 529.134h-.05l-.017-.117.067-.017z",
    transform: "translate(.262 -507.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35794",
    "data-name": "Path 35794",
    className: "cls-3",
    d: "M.467 511.517H.4v-.117h.067z",
    transform: "translate(1.011 -492.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35795",
    "data-name": "Path 35795",
    className: "cls-3",
    d: "M1.467 531.334h-.05l-.017-.117.067-.017z",
    transform: "translate(.179 -509.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2208",
    "data-name": "Rectangle 2208",
    className: "cls-3",
    transform: "rotate(-3.094 394.94 -18.218)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35796",
    "data-name": "Path 35796",
    className: "cls-3",
    d: "M1.167 524.734H1.1v-.134h.067z",
    transform: "translate(.429 -503.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35797",
    "data-name": "Path 35797",
    className: "cls-3",
    d: "M1.167 525.834h-.05L1.1 525.7h.067z",
    transform: "translate(.429 -504.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35798",
    "data-name": "Path 35798",
    className: "cls-3",
    d: "M1.267 526.934H1.2v-.117l.067-.017z",
    transform: "translate(.346 -505.693)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842",
    transform: "translate(20.72 10.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35799",
    "data-name": "Path 35799",
    className: "cls-5",
    d: "M121.636 466.907l.364 12.406-.905-.939.05-.017-.017-.067c-.034 0-.05.017-.084.017l-1.174-1.224-.017-.034h-.017l-.05-.05.05-.017-.034-.117-.067.017.034.084-1.157-1.207-2.565-5.03 5.264-4.057a.826.826 0 0 0 .325.235zm.151-.033l-.017-.469.754.1.536-.738-.369-.855-.905-.134-.034.05-.4.553-.335-.319a1.152 1.152 0 0 1 .62-.6 1.283 1.283 0 0 1 1.66.7 1.26 1.26 0 0 1-.637 1.677 1.127 1.127 0 0 1-.873.034zm-.872-1.811a1.32 1.32 0 0 0-.084.235l-4.024-1.425 1.308-1.593zm-2.8-2.85l-1.408-1.392 2.3-.922a1.093 1.093 0 0 0 .251.386 1.105 1.105 0 0 0 .285.2zm1.526-1.744l.168-.2.034.084.05-.017-.034-.084.62-.151.168-.671-.5-.5-.671.168-.117.436-.335-.151a.909.909 0 0 1 .251-.486 1 1 0 1 1 .369 1.576zm-.62-.738a.957.957 0 0 1-.017-.218l.268.117zm.754.486l-.184.235a1.1 1.1 0 0 1-.285-.2 1.064 1.064 0 0 1-.235-.369l.268-.1zm-.838-.738a1.444 1.444 0 0 0 .017.268l-2.364.956-4.074-4.024.017-.017zm-6.371-2.967l-.235-.1.067-.453-.419-.352-.5.2-.084.553.335.268-.134.235a.775.775 0 0 1-.436-.822.756.756 0 1 1 1.492.235 1.314 1.314 0 0 1-.086.237zm-.939.436a.152.152 0 0 0 .084.017l-.235 3.873h-.034a1.359 1.359 0 0 0-.972 1.66 1.423 1.423 0 0 0 .184.436l-1.442.822a1.422 1.422 0 0 0-.184-.436 1.6 1.6 0 0 0-.6-.6zm-3.336 5.817l-.218.4h-1.09l-.536 1.006.6 1.006h1.056l.268.4a1.6 1.6 0 0 1-2.129-.62 1.581 1.581 0 0 1 .5-2.179 1.5 1.5 0 0 1 1.549-.012zm3.588 7.98l-3.3-5.164c.017-.017.034-.034.05-.034l3.571 3.688.067 1.492c-.137.002-.267.019-.388.019zm-.084.168l.453.7-1.391.536-.251 1.66 1.308 1.039 1.475-.57.536.419a2.323 2.323 0 0 1-3.588-2.951 2.414 2.414 0 0 1 1.458-.832zm6.773 4.912l1.962 3.856-.671-.536c.017-.017.034-.05.067-.067l-.05-.05c-.017.017-.034.05-.067.067l-5.65-4.426a2.467 2.467 0 0 0 .2-2.615l.335-.251zM116 470.813l2.464 4.845-3.739-3.873zm-.034-.067l-1.291.989-1.408-1.458 1.241-2.364zm4.963-5.415a.944.944 0 0 1 .067-.2l.285.268-.218-.034zm-4.158-1.392l3.973 1.408-3.906-.469a.794.794 0 0 0-.319-.637zm-.067-.017l-.235.285c-.017 0-.017-.017-.034-.017a.822.822 0 0 0-.788 0l-.386-.771zm-.05-3.068l1.425 1.408-1.324 1.609-1.509-.536-.8-1.609zm-4.191-4.225l.017.017zm-.017.067a.712.712 0 0 1-.386.235l-.117-.251.335-.134.05.017zm-.738.218c-.017 0-.034-.017-.067-.017l.067-.134zm.168-.218l.117.235a.359.359 0 0 1-.134 0l.017-.235zm-.017.3a.57.57 0 0 0 .168-.017l2.3 4.627-1.241.5a1.134 1.134 0 0 0-.034-.235 1.384 1.384 0 0 0-1.425-1.073zm-1.056 6.019l.319-.184.771.251.017.4a1.241 1.241 0 0 1-1.104-.465zm3.672 4.661l-2.163-4.225a1.31 1.31 0 0 0 .654-.687l2.515 1.542a.8.8 0 0 0-.151.184.83.83 0 0 0 .235 1.09zm2.029-3.4a.73.73 0 0 1 .3.587l-.235-.034-.218-.369zm-.822-.05a.726.726 0 0 1 .738 0c.017 0 .017.017.034.017l-.134.168-.52.017zm-.151.117l.2.134-.251.453.235.4-.117.218a.776.776 0 0 1-.218-1.023.808.808 0 0 1 .154-.183zm.1-.084l.05.1-.117-.067c.036-.017.053-.017.07-.034zm-.436-.872l.419.822c-.034.017-.05.034-.084.05l-2.548-1.559c.017-.034.017-.067.034-.1zm-2.112-1.106l1.308-.52.771 1.542-2.129-.754a.7.7 0 0 0 .053-.269zm-.084.034a.982.982 0 0 1-.034.218l-.268-.1zm-.05.285c0 .034-.017.05-.017.084l-.319-.184zm-.671.788l-.2-.386.486-.469.335.2a1.243 1.243 0 0 1-.618.653zm-.235-.335l.168.335-.151.05zm-.436-2.146a1.294 1.294 0 0 1 1.341 1.006 1.313 1.313 0 0 1 .034.235l-.419.168-.184-.754-.8-.251zm4.694 4.661l.017.05a.79.79 0 0 1-.587.017l.117-.235.4-.017.034.117.067-.017-.034-.117.218-.386.252.034a1.48 1.48 0 0 1-.084.251.786.786 0 0 1-.319.3l-.017-.034zm-3.957 3.755l-.285-5.784a.6.6 0 0 0 .184-.067l2.18 4.275-1.274 2.414zm.067 1.425l-.067-1.341.788.8-.319.6c-.129-.007-.264-.044-.398-.061zm-.117.671l-.335-.52a1.812 1.812 0 0 1 .3 0zm.134-.5a2.153 2.153 0 0 1 .319.067l-.285.536zm1.274.369a2.114 2.114 0 0 0-.738-.4l.285-.536 1.392 1.442-.319.235a2.387 2.387 0 0 0-.616-.746zm-1.157.385l.352-.654a2.412 2.412 0 0 1 .7.386 2.645 2.645 0 0 1 .6.7l-.553.436zm1.174.939l-.034-.017.536-.4a2.3 2.3 0 0 1-.2 2.414l-.536-.419zm-4.493-8.7l1.492-.855a1.341 1.341 0 0 0 1.19.5l.268 5.583-3.516-3.64a1.629 1.629 0 0 0 .57-1.594zm-.084.067a1.56 1.56 0 0 1-.553 1.459l-.352-.369.453-.855zm-.788-1.174a1.849 1.849 0 0 1 .57.57 1.424 1.424 0 0 1 .184.436l-.453.251-.52-.872zm.017 2.5l.168.184c-.017.017-.034.017-.034.034zm3.085-4.359l-.034.453-.553.536.184.771-.352.2a1.59 1.59 0 0 1-.184-.419 1.258 1.258 0 0 1 .905-1.542zm5.08-.2l-2.146.872L112.1 457a.786.786 0 0 0 .4-.252zm5.08 5.75l.017.319a.7.7 0 0 1-.235-.151zm-.268.134a1.643 1.643 0 0 1-.352-.469 1.379 1.379 0 0 1-.1-.637l.352.05.352.838v.017zm-3.856 2.833l.034.1-1.509 1.157-1.459-2.867 1.157-2.179a.839.839 0 0 0 .637 0v.017l.067-.017v-.017a.807.807 0 0 0 .335-.335.877.877 0 0 0 .1-.268l3.973.486a1.358 1.358 0 0 0 .117.671 1.3 1.3 0 0 0 .352.486l-3.705 2.85-.017-.067zm4.493 9.908l-1.291.453-.017-.084-.034.017-.034-.05.05-.017-.034-.117-.067.017.034.084-.436-.855.034.034.1-.067-.034-.05c-.034.017-.067.05-.1.067l-1.425-2.8 1.107 1.14.017.084.034-.017zm1.14 2.682l.3-1.643-1.274-1.09-.369-12.356a1.3 1.3 0 0 0 .905-.034 1.387 1.387 0 0 0-1.09-2.548l-.034-.067-.05.017.034.084a1.243 1.243 0 0 0-.6.6l-2.783-2.749 1.425-1.744a.9.9 0 0 0 .352.084l.034.084.05-.017-.017-.05a1.017 1.017 0 0 0 .7-.285 1.068 1.068 0 0 0-1.509-1.509.875.875 0 0 0-.268.5l-6.32-2.8a.622.622 0 0 0 .067-.235.81.81 0 0 0-.671-.939.83.83 0 0 0-.453 1.576l-3.219 5.75a1.643 1.643 0 0 0-2.2 2.33 1.709 1.709 0 0 0 2.28.654l3.269 5.113a2.4 2.4 0 0 0-1.475.889 2.479 2.479 0 0 0 3.839 3.135l6.5 5.1-.3 1.609 1.274 1.09z",
    transform: "translate(-105.892 -455.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35800",
    "data-name": "Path 35800",
    className: "cls-3",
    d: "M200.5 591.767v-.067h.117v.067z",
    transform: "translate(-184.639 -568.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35801",
    "data-name": "Path 35801",
    className: "cls-3",
    d: "M199 591.717l.117-.017v.067a.285.285 0 0 0-.117.017z",
    transform: "translate(-183.39 -568.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35802",
    "data-name": "Path 35802",
    className: "cls-3",
    d: "M197.6 592.017a.286.286 0 0 1 .117-.017l.017.067-.117.017z",
    transform: "translate(-182.225 -569.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35803",
    "data-name": "Path 35803",
    className: "cls-3",
    d: "M192.134 594.017l-.034-.05c.034-.017.067-.05.1-.067l.034.05a.348.348 0 0 1-.1.067z",
    transform: "translate(-177.647 -570.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35804",
    "data-name": "Path 35804",
    className: "cls-3",
    d: "M206.317 592.6c.034.017.084.034.117.05l-.017.05c-.034-.017-.084-.034-.117-.05z",
    transform: "translate(-189.466 -569.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35805",
    "data-name": "Path 35805",
    className: "cls-3",
    d: "M194.7 592.65a.818.818 0 0 1 .117-.05l.017.05a.83.83 0 0 1-.117.05z",
    transform: "translate(-179.811 -569.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35806",
    "data-name": "Path 35806",
    className: "cls-3",
    d: "M187.85 597.934l-.05-.034c.017-.034.05-.067.067-.1l.05.034z",
    transform: "translate(-174.068 -573.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35807",
    "data-name": "Path 35807",
    className: "cls-3",
    d: "M203.417 591.9c.034 0 .084.017.117.017l-.017.05c-.034 0-.084-.017-.117-.017z",
    transform: "translate(-187.053 -569.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35808",
    "data-name": "Path 35808",
    className: "cls-3",
    d: "M204.817 592.1c.034.017.084.017.117.034l-.017.067-.117-.034z",
    transform: "translate(-188.218 -569.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35809",
    "data-name": "Path 35809",
    className: "cls-3",
    d: "M187.05 599.134l-.05-.034.067-.1.05.034a.35.35 0 0 0-.067.1z",
    transform: "translate(-173.402 -574.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35810",
    "data-name": "Path 35810",
    className: "cls-3",
    d: "M209.017 593.8a.977.977 0 0 1 .117.067l-.034.05a.352.352 0 0 1-.1-.067z",
    transform: "translate(-191.714 -570.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35811",
    "data-name": "Path 35811",
    className: "cls-3",
    d: "M207.634 593.1c.034.017.084.034.117.05l-.033.05a.824.824 0 0 0-.117-.05z",
    transform: "translate(-190.549 -570.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35812",
    "data-name": "Path 35812",
    className: "cls-3",
    d: "M210.234 594.6c.034.017.067.05.1.067l-.034.05c-.034-.017-.067-.05-.1-.067z",
    transform: "translate(-192.713 -571.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35813",
    "data-name": "Path 35813",
    className: "cls-3",
    d: "M212.4 596.45l.05-.05c.034.034.067.05.084.084l-.05.034c-.034 0-.05-.034-.084-.068z",
    transform: "translate(-194.544 -572.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35814",
    "data-name": "Path 35814",
    className: "cls-3",
    d: "M213.4 597.633l.05-.034c.034.034.05.067.084.1l-.05.034a.445.445 0 0 1-.084-.1z",
    transform: "translate(-195.376 -573.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35815",
    "data-name": "Path 35815",
    className: "cls-3",
    d: "M211.333 595.484l-.034-.034.034-.05.034.034a.233.233 0 0 0 .067.05l-.034.05c-.016-.017-.05-.034-.067-.05z",
    transform: "translate(-193.628 -571.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35816",
    "data-name": "Path 35816",
    className: "cls-3",
    d: "M214.3 598.834l.05-.034.067.1-.05.034a.351.351 0 0 1-.067-.1z",
    transform: "translate(-196.125 -574.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35817",
    "data-name": "Path 35817",
    className: "cls-3",
    d: "M193.334 593.4l-.034-.05a.816.816 0 0 1 .117-.05l.034.05z",
    transform: "translate(-178.646 -570.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35818",
    "data-name": "Path 35818",
    className: "cls-3",
    d: "M189.834 595.817l-.034-.034.084-.084.05.033z",
    transform: "translate(-175.733 -572.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35819",
    "data-name": "Path 35819",
    className: "cls-3",
    d: "M192.4 596.617l.067-.017.034.117-.067.017z",
    transform: "translate(-177.897 -572.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35820",
    "data-name": "Path 35820",
    className: "cls-3",
    d: "M169.3 520.417l.067-.017.034.117-.067.017z",
    transform: "translate(-158.67 -509.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35821",
    "data-name": "Path 35821",
    className: "cls-3",
    d: "M168.7 518.317l.05-.017.05.117-.067.017z",
    transform: "translate(-158.17 -507.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35822",
    "data-name": "Path 35822",
    className: "cls-3",
    d: "M168.4 517.217l.05-.017.034.117-.05.017z",
    transform: "translate(-157.921 -506.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35823",
    "data-name": "Path 35823",
    className: "cls-3",
    d: "M169 519.317l.067-.017.034.117-.067.017z",
    transform: "translate(-158.42 -508.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35824",
    "data-name": "Path 35824",
    className: "cls-3",
    d: "M192.7 597.617l.067-.017.033.117-.067.017z",
    transform: "translate(-178.147 -573.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35825",
    "data-name": "Path 35825",
    className: "cls-3",
    d: "M193.1 598.717l.05-.017.034.117-.05.017z",
    transform: "translate(-178.48 -574.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35826",
    "data-name": "Path 35826",
    className: "cls-3",
    d: "M191.1 592.317l.067-.017.034.118-.067.017z",
    transform: "translate(-176.815 -569.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35827",
    "data-name": "Path 35827",
    className: "cls-3",
    d: "M189.9 588.117l.05-.017.034.117-.05.017z",
    transform: "translate(-175.816 -565.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35828",
    "data-name": "Path 35828",
    className: "cls-3",
    d: "M189.5 587.034l.067-.034.034.134-.067.017z",
    transform: "translate(-175.483 -564.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35829",
    "data-name": "Path 35829",
    className: "cls-3",
    d: "M189.2 586.017l.067-.017.034.117-.067.017z",
    transform: "translate(-175.233 -564.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35830",
    "data-name": "Path 35830",
    className: "cls-3",
    d: "M191.884 594.617l-.05.017-.034-.117.05-.017z",
    transform: "translate(-177.397 -571.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35831",
    "data-name": "Path 35831",
    className: "cls-3",
    d: "M190.2 589.217l.05-.017.034.117-.05.017z",
    transform: "translate(-176.066 -566.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35832",
    "data-name": "Path 35832",
    className: "cls-3",
    d: "M192.2 595.617l-.067.017-.034-.117.05-.017z",
    transform: "translate(-177.647 -572.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35833",
    "data-name": "Path 35833",
    className: "cls-3",
    d: "M191.4 593.417l.067-.017.034.117-.05.017z",
    transform: "translate(-177.065 -570.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35834",
    "data-name": "Path 35834",
    className: "cls-3",
    d: "M190.8 591.317l.067-.017.034.117-.067.017z",
    transform: "translate(-176.565 -568.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35835",
    "data-name": "Path 35835",
    className: "cls-3",
    d: "M190.5 590.217l.05-.017.05.117-.067.017z",
    transform: "translate(-176.315 -567.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35836",
    "data-name": "Path 35836",
    className: "cls-3",
    d: "M171.9 528.917l.05-.017.05.117-.067.017z",
    transform: "translate(-160.834 -516.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35837",
    "data-name": "Path 35837",
    className: "cls-3",
    d: "M182.5 563.817l.05-.017.034.117-.05.017z",
    transform: "translate(-169.657 -545.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35838",
    "data-name": "Path 35838",
    className: "cls-3",
    d: "M182.2 562.717l.05-.017.034.117-.05.017z",
    transform: "translate(-169.407 -544.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35839",
    "data-name": "Path 35839",
    className: "cls-3",
    d: "M181.8 561.717l.067-.017.034.117-.05.017z",
    transform: "translate(-169.074 -543.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35840",
    "data-name": "Path 35840",
    className: "cls-3",
    d: "M181.5 560.617l.067-.017.034.117-.067.017z",
    transform: "translate(-168.824 -542.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35841",
    "data-name": "Path 35841",
    className: "cls-3",
    d: "M183.4 566.917l.067-.017.034.134-.067.017z",
    transform: "translate(-170.406 -548.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35842",
    "data-name": "Path 35842",
    className: "cls-3",
    d: "M182.8 564.817l.05-.017.05.117-.067.017z",
    transform: "translate(-169.906 -546.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35843",
    "data-name": "Path 35843",
    className: "cls-3",
    d: "M183.1 565.917l.067-.017.034.117-.067.017z",
    transform: "translate(-170.156 -547.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35844",
    "data-name": "Path 35844",
    className: "cls-3",
    d: "M179.9 555.317l.067-.017.034.117-.067.017z",
    transform: "translate(-167.492 -538.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35845",
    "data-name": "Path 35845",
    className: "cls-3",
    d: "M179.6 554.317l.05-.017.034.117-.05.017z",
    transform: "translate(-167.243 -537.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35846",
    "data-name": "Path 35846",
    className: "cls-3",
    d: "M178.9 552.117l.067-.017.034.117-.05.017z",
    transform: "translate(-166.66 -535.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35847",
    "data-name": "Path 35847",
    className: "cls-3",
    d: "M183.8 568.017l.05-.017.034.117-.05.017z",
    transform: "translate(-170.739 -549.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35848",
    "data-name": "Path 35848",
    className: "cls-3",
    d: "M179.3 553.217l.05-.017.034.117-.05.017z",
    transform: "translate(-166.993 -536.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35849",
    "data-name": "Path 35849",
    className: "cls-3",
    d: "M180.9 558.517l.05-.017.034.117-.05.017z",
    transform: "translate(-168.325 -541.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35850",
    "data-name": "Path 35850",
    className: "cls-3",
    d: "M180.2 556.417l.067-.017.034.117-.067.017z",
    transform: "translate(-167.742 -539.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35851",
    "data-name": "Path 35851",
    className: "cls-3",
    d: "M180.6 557.417l.05-.017.034.117-.05.017z",
    transform: "translate(-168.075 -540.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35852",
    "data-name": "Path 35852",
    className: "cls-3",
    d: "M181.2 559.517l.05-.017.05.117-.067.017z",
    transform: "translate(-168.575 -542.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35853",
    "data-name": "Path 35853",
    className: "cls-3",
    d: "M187 578.617l.05-.017.034.117-.05.017z",
    transform: "translate(-173.402 -557.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35854",
    "data-name": "Path 35854",
    className: "cls-3",
    d: "M186.3 576.517l.067-.017.034.117-.067.017z",
    transform: "translate(-172.82 -556.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35855",
    "data-name": "Path 35855",
    className: "cls-3",
    d: "M187.3 579.617l.05-.017.05.117-.067.034z",
    transform: "translate(-173.652 -558.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35856",
    "data-name": "Path 35856",
    className: "cls-3",
    d: "M186.6 577.517l.067-.017.034.117-.05.017z",
    transform: "translate(-173.069 -557.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2209",
    "data-name": "Rectangle 2209",
    className: "cls-3",
    transform: "rotate(-17.446 75.379 -34.11)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35857",
    "data-name": "Path 35857",
    className: "cls-3",
    d: "M188.2 582.817l.067-.017.034.117-.05.017z",
    transform: "translate(-174.401 -561.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35858",
    "data-name": "Path 35858",
    className: "cls-3",
    d: "M187.9 581.817l.067-.017.034.117-.067.017z",
    transform: "translate(-174.151 -560.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35859",
    "data-name": "Path 35859",
    className: "cls-3",
    d: "M184.4 570.117l.067-.017.034.117-.067.017z",
    transform: "translate(-171.238 -550.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35860",
    "data-name": "Path 35860",
    className: "cls-3",
    d: "M184.7 571.217l.067-.017.034.117-.067.017z",
    transform: "translate(-171.488 -551.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35861",
    "data-name": "Path 35861",
    className: "cls-3",
    d: "M184.1 569.117l.05-.017.034.117-.05.017z",
    transform: "translate(-170.988 -550.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35862",
    "data-name": "Path 35862",
    className: "cls-3",
    d: "M185 572.217l.067-.017.034.117-.067.017z",
    transform: "translate(-171.738 -552.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35863",
    "data-name": "Path 35863",
    className: "cls-3",
    d: "M185.4 573.317l.05-.017.034.117-.05.017z",
    transform: "translate(-172.07 -553.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35864",
    "data-name": "Path 35864",
    className: "cls-3",
    d: "M186 575.417l.067-.017.034.117-.067.017z",
    transform: "translate(-172.57 -555.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35865",
    "data-name": "Path 35865",
    className: "cls-3",
    d: "M185.7 574.334l.05-.034.034.134-.05.017z",
    transform: "translate(-172.32 -554.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35866",
    "data-name": "Path 35866",
    className: "cls-3",
    d: "M173.5 534.134l.067-.034.034.134-.067.017z",
    transform: "translate(-162.166 -520.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35867",
    "data-name": "Path 35867",
    className: "cls-3",
    d: "M178 549.017l.05-.017.05.117-.067.017z",
    transform: "translate(-165.911 -533.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35868",
    "data-name": "Path 35868",
    className: "cls-3",
    d: "M177.7 547.917l.05-.017.034.117-.05.017z",
    transform: "translate(-165.661 -532.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35869",
    "data-name": "Path 35869",
    className: "cls-3",
    d: "M178.3 550.017l.067-.017.034.117-.067.017z",
    transform: "translate(-166.161 -534.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35870",
    "data-name": "Path 35870",
    className: "cls-3",
    d: "M178.6 551.117l.067-.017.034.117-.067.017z",
    transform: "translate(-166.41 -535.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35871",
    "data-name": "Path 35871",
    className: "cls-3",
    d: "M177.3 546.817l.067-.017.034.134-.05.017z",
    transform: "translate(-165.328 -531.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35872",
    "data-name": "Path 35872",
    className: "cls-3",
    d: "M174.5 537.317l.05-.017.034.117-.05.017z",
    transform: "translate(-162.998 -523.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35873",
    "data-name": "Path 35873",
    className: "cls-3",
    d: "M173.8 535.217l.067-.017.034.117-.067.017z",
    transform: "translate(-162.415 -521.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35874",
    "data-name": "Path 35874",
    className: "cls-3",
    d: "M174.8 538.417l.05-.017.034.117-.05.017z",
    transform: "translate(-163.248 -524.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35875",
    "data-name": "Path 35875",
    className: "cls-3",
    d: "M175.7 541.617l.067-.017.034.117-.05.017z",
    transform: "translate(-163.997 -527.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35876",
    "data-name": "Path 35876",
    className: "cls-3",
    d: "M175.4 540.517l.067-.017.034.117-.067.017z",
    transform: "translate(-163.747 -526.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35877",
    "data-name": "Path 35877",
    className: "cls-3",
    d: "M176.1 542.617l.05-.017.034.117-.05.017z",
    transform: "translate(-164.33 -527.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35878",
    "data-name": "Path 35878",
    className: "cls-3",
    d: "M176.4 543.717l.05-.017.034.117-.05.017z",
    transform: "translate(-164.579 -528.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35879",
    "data-name": "Path 35879",
    className: "cls-3",
    d: "M177 545.817l.067-.017.034.117-.067.017z",
    transform: "translate(-165.079 -530.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35880",
    "data-name": "Path 35880",
    className: "cls-3",
    d: "M176.7 544.717l.067-.017.034.117-.067.017z",
    transform: "translate(-164.829 -529.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35881",
    "data-name": "Path 35881",
    className: "cls-3",
    d: "M174.1 536.317l.067-.017.033.117-.05.017z",
    transform: "translate(-162.665 -522.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35882",
    "data-name": "Path 35882",
    className: "cls-3",
    d: "M170.6 524.617l.067-.017.034.117-.067.017z",
    transform: "translate(-159.752 -512.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35883",
    "data-name": "Path 35883",
    className: "cls-3",
    d: "M171.6 527.817l.05-.017.034.117-.05.017z",
    transform: "translate(-160.584 -515.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35884",
    "data-name": "Path 35884",
    className: "cls-3",
    d: "M171.3 526.717l.05-.017.034.117-.05.017z",
    transform: "translate(-160.334 -514.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35885",
    "data-name": "Path 35885",
    className: "cls-3",
    d: "M170.9 525.717l.067-.017.034.117-.067.017z",
    transform: "translate(-160.001 -513.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35886",
    "data-name": "Path 35886",
    className: "cls-3",
    d: "M170 522.517l.05-.017.034.117-.05.017z",
    transform: "translate(-159.252 -511.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35887",
    "data-name": "Path 35887",
    className: "cls-3",
    d: "M170.3 523.617l.05-.017.05.117-.067.017z",
    transform: "translate(-159.502 -512.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35888",
    "data-name": "Path 35888",
    className: "cls-3",
    d: "M172.5 531.017l.067-.017.034.117-.05.017z",
    transform: "translate(-161.333 -518.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35889",
    "data-name": "Path 35889",
    className: "cls-3",
    d: "M172.2 529.917l.067-.017.034.117-.067.017z",
    transform: "translate(-161.083 -517.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35890",
    "data-name": "Path 35890",
    className: "cls-3",
    d: "M169.6 521.517l.067-.017.034.117-.05.017z",
    transform: "translate(-158.919 -510.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35891",
    "data-name": "Path 35891",
    className: "cls-3",
    d: "M173.2 533.117l.05-.017.05.117-.067.017z",
    transform: "translate(-161.916 -520.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35892",
    "data-name": "Path 35892",
    className: "cls-3",
    d: "M172.9 532.017l.05-.017.034.117-.05.017z",
    transform: "translate(-161.666 -519.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35893",
    "data-name": "Path 35893",
    className: "cls-3",
    d: "M190.167 487.4l.034.117-.05.017-.05-.117z",
    transform: "translate(-175.982 -482.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35894",
    "data-name": "Path 35894",
    className: "cls-3",
    d: "M190.65 488.4l.05.117-.067.017-.034-.1z",
    transform: "translate(-176.399 -482.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35895",
    "data-name": "Path 35895",
    className: "cls-3",
    d: "M189.4 485.5l-.05.034-.05-.117.05-.017z",
    transform: "translate(-175.317 -480.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35896",
    "data-name": "Path 35896",
    className: "cls-3",
    d: "M199.6 509.834l.05-.034.05.117-.067.017z",
    transform: "translate(-183.89 -500.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2210",
    "data-name": "Rectangle 2210",
    className: "cls-3",
    transform: "rotate(-22.377 28.219 -34.526)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35897",
    "data-name": "Path 35897",
    className: "cls-3",
    d: "M195.7 500.717l.05-.017.05.1-.05.034z",
    transform: "translate(-180.644 -493.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35898",
    "data-name": "Path 35898",
    className: "cls-3",
    d: "M196.1 501.717l.067-.017.05.117-.067.017z",
    transform: "translate(-180.977 -493.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2211",
    "data-name": "Rectangle 2211",
    className: "cls-3",
    transform: "rotate(-22.377 25.377 -33.932)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35899",
    "data-name": "Path 35899",
    className: "cls-3",
    d: "M194.8 498.633l.067-.034.05.117-.067.017z",
    transform: "translate(-179.895 -491.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35900",
    "data-name": "Path 35900",
    className: "cls-3",
    d: "M195.3 499.634l.05-.034.05.117-.05.034z",
    transform: "translate(-180.311 -492.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2212",
    "data-name": "Rectangle 2212",
    className: "cls-3",
    transform: "rotate(-22.377 27.715 -34.437)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35901",
    "data-name": "Path 35901",
    className: "cls-3",
    d: "M197.8 505.817l.067-.017.05.1-.067.034z",
    transform: "translate(-182.392 -497.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35902",
    "data-name": "Path 35902",
    className: "cls-3",
    d: "M197.4 504.734l.05-.034.05.117-.05.034z",
    transform: "translate(-182.059 -496.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35903",
    "data-name": "Path 35903",
    className: "cls-3",
    d: "M200 510.834l.05-.033.05.117-.05.034z",
    transform: "translate(-184.223 -501.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35904",
    "data-name": "Path 35904",
    className: "cls-3",
    d: "M198.3 506.817l.05-.017.05.117-.05.017z",
    transform: "translate(-182.808 -498.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35905",
    "data-name": "Path 35905",
    className: "cls-3",
    d: "M194 496.617l.05-.017.05.117-.05.017z",
    transform: "translate(-179.229 -489.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2213",
    "data-name": "Rectangle 2213",
    className: "cls-3",
    transform: "rotate(-22.377 22.119 -33.261)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35906",
    "data-name": "Path 35906",
    className: "cls-3",
    d: "M191.8 491.517l.067-.017.05.117-.067.017z",
    transform: "translate(-177.397 -485.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35907",
    "data-name": "Path 35907",
    className: "cls-3",
    d: "M198.7 507.817l.05-.017.05.117-.05.017z",
    transform: "translate(-183.141 -499.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35908",
    "data-name": "Path 35908",
    className: "cls-3",
    d: "M191 489.434l.05-.034.05.117-.05.034z",
    transform: "translate(-176.732 -483.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35909",
    "data-name": "Path 35909",
    className: "cls-3",
    d: "M192.3 492.517l.05-.017.05.117-.05.017z",
    transform: "translate(-177.814 -486.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35910",
    "data-name": "Path 35910",
    className: "cls-3",
    d: "M193.6 495.617l.05-.017.05.1-.067.034z",
    transform: "translate(-178.896 -488.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2214",
    "data-name": "Rectangle 2214",
    className: "cls-3",
    transform: "rotate(-22.377 23.999 -33.643)",
    d: "M0 0h.067v.117H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35911",
    "data-name": "Path 35911",
    className: "cls-3",
    d: "M192.7 493.534l.05-.034.05.117-.05.017z",
    transform: "translate(-178.147 -487.103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4848",
    "data-name": "Group 4848",
    transform: "translate(1.549 6.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4843",
    "data-name": "Group 4843",
    transform: "translate(0 3.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35912",
    "data-name": "Path 35912",
    className: "cls-3",
    d: "M-5.1 453.922l.453 1.078 1.157.151.7-.922-.453-1.073L-4.4 453z",
    transform: "translate(5.664 -452.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35913",
    "data-name": "Path 35913",
    className: "cls-5",
    d: "M-5.769 449.631a1.625 1.625 0 0 0-2.263.3 1.61 1.61 0 0 0 .3 2.263 1.625 1.625 0 0 0 2.263-.3 1.623 1.623 0 0 0-.3-2.263zm.067-.084a1.714 1.714 0 0 1 .335 2.4 1.729 1.729 0 0 1-2.414.319 1.732 1.732 0 0 1-.335-2.414 1.742 1.742 0 0 1 2.416-.305z",
    transform: "translate(8.462 -449.194)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35914",
    "data-name": "Path 35914",
    className: "cls-3",
    d: "M2.7 462.95l7.058 16.35.134-.05-7.058-16.35z",
    transform: "translate(-.829 -457.045)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4844",
    "data-name": "Group 4844",
    transform: "translate(15.57 3.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35915",
    "data-name": "Path 35915",
    className: "cls-3",
    d: "M87.441 448.986l-.386-.486-.62.067-.235.587.386.5.62-.084z",
    transform: "translate(-85.9 -448.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35916",
    "data-name": "Path 35916",
    className: "cls-5",
    d: "M85 448.135a.858.858 0 0 0 1.123-.469.889.889 0 0 0-.469-1.14.844.844 0 0 0-1.123.469.891.891 0 0 0 .469 1.14zm-.017.05a.925.925 0 0 1 .7-1.71.925.925 0 0 1-.7 1.71z",
    transform: "translate(-84.41 -446.41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845",
    transform: "translate(8.288 21.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35917",
    "data-name": "Path 35917",
    className: "cls-3",
    d: "M44.041 559.67l-.285-.553-.637-.017-.319.537.3.553.62.017z",
    transform: "translate(-42.494 -558.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35918",
    "data-name": "Path 35918",
    className: "cls-5",
    d: "M41.45 558.54a.866.866 0 0 0 .905-1.475.855.855 0 0 0-1.19.285.87.87 0 0 0 .285 1.19zm-.034.05a.926.926 0 1 1 1.274-.3.925.925 0 0 1-1.274.3z",
    transform: "translate(-40.976 -556.876)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    "data-name": "Group 4846",
    transform: "translate(10.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35919",
    "data-name": "Path 35919",
    className: "cls-3",
    d: "M54.59 430.672l.034-.62-.5-.352-.57.268-.05.62.52.352z",
    transform: "translate(-53.144 -429.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35920",
    "data-name": "Path 35920",
    className: "cls-5",
    d: "M51.512 429.252a.871.871 0 0 0 1.157.419.85.85 0 0 0 .4-1.157.87.87 0 0 0-1.157-.419.884.884 0 0 0-.4 1.157zm-.05.034a.925.925 0 0 1 .436-1.224.945.945 0 0 1 1.241.436.925.925 0 0 1-.436 1.224.939.939 0 0 1-1.241-.436z",
    transform: "translate(-51.374 -427.974)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4847",
    "data-name": "Group 4847",
    transform: "translate(17.23 9.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35921",
    "data-name": "Path 35921",
    className: "cls-3",
    d: "M96.471 489l-.034-.419-.386-.184-.352.252.05.419.386.184z",
    transform: "translate(-95.467 -488.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35922",
    "data-name": "Path 35922",
    className: "cls-5",
    d: "M94.458 488.179a.574.574 0 0 0 .822.134.588.588 0 0 0 .134-.822.574.574 0 0 0-.821-.134.588.588 0 0 0-.135.822zm-.034.017a.626.626 0 1 1 .872.151.621.621 0 0 1-.872-.147z",
    transform: "translate(-94.308 -487.208)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35923",
    "data-name": "Path 35923",
    className: "cls-3",
    d: "M19.8 451.734v-.134l-13.7 1.375.017.134z",
    transform: "translate(-3.659 -447.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35924",
    "data-name": "Path 35924",
    className: "cls-3",
    d: "M20.541 464.564L5.017 459.3l-.017.05 15.525 5.264z",
    transform: "translate(-2.743 -454.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35925",
    "data-name": "Path 35925",
    className: "cls-3",
    d: "M91 453.333l1.14 6.1.151-.017-1.157-6.116z",
    transform: "translate(-74.325 -449.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35926",
    "data-name": "Path 35926",
    className: "cls-3",
    d: "M6.3 438.025l.084.168 8.282-4.325-.084-.168z",
    transform: "translate(-3.825 -432.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35927",
    "data-name": "Path 35927",
    className: "cls-3",
    d: "M58.2 433.968l5.013 2.632.1-.184-5.03-2.615z",
    transform: "translate(-47.024 -432.823)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4857",
    "data-name": "Group 4857",
    transform: "translate(14.954 25.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4849",
    "data-name": "Group 4849",
    transform: "translate(8.188 6.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35928",
    "data-name": "Path 35928",
    className: "cls-3",
    d: "M125.678 584.959l-.084-1.023-.939-.436-.855.587.1 1.039.939.436z",
    transform: "translate(-123.22 -582.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35929",
    "data-name": "Path 35929",
    className: "cls-5",
    d: "M120.685 582.8a1.433 1.433 0 0 0 2.347-1.643 1.433 1.433 0 0 0-2.347 1.643zm-.067.05a1.528 1.528 0 1 1 2.129.369 1.53 1.53 0 0 1-2.13-.372z",
    transform: "translate(-120.339 -580.439)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4850",
    "data-name": "Group 4850",
    transform: "translate(17.645 7.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35930",
    "data-name": "Path 35930",
    className: "cls-3",
    d: "M178.254 589.335l-.134-.285-.32-.05-.2.268.134.285.319.05z",
    transform: "translate(-177.457 -588.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35931",
    "data-name": "Path 35931",
    className: "cls-5",
    d: "M176.941 588.778a.432.432 0 0 0 .62-.084.443.443 0 1 0-.62.084zm0 .034a.48.48 0 1 1 .671-.1.482.482 0 0 1-.671.1z",
    transform: "translate(-176.748 -587.948)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35932",
    "data-name": "Path 35932",
    className: "cls-3",
    d: "M132.6 590.719l7.7-.251v-.068l-7.7.251z",
    transform: "translate(-122.356 -582.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35933",
    "data-name": "Path 35933",
    className: "cls-3",
    d: "M100.728 551.593L95.95 544.3h-.05l4.761 7.293z",
    transform: "translate(-91.809 -543.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35934",
    "data-name": "Path 35934",
    className: "cls-3",
    d: "M136.813 593.233l.034-.05-5.113-2.682-.034.05z",
    transform: "translate(-121.607 -582.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35935",
    "data-name": "Path 35935",
    className: "cls-3",
    d: "M130.19 597.313l.05-.017-1.174-5.1-.067.017z",
    transform: "translate(-119.36 -583.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35936",
    "data-name": "Path 35936",
    className: "cls-3",
    d: "M137.34 596.015l-3.923-5.314h-.017l3.923 5.331z",
    transform: "translate(-123.022 -582.551)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4851",
    "data-name": "Group 4851",
    transform: "translate(3.348 6.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35937",
    "data-name": "Path 35937",
    className: "cls-3",
    d: "M92.2 580.4l.1.235.251.05.168-.2-.084-.252-.268-.034z",
    transform: "translate(-92.077 -580.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35938",
    "data-name": "Path 35938",
    className: "cls-5",
    d: "M92.093 579.473a.387.387 0 0 0-.52.034.337.337 0 0 0 .05.5.357.357 0 1 0 .469-.537zm0-.017a.377.377 0 0 1 .05.537.393.393 0 0 1-.536.05.381.381 0 0 1 .486-.587z",
    transform: "translate(-91.467 -579.367)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4852",
    "data-name": "Group 4852",
    transform: "translate(2.189 8.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35939",
    "data-name": "Path 35939",
    className: "cls-3",
    d: "M85.6 594.385l.117.335.369.067.235-.268-.117-.352-.369-.067z",
    transform: "translate(-85.424 -593.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35940",
    "data-name": "Path 35940",
    className: "cls-5",
    d: "M85.416 593.112a.5.5 0 0 0-.7.05.5.5 0 1 0 .7-.05zm.017-.033a.536.536 0 1 1-.754.067.534.534 0 0 1 .754-.068z",
    transform: "translate(-84.553 -592.953)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4853",
    "data-name": "Group 4853",
    transform: "translate(3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35941",
    "data-name": "Path 35941",
    className: "cls-3",
    d: "M95 543.034l-.1.251.151.218.285-.034.1-.252-.15-.217z",
    transform: "translate(-94.781 -542.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35942",
    "data-name": "Path 35942",
    className: "cls-5",
    d: "M94.948 542.463a.38.38 0 1 0-.335.419.375.375 0 0 0 .335-.419zm.034-.017a.4.4 0 1 1-.436-.352.407.407 0 0 1 .436.352z",
    transform: "translate(-94.192 -542.092)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4854",
    "data-name": "Group 4854",
    transform: "translate(5.16 8.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35943",
    "data-name": "Path 35943",
    className: "cls-3",
    d: "M103.184 591.834l-.084.235.151.218.268-.05.1-.235-.168-.2z",
    transform: "translate(-102.961 -591.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35944",
    "data-name": "Path 35944",
    className: "cls-5",
    d: "M103.031 591.228a.356.356 0 1 0-.3.4.361.361 0 0 0 .3-.4zm.017 0a.389.389 0 1 1-.436-.335.394.394 0 0 1 .436.335z",
    transform: "translate(-102.272 -590.892)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4855",
    "data-name": "Group 4855",
    transform: "translate(3.758 3.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35945",
    "data-name": "Path 35945",
    className: "cls-3",
    d: "M94.534 564.05l-.034.184.117.117.184-.05.034-.185L94.7 564z",
    transform: "translate(-94.401 -563.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35946",
    "data-name": "Path 35946",
    className: "cls-5",
    d: "M94.413 563.686a.258.258 0 0 0-.319-.168.225.225 0 0 0-.151.3.247.247 0 0 0 .3.168.24.24 0 0 0 .17-.3zm.017 0a.265.265 0 1 1-.335-.168.256.256 0 0 1 .335.168z",
    transform: "translate(-93.912 -563.502)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4856",
    "data-name": "Group 4856",
    transform: "translate(0 5.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35947",
    "data-name": "Path 35947",
    className: "cls-3",
    d: "M72 577.818l.05.167.168.05.117-.134-.05-.168-.168-.033z",
    transform: "translate(-71.916 -577.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35948",
    "data-name": "Path 35948",
    className: "cls-5",
    d: "M71.917 577.181a.259.259 0 0 0-.352.017.244.244 0 0 0 .017.352.249.249 0 1 0 .335-.369zm.017-.017a.261.261 0 1 1-.369.017.264.264 0 0 1 .368-.017z",
    transform: "translate(-71.497 -577.097)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35949",
    "data-name": "Path 35949",
    className: "cls-3",
    d: "M94.6 581.7v.05l5.331.989.017-.067z",
    transform: "translate(-90.727 -575.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35950",
    "data-name": "Path 35950",
    className: "cls-3",
    d: "M95.6 565.117l5.013 3.906.017-.017-5.03-3.906z",
    transform: "translate(-91.559 -561.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35951",
    "data-name": "Path 35951",
    className: "cls-3",
    d: "M165.549 592.05l-.034-.05-2.615 2.33.034.034z",
    transform: "translate(-147.576 -583.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35952",
    "data-name": "Path 35952",
    className: "cls-3",
    d: "M93.25 568l.319-2.582-.05-.017-.319 2.582z",
    transform: "translate(-89.561 -561.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35953",
    "data-name": "Path 35953",
    className: "cls-3",
    d: "M108.454 586.484l-.017-.084-3.437 1.073.034.067z",
    transform: "translate(-99.383 -578.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35954",
    "data-name": "Path 35954",
    className: "cls-3",
    d: "M95.644 584.093l-1.677-1.693-.067.067 1.677 1.677z",
    transform: "translate(-90.144 -575.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35955",
    "data-name": "Path 35955",
    className: "cls-3",
    d: "M91.581 593.15v-.05l-2.481.57v.05z",
    transform: "translate(-86.149 -584.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35956",
    "data-name": "Path 35956",
    className: "cls-3",
    d: "M88.45 584.181l.754-2.364-.067-.017-.738 2.364z",
    transform: "translate(-85.566 -575.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35957",
    "data-name": "Path 35957",
    className: "cls-3",
    d: "M76.7 579.12v-.033l-3.3-.486v.034z",
    transform: "translate(-73.081 -572.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35958",
    "data-name": "Path 35958",
    className: "cls-3",
    d: "M75.3 581.666L72.817 579l-.017.017 2.481 2.665z",
    transform: "translate(-72.582 -572.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35959",
    "data-name": "Path 35959",
    className: "cls-3",
    d: "M95.617 548.7l.05-3.3h-.017l-.05 3.3z",
    transform: "translate(-91.559 -544.845)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4858",
    "data-name": "Group 4858",
    transform: "translate(32.944 21.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35960",
    "data-name": "Path 35960",
    className: "cls-3",
    d: "M201.684 535.634c-.017.033-.034.05-.05.084l-.034-.034c.017-.033.034-.05.05-.084z",
    transform: "translate(-197.778 -532.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35961",
    "data-name": "Path 35961",
    className: "cls-3",
    d: "M201.8 522.917l.034-.017c.017.034.034.05.05.084l-.034.017z",
    transform: "translate(-197.944 -521.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35962",
    "data-name": "Path 35962",
    className: "cls-3",
    d: "M201.1 521.933l.034-.034.05.084-.034.034a.143.143 0 0 0-.05-.084z",
    transform: "translate(-197.361 -521.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35963",
    "data-name": "Path 35963",
    className: "cls-3",
    d: "M200.4 521.034l.034-.034c.017.017.034.05.067.067l-.034.034z",
    transform: "translate(-196.779 -520.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35964",
    "data-name": "Path 35964",
    className: "cls-3",
    d: "M199.6 520.234l.05-.034.067.067-.034.034z",
    transform: "translate(-196.113 -519.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35965",
    "data-name": "Path 35965",
    className: "cls-3",
    d: "M202.333 523.917l-.034-.084.05-.034.034.1z",
    transform: "translate(-198.36 -522.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35966",
    "data-name": "Path 35966",
    className: "cls-3",
    d: "M201.084 536.717l-.05.084-.034-.034c.017-.017.034-.05.05-.067z",
    transform: "translate(-197.278 -533.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2215",
    "data-name": "Rectangle 2215",
    className: "cls-3",
    transform: "rotate(-81.871 1.203 -1.301)",
    d: "M0 0h.05v.101H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35967",
    "data-name": "Path 35967",
    className: "cls-3",
    d: "M198.8 519.534l.034-.034a.131.131 0 0 1 .067.067l-.034.033z",
    transform: "translate(-195.447 -519.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35968",
    "data-name": "Path 35968",
    className: "cls-3",
    d: "M193.8 517.15v-.05l.1.017-.017.05z",
    transform: "translate(-191.285 -517.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35969",
    "data-name": "Path 35969",
    className: "cls-3",
    d: "M195.9 517.75l.017-.05.084.034-.017.05a.283.283 0 0 1-.084-.034z",
    transform: "translate(-193.033 -517.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35970",
    "data-name": "Path 35970",
    className: "cls-3",
    d: "M194.9 517.45l.017-.05c.034.017.067.017.084.034l-.017.05c-.034-.017-.05-.034-.084-.034z",
    transform: "translate(-192.201 -517.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35971",
    "data-name": "Path 35971",
    className: "cls-3",
    d: "M196.9 518.25l.017-.05c.034.017.05.034.084.05l-.017.034c-.034 0-.051-.017-.084-.034z",
    transform: "translate(-193.865 -517.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35972",
    "data-name": "Path 35972",
    className: "cls-3",
    d: "M197.9 518.933l.017-.034c.034.017.05.034.084.05l-.034.034a.232.232 0 0 0-.067-.05z",
    transform: "translate(-194.698 -518.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35973",
    "data-name": "Path 35973",
    className: "cls-3",
    d: "M189.317 516.967l-.017-.05c.034 0 .067-.017.1-.017v.05a.182.182 0 0 0-.083.017z",
    transform: "translate(-187.54 -516.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35974",
    "data-name": "Path 35974",
    className: "cls-3",
    d: "M179.1 525.984a.182.182 0 0 0 .017-.084l.05.017-.017.084z",
    transform: "translate(-179.05 -524.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35975",
    "data-name": "Path 35975",
    className: "cls-3",
    d: "M178.9 527c0-.034.017-.067.017-.1l.05.017a.73.73 0 0 1-.017.084z",
    transform: "translate(-178.883 -525.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35976",
    "data-name": "Path 35976",
    className: "cls-3",
    d: "M180.3 522.884c.017-.034.034-.05.05-.084l.034.017c-.017.033-.034.05-.05.084z",
    transform: "translate(-180.048 -521.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35977",
    "data-name": "Path 35977",
    className: "cls-3",
    d: "M178.8 529.3v-.1h.05v.084z",
    transform: "translate(-178.8 -527.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35978",
    "data-name": "Path 35978",
    className: "cls-3",
    d: "M180.9 521.884c.017-.033.034-.05.05-.084l.034.033-.05.084z",
    transform: "translate(-180.548 -520.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35979",
    "data-name": "Path 35979",
    className: "cls-3",
    d: "M178.967 531.584l-.05.017a.213.213 0 0 1-.017-.1h.05a.126.126 0 0 1 .017.083z",
    transform: "translate(-178.883 -529.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35980",
    "data-name": "Path 35980",
    className: "cls-3",
    d: "M191.6 516.85v-.05h.1v.05z",
    transform: "translate(-189.454 -516.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35981",
    "data-name": "Path 35981",
    className: "cls-3",
    d: "M179.667 533.684l-.034.017-.034-.084.034-.017z",
    transform: "translate(-179.466 -530.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35982",
    "data-name": "Path 35982",
    className: "cls-3",
    d: "M179.184 532.684l-.05.017c-.017-.034-.017-.067-.034-.084l.05-.017z",
    transform: "translate(-179.05 -529.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35983",
    "data-name": "Path 35983",
    className: "cls-3",
    d: "M181.6 520.984l.067-.084.034.034-.067.084z",
    transform: "translate(-181.131 -520.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35984",
    "data-name": "Path 35984",
    className: "cls-3",
    d: "M178.85 530.4h-.034l-.017-.084.05-.017z",
    transform: "translate(-178.8 -528.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35985",
    "data-name": "Path 35985",
    className: "cls-3",
    d: "M200.3 537.434c-.017.017-.034.05-.067.067l-.034-.034c.017-.017.034-.05.067-.067z",
    transform: "translate(-196.612 -533.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35986",
    "data-name": "Path 35986",
    className: "cls-3",
    d: "M187.117 517.384l-.017-.05c.034-.017.067-.017.084-.034l.017.05c-.017.017-.051.017-.084.034z",
    transform: "translate(-185.708 -517.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35987",
    "data-name": "Path 35987",
    className: "cls-3",
    d: "M188.217 517.167l-.017-.05.1-.017v.05z",
    transform: "translate(-186.624 -517.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35988",
    "data-name": "Path 35988",
    className: "cls-3",
    d: "M190.5 516.85v-.05h.1v.05z",
    transform: "translate(-188.538 -516.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35989",
    "data-name": "Path 35989",
    className: "cls-3",
    d: "M185.1 518.25c.034-.017.05-.034.084-.05l.017.034c-.034.017-.05.034-.084.05z",
    transform: "translate(-184.044 -517.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35990",
    "data-name": "Path 35990",
    className: "cls-3",
    d: "M183.2 519.467l.067-.067.034.033a.233.233 0 0 0-.067.05z",
    transform: "translate(-182.462 -518.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35991",
    "data-name": "Path 35991",
    className: "cls-3",
    d: "M184.1 518.85a.363.363 0 0 1 .084-.05l.017.033-.084.05z",
    transform: "translate(-183.211 -518.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35992",
    "data-name": "Path 35992",
    className: "cls-3",
    d: "M182.4 520.167l.067-.067.034.034-.067.067z",
    transform: "translate(-181.796 -519.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35993",
    "data-name": "Path 35993",
    className: "cls-3",
    d: "M186.117 517.784l-.017-.033.084-.05.017.05z",
    transform: "translate(-184.876 -517.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35994",
    "data-name": "Path 35994",
    className: "cls-3",
    d: "M178.8 528.2v-.1h.05v.084z",
    transform: "translate(-178.8 -526.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35995",
    "data-name": "Path 35995",
    className: "cls-3",
    d: "M196.65 540.217l.034-.017.017.034-.034.017-.05.033-.017-.05z",
    transform: "translate(-193.616 -536.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35996",
    "data-name": "Path 35996",
    className: "cls-3",
    d: "M197.7 539.734c-.034.017-.05.033-.084.05l-.017-.033c.034-.017.05-.034.084-.05z",
    transform: "translate(-194.448 -535.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35997",
    "data-name": "Path 35997",
    className: "cls-3",
    d: "M195.684 540.7l.017.05-.084.034-.017-.05a.128.128 0 0 1 .084-.034z",
    transform: "translate(-192.783 -536.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35998",
    "data-name": "Path 35998",
    className: "cls-3",
    d: "M199.5 538.333l-.067.067-.034-.033c.017-.017.05-.034.067-.067z",
    transform: "translate(-195.946 -534.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35999",
    "data-name": "Path 35999",
    className: "cls-3",
    d: "M192.4 541.5v.05a.213.213 0 0 0-.1.017v-.05c.034 0 .067-.017.1-.017z",
    transform: "translate(-190.037 -537.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36000",
    "data-name": "Path 36000",
    className: "cls-3",
    d: "M194.584 541.1l.017.05c-.034.017-.067.017-.084.034l-.017-.05z",
    transform: "translate(-191.868 -537.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36001",
    "data-name": "Path 36001",
    className: "cls-3",
    d: "M202.634 533.7l.05.017c-.017.034-.017.05-.034.084l-.05-.017z",
    transform: "translate(-198.61 -530.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36002",
    "data-name": "Path 36002",
    className: "cls-3",
    d: "M203.367 527.184h-.05a.718.718 0 0 0-.017-.084h.05a.151.151 0 0 1 .017.084z",
    transform: "translate(-199.193 -525.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36003",
    "data-name": "Path 36003",
    className: "cls-3",
    d: "M191.3 541.6v.05h-.1v-.05z",
    transform: "translate(-189.121 -537.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36004",
    "data-name": "Path 36004",
    className: "cls-3",
    d: "M203.117 526.017c0-.034-.017-.067-.017-.1l.05-.017.017.084z",
    transform: "translate(-199.026 -524.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36005",
    "data-name": "Path 36005",
    className: "cls-3",
    d: "M193.5 541.3v.05l-.084.017-.017-.05z",
    transform: "translate(-190.952 -537.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36006",
    "data-name": "Path 36006",
    className: "cls-3",
    d: "M203.55 528.3h-.05v-.1h.05z",
    transform: "translate(-199.359 -526.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36007",
    "data-name": "Path 36007",
    className: "cls-3",
    d: "M203.55 529.4h-.05v-.1h.05a.107.107 0 0 1 0 .1z",
    transform: "translate(-199.359 -527.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36008",
    "data-name": "Path 36008",
    className: "cls-3",
    d: "M203.3 531.684a.727.727 0 0 1 .017-.084l.05.017c0 .033-.017.067-.017.1z",
    transform: "translate(-199.193 -529.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36009",
    "data-name": "Path 36009",
    className: "cls-3",
    d: "M203.5 530.584a.732.732 0 0 1 .017-.084h.05l-.017.1z",
    transform: "translate(-199.359 -528.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36010",
    "data-name": "Path 36010",
    className: "cls-3",
    d: "M190.1 541.6v.05h-.1v-.05z",
    transform: "translate(-188.122 -537.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36011",
    "data-name": "Path 36011",
    className: "cls-3",
    d: "M183 538.467l-.034.034c-.017-.017-.05-.034-.067-.067l.034-.034z",
    transform: "translate(-182.213 -534.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36012",
    "data-name": "Path 36012",
    className: "cls-3",
    d: "M181.4 536.784l-.034.033-.067-.084.034-.034c.034.035.051.068.067.085z",
    transform: "translate(-180.881 -533.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36013",
    "data-name": "Path 36013",
    className: "cls-3",
    d: "M182.2 537.667l-.034.034-.067-.067.034-.033c.017.032.051.049.067.066z",
    transform: "translate(-181.547 -534.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36014",
    "data-name": "Path 36014",
    className: "cls-3",
    d: "M183.9 539.25l-.017.034-.084-.05.034-.034c.017 0 .034.017.067.05z",
    transform: "translate(-182.962 -535.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36015",
    "data-name": "Path 36015",
    className: "cls-3",
    d: "M180.884 535.884l-.034.033c-.017-.033-.034-.05-.05-.084l.034-.034c.016.034.016.068.05.085z",
    transform: "translate(-180.465 -532.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36016",
    "data-name": "Path 36016",
    className: "cls-3",
    d: "M198.517 539.034l-.084.05-.034-.033c.017-.017.05-.034.067-.05z",
    transform: "translate(-195.114 -535.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36017",
    "data-name": "Path 36017",
    className: "cls-3",
    d: "M184.9 539.75l-.017.033c-.034-.017-.05-.033-.084-.05l.017-.034z",
    transform: "translate(-183.794 -535.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36018",
    "data-name": "Path 36018",
    className: "cls-3",
    d: "M180 534.617l.034-.017.017.05.05.084-.034.017c-.017-.034-.034-.05-.05-.084a.062.062 0 0 0-.017-.05z",
    transform: "translate(-179.799 -531.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36019",
    "data-name": "Path 36019",
    className: "cls-3",
    d: "M185.817 540.333l-.034.05-.084-.034.017-.05z",
    transform: "translate(-184.543 -536.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36020",
    "data-name": "Path 36020",
    className: "cls-3",
    d: "M179.484 524.817l-.034.084-.05-.017c.017-.034.017-.067.034-.084z",
    transform: "translate(-179.299 -523.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36021",
    "data-name": "Path 36021",
    className: "cls-3",
    d: "M179.884 523.817c-.017.034-.034.05-.034.084l-.05-.017.034-.084z",
    transform: "translate(-179.632 -522.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36022",
    "data-name": "Path 36022",
    className: "cls-3",
    d: "M189.017 541.417l-.017.05c-.034 0-.067-.017-.1-.017l.017-.05a.212.212 0 0 1 .1.017z",
    transform: "translate(-187.207 -537.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36023",
    "data-name": "Path 36023",
    className: "cls-3",
    d: "M187.817 541.217l-.017.05-.1-.017.017-.05c.05 0 .083 0 .1.017z",
    transform: "translate(-186.208 -537.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36024",
    "data-name": "Path 36024",
    className: "cls-3",
    d: "M186.9 540.734l-.017.05c-.034-.017-.05-.017-.084-.034l.017-.05z",
    transform: "translate(-185.459 -536.693)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4864",
    "data-name": "Group 4864",
    transform: "translate(14.663 12.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4859",
    "data-name": "Group 4859",
    transform: "translate(10.843 .138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36025",
    "data-name": "Path 36025",
    className: "cls-3",
    d: "M136.352 468.205l.419-.184.05-.453-.369-.268-.4.184-.05.453z",
    transform: "translate(-135.738 -467.075)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36026",
    "data-name": "Path 36026",
    className: "cls-5",
    d: "M134.6 466.267a.624.624 0 1 0 .872-.134.618.618 0 0 0-.872.134zm-.034-.034a.654.654 0 0 1 .939-.134.671.671 0 0 1 .151.939.654.654 0 0 1-.939.134.671.671 0 0 1-.152-.939z",
    transform: "translate(-134.437 -465.958)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4860",
    "data-name": "Group 4860",
    transform: "translate(14.915 1.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36027",
    "data-name": "Path 36027",
    className: "cls-3",
    d: "M161.32 476.257l.57-.252.067-.62-.5-.386-.587.252-.067.637z",
    transform: "translate(-160.452 -474.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36028",
    "data-name": "Path 36028",
    className: "cls-5",
    d: "M158.955 473.64a.875.875 0 1 0 1.224-.184.88.88 0 0 0-1.224.184zm-.05-.034a.936.936 0 1 1 .2 1.308.936.936 0 0 1-.2-1.308z",
    transform: "translate(-158.725 -473.225)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4861",
    "data-name": "Group 4861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36029",
    "data-name": "Path 36029",
    className: "cls-3",
    d: "M71.384 467.271l.436.151.369-.3-.084-.453-.436-.168-.369.3z",
    transform: "translate(-71.042 -466.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36030",
    "data-name": "Path 36030",
    className: "cls-5",
    d: "M70.355 465.18a.647.647 0 0 0-.52.755.655.655 0 1 0 1.291-.218.7.7 0 0 0-.771-.537zm-.017-.033a.7.7 0 1 1-.57.8.715.715 0 0 1 .57-.801z",
    transform: "translate(-69.762 -465.135)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4862",
    "data-name": "Group 4862",
    transform: "translate(6.224 .166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36031",
    "data-name": "Path 36031",
    className: "cls-3",
    d: "M107.817 467.636l.3.034.2-.235-.117-.285-.3-.05-.2.251z",
    transform: "translate(-107.563 -466.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36032",
    "data-name": "Path 36032",
    className: "cls-5",
    d: "M107.172 466.188a.425.425 0 1 0 .553.235.427.427 0 0 0-.553-.235zm0-.033a.452.452 0 0 1 .587.251.438.438 0 0 1-.251.587.452.452 0 0 1-.587-.251.444.444 0 0 1 .251-.587z",
    transform: "translate(-106.884 -466.126)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4863",
    "data-name": "Group 4863",
    transform: "translate(10.624 6.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36033",
    "data-name": "Path 36033",
    className: "cls-3",
    d: "M134.351 504.9l.285-.1.05-.318-.251-.184-.285.1-.05.3z",
    transform: "translate(-133.938 -504.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36034",
    "data-name": "Path 36034",
    className: "cls-5",
    d: "M133.262 503.612a.429.429 0 1 0 .6-.067.428.428 0 0 0-.6.067zm-.034-.017a.469.469 0 0 1 .637-.067.453.453 0 0 1-.57.7.471.471 0 0 1-.067-.628z",
    transform: "translate(-133.133 -503.433)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36035",
    "data-name": "Path 36035",
    className: "cls-3",
    d: "M114.81 469.168l-4.51-.268v.1l4.493.268z",
    transform: "translate(-103.504 -468.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36036",
    "data-name": "Path 36036",
    className: "cls-3",
    d: "M143.008 472.039L138.817 471l-.017.1 4.191 1.039z",
    transform: "translate(-127.226 -470.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36037",
    "data-name": "Path 36037",
    className: "cls-3",
    d: "M136.186 471.1h-.05l-.436 5.734.05.017z",
    transform: "translate(-124.645 -470.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36038",
    "data-name": "Path 36038",
    className: "cls-3",
    d: "M140.792 479l-4.292 4.56.017.034 4.292-4.56z",
    transform: "translate(-125.311 -476.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36039",
    "data-name": "Path 36039",
    className: "cls-3",
    d: "M81.217 468.4l-5.717.268.017.05 5.7-.268z",
    transform: "translate(-74.538 -467.853)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4872",
    "data-name": "Group 4872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4865",
    "data-name": "Group 4865",
    transform: "translate(8.212 12.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36040",
    "data-name": "Path 36040",
    className: "cls-3",
    d: "M35.137 470.5l-.637.972.536 1.039 1.157.067.637-.989-.536-1.023z",
    transform: "translate(-33.961 -469.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36041",
    "data-name": "Path 36041",
    className: "cls-5",
    d: "M34.607 468.2a1.612 1.612 0 1 0-1.693 1.526 1.612 1.612 0 0 0 1.693-1.526zm.1 0a1.713 1.713 0 1 1-1.609-1.811 1.743 1.743 0 0 1 1.61 1.811z",
    transform: "translate(-31.285 -466.385)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866",
    transform: "translate(2.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36042",
    "data-name": "Path 36042",
    className: "cls-3",
    d: "M.952 392.3l-.352.52.268.57.62.034.352-.52-.268-.553z",
    transform: "translate(-.281 -391.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36043",
    "data-name": "Path 36043",
    className: "cls-5",
    d: "M.508 391.079a.875.875 0 0 0-.8-.922.863.863 0 0 0-.922.8.875.875 0 0 0 .8.922.863.863 0 0 0 .922-.8zm.05 0a.923.923 0 0 1-.989.855.948.948 0 0 1-.872-.989.9.9 0 0 1 .989-.855.945.945 0 0 1 .872.989z",
    transform: "translate(1.303 -390.087)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36044",
    "data-name": "Path 36044",
    className: "cls-3",
    d: "M-8.211 479.6l-9.489 14.988.117.084 9.489-15z",
    transform: "translate(17.7 -464.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36045",
    "data-name": "Path 36045",
    className: "cls-3",
    d: "M4.817 397.5l-.117.05 5.734 12.524.117-.05z",
    transform: "translate(-.945 -396.257)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4867",
    "data-name": "Group 4867",
    transform: "translate(18.44 25.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36046",
    "data-name": "Path 36046",
    className: "cls-3",
    d: "M95.123 542.656l.2-.587-.423-.469-.6.117-.2.6.419.469z",
    transform: "translate(-93.796 -541.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36047",
    "data-name": "Path 36047",
    className: "cls-5",
    d: "M92.358 540.7a.865.865 0 1 0 .671-1.023.862.862 0 0 0-.671 1.023zm-.05 0a.916.916 0 1 1 1.073.721.912.912 0 0 1-1.073-.721z",
    transform: "translate(-92.289 -539.589)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4868",
    "data-name": "Group 4868",
    transform: "translate(23.543 21.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36048",
    "data-name": "Path 36048",
    className: "cls-3",
    d: "M126.825 523.175l.285-.821-.587-.654-.855.185-.268.821.587.654z",
    transform: "translate(-124.952 -521.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36049",
    "data-name": "Path 36049",
    className: "cls-5",
    d: "M122.84 520.465a1.207 1.207 0 1 0 .939-1.425 1.214 1.214 0 0 0-.939 1.425zm-.084.017a1.286 1.286 0 1 1 1.526.989 1.294 1.294 0 0 1-1.526-.99z",
    transform: "translate(-122.727 -518.927)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4869",
    "data-name": "Group 4869",
    transform: "translate(17.851 18.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36050",
    "data-name": "Path 36050",
    className: "cls-3",
    d: "M91.636 505.041l.536-.3v-.641l-.536-.3-.536.3v.62z",
    transform: "translate(-90.71 -503.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36051",
    "data-name": "Path 36051",
    className: "cls-5",
    d: "M88.946 502.464a.871.871 0 1 0 1.509.872.871.871 0 0 0-1.509-.872zm-.05-.033a.92.92 0 1 1 .335 1.257.927.927 0 0 1-.331-1.257z",
    transform: "translate(-88.774 -501.974)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4870",
    "data-name": "Group 4870",
    transform: "translate(14.096 30.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36052",
    "data-name": "Path 36052",
    className: "cls-3",
    d: "M68.186 572.038l.319-.268-.067-.419-.4-.151-.335.285.084.419z",
    transform: "translate(-67.478 -570.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36053",
    "data-name": "Path 36053",
    className: "cls-5",
    d: "M66.447 570.4a.591.591 0 0 0 .352.755.577.577 0 0 0 .754-.352.589.589 0 0 0-1.107-.4zm-.034-.017a.628.628 0 0 1 .8-.369.626.626 0 0 1-.436 1.174.628.628 0 0 1-.363-.805z",
    transform: "translate(-66.376 -569.976)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    "data-name": "Group 4871",
    transform: "translate(24.571 31.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36054",
    "data-name": "Path 36054",
    className: "cls-3",
    d: "M130.787 579.521l.151-.4-.268-.319-.419.067-.151.386.268.335z",
    transform: "translate(-129.892 -578.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36055",
    "data-name": "Path 36055",
    className: "cls-5",
    d: "M128.9 578.087a.586.586 0 1 0 .486-.671.587.587 0 0 0-.486.671zm-.034 0a.639.639 0 0 1 .52-.721.649.649 0 0 1 .721.52.639.639 0 0 1-.52.721.607.607 0 0 1-.721-.52z",
    transform: "translate(-128.859 -577.36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36056",
    "data-name": "Path 36056",
    className: "cls-3",
    d: "M51.919 491.012l.1-.084L43.1 480.4l-.1.1z",
    transform: "translate(-32.824 -465.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36057",
    "data-name": "Path 36057",
    className: "cls-3",
    d: "M47.727 495.059L43.25 479.3l-.05.017 4.476 15.759z",
    transform: "translate(-32.99 -464.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2216",
    "data-name": "Rectangle 2216",
    className: "cls-3",
    transform: "rotate(-44.943 44.492 -2.622)",
    d: "M0 0h6.203v.134H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36058",
    "data-name": "Path 36058",
    className: "cls-3",
    d: "M43.584 480.4l-.084.168 8.265 4.409.1-.184z",
    transform: "translate(-33.24 -465.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36059",
    "data-name": "Path 36059",
    className: "cls-3",
    d: "M93.9 509.217l.671 5.616.2-.017-.687-5.616z",
    transform: "translate(-75.19 -489.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36060",
    "data-name": "Path 36060",
    className: "cls-3",
    d: "M95.65 508l-.05.134 5.5 2.582.067-.117z",
    transform: "translate(-76.605 -488.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36061",
    "data-name": "Path 36061",
    className: "cls-3",
    d: "M104.112 525.5l-4.912 3.353.084.117 4.912-3.353z",
    transform: "translate(-79.602 -502.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36062",
    "data-name": "Path 36062",
    className: "cls-3",
    d: "M98.85 546l-.05.034 5.516 5.75.034-.034z",
    transform: "translate(-79.269 -519.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36063",
    "data-name": "Path 36063",
    className: "cls-3",
    d: "M128.7 529.1l.771 8.634h.05l-.771-8.634z",
    transform: "translate(-104.156 -505.794)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4877",
    "data-name": "Group 4877",
    transform: "translate(8.198 2.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4873",
    "data-name": "Group 4873",
    transform: "translate(3.545 10.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36064",
    "data-name": "Path 36064",
    className: "cls-3",
    d: "M55.27 468.875l.721-.2.168-.738-.57-.536-.721.2-.168.738z",
    transform: "translate(-54.305 -467.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36065",
    "data-name": "Path 36065",
    className: "cls-5",
    d: "M52.688 465.527a1.08 1.08 0 1 0 1.492 0 1.042 1.042 0 0 0-1.492 0zm-.05-.05a1.133 1.133 0 0 1 1.593 0 1.115 1.115 0 0 1 .067 1.576 1.149 1.149 0 0 1-1.593.017 1.136 1.136 0 0 1-.067-1.593z",
    transform: "translate(-52.344 -465.15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4874",
    "data-name": "Group 4874",
    transform: "translate(7.438 14.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36066",
    "data-name": "Path 36066",
    className: "cls-3",
    d: "M78.137 492.94l.469-.352-.1-.57-.553-.218-.453.352.1.57z",
    transform: "translate(-77.175 -491.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36067",
    "data-name": "Path 36067",
    className: "cls-5",
    d: "M75.671 490.73a.824.824 0 1 0 1.056-.419.794.794 0 0 0-1.056.419zm-.05-.017a.845.845 0 0 1 1.123-.453.862.862 0 0 1 .5 1.107.85.85 0 0 1-1.123.453.868.868 0 0 1-.501-1.107z",
    transform: "translate(-75.564 -490.192)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36068",
    "data-name": "Path 36068",
    className: "cls-3",
    d: "M37.2 403.817l7.7 4.46.034-.134-7.7-4.443z",
    transform: "translate(-36.194 -403.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4875",
    "data-name": "Group 4875",
    transform: "translate(14.895 14.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36069",
    "data-name": "Path 36069",
    className: "cls-3",
    d: "M121.517 492.988l.453.117.319-.319-.134-.453-.436-.134-.319.335z",
    transform: "translate(-121.173 -491.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36070",
    "data-name": "Path 36070",
    className: "cls-5",
    d: "M120.541 490.862a.624.624 0 0 0-.436.788.625.625 0 1 0 1.207-.319.634.634 0 0 0-.771-.469zm0-.05a.7.7 0 0 1 .821.5.667.667 0 1 1-1.291.335.671.671 0 0 1 .47-.836z",
    transform: "translate(-120.046 -490.793)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36071",
    "data-name": "Path 36071",
    className: "cls-3",
    d: "M82.4 493.717l6.706.067v-.117L82.4 493.6z",
    transform: "translate(-73.816 -478.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36072",
    "data-name": "Path 36072",
    className: "cls-3",
    d: "M72.209 474.724l.017-.05-10.109-3.974-.017.05z",
    transform: "translate(-56.92 -459.467)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4876",
    "data-name": "Group 4876",
    transform: "translate(5.13 11.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36073",
    "data-name": "Path 36073",
    className: "cls-5",
    d: "M61.8 474.333l.034-.034.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.1.117l.034-.034.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.117.1l.034-.033.067.067-.034.034zm.1.117l.034-.034.067.067-.034.033zm.117.1l.034-.034.067.067-.034.033zm.1.117l.034-.034.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.1.1l.034-.034.067.067-.034.034zm.117.117l.034-.033.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.1.1l.034-.034.067.067-.034.034zm.117.117l.034-.034.067.067-.034.034zm.1.1l.034-.034.067.067-.034.033zm.117.117l.034-.034.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.1.1l.034-.034.067.067-.034.034zm.117.117l.034-.033.067.067-.034.034zm.1.1l.034-.033.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.117.117l.034-.034.067.067-.034.034zm.1.1l.034-.034.067.067-.034.033zm.117.1l.034-.034.084.067-.034.034zm.1.117l.034-.034.067.067-.034.034zm.117.1l.034-.034.067.067-.034.034zm.117.117l.034-.033.067.067-.034.034zm.1.1l.034-.034.067.067-.034.034z",
    transform: "translate(-61.8 -474.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36074",
    "data-name": "Path 36074",
    className: "cls-3",
    d: "M35.978 417.494l.117-.067-4.778-10.227-.117.05z",
    transform: "translate(-31.2 -406.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36075",
    "data-name": "Path 36075",
    className: "cls-3",
    d: "M58.934 441.183l4.309-5.549-.05-.034-4.293 5.549z",
    transform: "translate(-54.256 -430.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36076",
    "data-name": "Path 36076",
    className: "cls-3",
    d: "M101.11 443.26l.017-.034L96.5 433.1v.05z",
    transform: "translate(-85.552 -428.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_274",
    "data-name": "Line 274",
    className: "cls-3",
    transform: "translate(0 .637)",
    d: "M15.675 14.401L0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4881",
    "data-name": "Group 4881",
    transform: "translate(1.48 16.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4880",
    "data-name": "Group 4880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4879",
    "data-name": "Group 4879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36077",
    "data-name": "Path 36077",
    className: "cls-3",
    d: "M-6.614 491.3l-.386.486.218.587.62.117.386-.486-.218-.6z",
    transform: "translate(7.314 -490.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36078",
    "data-name": "Path 36078",
    className: "cls-5",
    d: "M-7.084 490.395a.9.9 0 0 0-.721-1.006.858.858 0 0 0-.989.721.9.9 0 0 0 .721 1.006.889.889 0 0 0 .989-.721zm.05.017a.926.926 0 0 1-1.056.771.942.942 0 0 1-.771-1.073.926.926 0 0 1 1.056-.771.933.933 0 0 1 .771 1.073z",
    transform: "translate(8.874 -489.326)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPlaceholder);
export default __webpack_public_path__ + "static/media/report_placeholder.207dfc8eb8ae0dea838a5c1e5a49f3e5.svg";
export { ForwardRef as ReactComponent };